[
  {
    "uri": "./GrafanaConfigDto.schema.json",
    "fileMatch": ["a://b/GrafanaConfigDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./GrafanaConfigDto.schema.json",
      "title": "GrafanaConfigDto",
      "type": "object",
      "properties": {
        "url": {
          "type": "string",
          "description": "Base URL of the Grafana instance",
          "example": "http://localhost:3001"
        },
        "tempoUid": {
          "type": "string",
          "description": "UID of the Tempo data source in Grafana",
          "example": "tempo"
        },
        "lokiUid": {
          "type": "string",
          "description": "UID of the Loki data source in Grafana",
          "example": "loki"
        }
      },
      "required": ["tempoUid", "lokiUid"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./FrontendConfigResponseDto.schema.json",
    "fileMatch": ["a://b/FrontendConfigResponseDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./FrontendConfigResponseDto.schema.json",
      "title": "FrontendConfigResponseDto",
      "type": "object",
      "properties": {
        "grafana": {
          "description": "Grafana observability configuration",
          "allOf": [
            {
              "$ref": "./GrafanaConfigDto.schema.json"
            }
          ]
        }
      },
      "required": ["grafana"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./RoleDto.schema.json",
    "fileMatch": ["a://b/RoleDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./RoleDto.schema.json",
      "title": "RoleDto",
      "type": "object",
      "properties": {
        "role": {
          "enum": [
            "presentation:manage",
            "presentation:request",
            "issuance:manage",
            "issuance:offer",
            "clients:manage",
            "users:manage",
            "tenants:manage",
            "registrar:manage"
          ],
          "type": "string",
          "description": "OAuth2 roles",
          "example": "issuance:manage"
        }
      },
      "required": ["role"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./ClientCredentialsDto.schema.json",
    "fileMatch": ["a://b/ClientCredentialsDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./ClientCredentialsDto.schema.json",
      "title": "ClientCredentialsDto",
      "type": "object",
      "properties": {
        "grant_type": {
          "type": "string",
          "minLength": 1
        },
        "client_id": {
          "type": "string",
          "minLength": 1
        },
        "client_secret": {
          "type": "string",
          "minLength": 1
        }
      },
      "required": ["client_id", "client_secret"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./TokenResponse.schema.json",
    "fileMatch": ["a://b/TokenResponse*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./TokenResponse.schema.json",
      "title": "TokenResponse",
      "type": "object",
      "properties": {
        "access_token": {
          "type": "string"
        },
        "refresh_token": {
          "type": "string"
        },
        "token_type": {
          "type": "string"
        },
        "expires_in": {
          "type": "number"
        },
        "state": {
          "type": "string"
        }
      },
      "required": ["access_token", "token_type", "expires_in", "state"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./TenantEntity.schema.json",
    "fileMatch": ["a://b/TenantEntity*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./TenantEntity.schema.json",
      "title": "TenantEntity",
      "type": "object",
      "properties": {
        "sessionConfig": {
          "nullable": true,
          "description": "Session storage configuration for this tenant. Controls TTL and cleanup behavior.",
          "type": "object",
          "allOf": [
            {
              "$ref": "./SessionStorageConfig.schema.json"
            }
          ]
        },
        "statusListConfig": {
          "nullable": true,
          "description": "Status list configuration for this tenant. Only affects newly created status lists.",
          "type": "object",
          "allOf": [
            {
              "$ref": "./StatusListConfig.schema.json"
            }
          ]
        },
        "id": {
          "type": "string",
          "description": "The unique identifier for the tenant."
        },
        "name": {
          "type": "string",
          "description": "The name of the tenant."
        },
        "description": {
          "type": "string",
          "description": "The description of the tenant."
        },
        "status": {
          "type": "string",
          "description": "The current status of the tenant."
        },
        "clients": {
          "description": "The clients associated with the tenant.",
          "type": "array",
          "items": {
            "$ref": "./ClientEntity.schema.json"
          }
        }
      },
      "required": ["id", "name", "status", "clients"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./ClientEntity.schema.json",
    "fileMatch": ["a://b/ClientEntity*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./ClientEntity.schema.json",
      "title": "ClientEntity",
      "type": "object",
      "properties": {
        "allowedPresentationConfigs": {
          "nullable": true,
          "description": "List of presentation config IDs this client can use. If empty/null, all configs are allowed.",
          "example": ["age-verification", "kyc-basic"],
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "allowedIssuanceConfigs": {
          "nullable": true,
          "description": "List of issuance config IDs this client can use. If empty/null, all configs are allowed.",
          "example": ["pid", "mdl"],
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "clientId": {
          "type": "string",
          "description": "The unique identifier for the client."
        },
        "secret": {
          "type": "string",
          "description": "The secret key for the client."
        },
        "tenantId": {
          "type": "string",
          "description": "The unique identifier for the tenant that the client belongs to. Only null for accounts that manage tenants, that do not belong to a client"
        },
        "description": {
          "type": "string",
          "description": "The description of the client."
        },
        "roles": {
          "description": "The roles assigned to the client.",
          "type": "array",
          "items": {
            "type": "string",
            "enum": [
              "presentation:manage",
              "presentation:request",
              "issuance:manage",
              "issuance:offer",
              "clients:manage",
              "users:manage",
              "tenants:manage",
              "registrar:manage"
            ]
          }
        },
        "tenant": {
          "description": "The tenant that the client belongs to.",
          "allOf": [
            {
              "$ref": "./TenantEntity.schema.json"
            }
          ]
        }
      },
      "required": ["clientId", "roles"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./AuditLogResponseDto.schema.json",
    "fileMatch": ["a://b/AuditLogResponseDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./AuditLogResponseDto.schema.json",
      "title": "AuditLogResponseDto",
      "type": "object",
      "properties": {
        "id": {
          "type": "string"
        },
        "tenantId": {
          "type": "string"
        },
        "actionType": {
          "enum": [
            "tenant_created",
            "tenant_updated",
            "tenant_deleted",
            "presentation_config_created",
            "presentation_config_updated",
            "presentation_config_deleted",
            "issuance_config_updated",
            "credential_config_created",
            "credential_config_updated",
            "credential_config_deleted",
            "status_list_config_updated",
            "status_list_config_reset",
            "webhook_endpoint_created",
            "webhook_endpoint_updated",
            "webhook_endpoint_deleted",
            "attribute_provider_created",
            "attribute_provider_updated",
            "attribute_provider_deleted"
          ],
          "type": "string"
        },
        "actorType": {
          "enum": ["user", "client", "system"],
          "type": "string"
        },
        "actorId": {
          "type": "string"
        },
        "actorDisplay": {
          "type": "string"
        },
        "changedFields": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "before": {
          "type": "object",
          "additionalProperties": true
        },
        "after": {
          "type": "object",
          "additionalProperties": true
        },
        "requestId": {
          "type": "string"
        },
        "timestamp": {
          "format": "date-time",
          "type": "string"
        }
      },
      "required": ["id", "tenantId", "actionType", "actorType", "timestamp"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./ClientSecretResponseDto.schema.json",
    "fileMatch": ["a://b/ClientSecretResponseDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./ClientSecretResponseDto.schema.json",
      "title": "ClientSecretResponseDto",
      "type": "object",
      "properties": {
        "secret": {
          "type": "string"
        }
      },
      "required": ["secret"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./StatusListAggregationDto.schema.json",
    "fileMatch": ["a://b/StatusListAggregationDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./StatusListAggregationDto.schema.json",
      "title": "StatusListAggregationDto",
      "type": "object",
      "properties": {
        "status_lists": {
          "description": "Array of status list token URIs",
          "example": [
            "https://example.com/tenant-123/status-management/status-list/list-1",
            "https://example.com/tenant-123/status-management/status-list/list-2"
          ],
          "type": "array",
          "items": {
            "type": "string"
          }
        }
      },
      "required": ["status_lists"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./StatusListResponseDto.schema.json",
    "fileMatch": ["a://b/StatusListResponseDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./StatusListResponseDto.schema.json",
      "title": "StatusListResponseDto",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "description": "Unique identifier for the status list",
          "example": "550e8400-e29b-41d4-a716-446655440000"
        },
        "tenantId": {
          "type": "string",
          "description": "The tenant ID",
          "example": "root"
        },
        "credentialConfigurationId": {
          "type": "string",
          "nullable": true,
          "description": "Credential configuration ID this list is bound to. Null means shared.",
          "example": "org.iso.18013.5.1.mDL"
        },
        "keyChainId": {
          "type": "string",
          "nullable": true,
          "description": "Key chain ID used for signing. Null means using the tenant's default.",
          "example": "my-status-list-keychain"
        },
        "bits": {
          "description": "Bits per status value",
          "enum": [1, 2, 4, 8],
          "type": "number",
          "example": 1
        },
        "capacity": {
          "type": "number",
          "description": "Total capacity of the status list",
          "example": 10000
        },
        "usedEntries": {
          "type": "number",
          "description": "Number of entries in use",
          "example": 150
        },
        "availableEntries": {
          "type": "number",
          "description": "Number of available entries",
          "example": 9850
        },
        "uri": {
          "type": "string",
          "description": "The public URI for this status list",
          "example": "https://example.com/demo/status-management/status-list/550e8400-e29b-41d4-a716-446655440000"
        },
        "createdAt": {
          "format": "date-time",
          "type": "string",
          "description": "Creation timestamp",
          "example": "2024-01-15T10:30:00.000Z"
        },
        "expiresAt": {
          "format": "date-time",
          "type": "string",
          "nullable": true,
          "description": "JWT expiration timestamp. Null if JWT has not been generated yet.",
          "example": "2024-01-15T11:30:00.000Z"
        }
      },
      "required": [
        "id",
        "tenantId",
        "bits",
        "capacity",
        "usedEntries",
        "availableEntries",
        "uri",
        "createdAt"
      ],
      "additionalProperties": false
    }
  },
  {
    "uri": "./AuthorizeQueries.schema.json",
    "fileMatch": ["a://b/AuthorizeQueries*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./AuthorizeQueries.schema.json",
      "title": "AuthorizeQueries",
      "type": "object",
      "properties": {
        "issuer_state": {
          "type": "string"
        },
        "response_type": {
          "type": "string"
        },
        "client_id": {
          "type": "string"
        },
        "redirect_uri": {
          "type": "string"
        },
        "resource": {
          "type": "string"
        },
        "scope": {
          "type": "string"
        },
        "code_challenge": {
          "type": "string"
        },
        "code_challenge_method": {
          "type": "string"
        },
        "dpop_jkt": {
          "type": "string"
        },
        "request_uri": {
          "type": "string"
        },
        "auth_session": {
          "type": "string"
        },
        "state": {
          "type": "string"
        },
        "authorization_details": {
          "anyOf": [
            {
              "type": "string"
            },
            {
              "type": "array",
              "items": {}
            }
          ],
          "description": "RFC 9396 authorization details. When passed via\napplication/x-www-form-urlencoded (PAR) the value is a JSON string; when\npassed inside a signed request object it can already be an array."
        }
      },
      "additionalProperties": false
    }
  },
  {
    "uri": "./OfferRequestDto.schema.json",
    "fileMatch": ["a://b/OfferRequestDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./OfferRequestDto.schema.json",
      "title": "OfferRequestDto",
      "type": "object",
      "properties": {
        "response_type": {
          "anyOf": [
            {
              "type": "string",
              "const": "uri"
            },
            {
              "type": "string",
              "const": "dc-api"
            },
            {
              "type": "string",
              "const": "iso-18013-7"
            }
          ],
          "enum": ["uri", "dc-api", "iso-18013-7"],
          "examples": [
            {
              "value": "qrcode"
            }
          ],
          "description": "The type of response expected for the offer request."
        },
        "authorization_server": {
          "type": "string",
          "description": "Authorization server id from issuer configuration. If omitted, the first enabled server is used.",
          "example": "issuer-built-in"
        },
        "credentialClaims": {
          "type": "object",
          "propertyNames": {
            "type": "string"
          },
          "additionalProperties": {
            "oneOf": [
              {
                "type": "object",
                "properties": {
                  "type": {
                    "type": "string",
                    "enum": ["inline"]
                  },
                  "claims": {
                    "type": "object",
                    "additionalProperties": true
                  }
                },
                "required": ["type", "claims"],
                "additionalProperties": false
              },
              {
                "type": "object",
                "properties": {
                  "type": {
                    "type": "string",
                    "enum": ["attributeProvider"]
                  },
                  "attributeProviderId": {
                    "type": "string"
                  }
                },
                "required": ["type", "attributeProviderId"],
                "additionalProperties": false
              },
              {
                "type": "object",
                "properties": {
                  "type": {
                    "type": "string",
                    "enum": ["webhook"]
                  },
                  "webhook": {
                    "type": "object",
                    "properties": {
                      "url": {
                        "type": "string"
                      },
                      "auth": {
                        "type": "object"
                      }
                    },
                    "required": ["url"],
                    "additionalProperties": false
                  }
                },
                "required": ["type", "webhook"],
                "additionalProperties": false
              }
            ]
          },
          "description": "Credential claims configuration per credential. Keys must match credentialConfigurationIds.",
          "example": {
            "citizen": {
              "type": "inline",
              "claims": {
                "given_name": "John",
                "family_name": "Doe"
              }
            }
          }
        },
        "flow": {
          "anyOf": [
            {
              "type": "string",
              "const": "authorization_code"
            },
            {
              "type": "string",
              "const": "pre_authorized_code"
            }
          ],
          "description": "The flow type for the offer request.",
          "enum": ["authorization_code", "pre_authorized_code"]
        },
        "tx_code": {
          "type": "string",
          "description": "Transaction code for pre-authorized code flow."
        },
        "tx_code_description": {
          "type": "string",
          "description": "Description for the transaction code (e.g., \"Please enter the PIN sent to your email\")."
        },
        "credentialConfigurationIds": {
          "items": {
            "type": "string"
          },
          "description": "List of credential configuration ids to be included in the offer.",
          "type": "array"
        },
        "webhookEndpointId": {
          "type": "string",
          "description": "ID of the webhook endpoint to notify about the status of the issuance process."
        }
      },
      "required": ["response_type", "flow", "credentialConfigurationIds"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./WebHookAuthConfigNone.schema.json",
    "fileMatch": ["a://b/WebHookAuthConfigNone*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./WebHookAuthConfigNone.schema.json",
      "title": "WebHookAuthConfigNone",
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "const": "none",
          "description": "The type of authentication used for the webhook.",
          "enum": []
        }
      },
      "required": ["type"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./ApiKeyConfig.schema.json",
    "fileMatch": ["a://b/ApiKeyConfig*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./ApiKeyConfig.schema.json",
      "title": "ApiKeyConfig",
      "type": "object",
      "properties": {
        "headerName": {
          "type": "string",
          "description": "The name of the header where the API key will be sent."
        },
        "value": {
          "type": "string",
          "description": "The value of the API key to be sent in the header."
        }
      },
      "required": ["headerName", "value"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./WebHookAuthConfigHeader.schema.json",
    "fileMatch": ["a://b/WebHookAuthConfigHeader*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./WebHookAuthConfigHeader.schema.json",
      "title": "WebHookAuthConfigHeader",
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "const": "apiKey",
          "description": "The type of authentication used for the webhook.",
          "enum": []
        },
        "config": {
          "properties": {
            "headerName": {
              "type": "string"
            },
            "value": {
              "type": "string"
            }
          },
          "additionalProperties": false,
          "description": "Configuration for API key authentication.\nThis is required if the type is 'apiKey'.",
          "allOf": [
            {
              "$ref": "./ApiKeyConfig.schema.json"
            }
          ]
        }
      },
      "required": ["type", "config"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./Session.schema.json",
    "fileMatch": ["a://b/Session*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./Session.schema.json",
      "title": "Session",
      "type": "object",
      "properties": {
        "status": {
          "description": "Status of the session.",
          "enum": ["active", "fetched", "completed", "expired", "failed"],
          "type": "string"
        },
        "id": {
          "type": "string",
          "description": "Unique identifier for the session."
        },
        "createdAt": {
          "format": "date-time",
          "type": "string",
          "description": "The timestamp when the request was created."
        },
        "updatedAt": {
          "format": "date-time",
          "type": "string",
          "description": "The timestamp when the request was last updated."
        },
        "expiresAt": {
          "format": "date-time",
          "type": "string",
          "description": "The timestamp when the request is set to expire."
        },
        "useDcApi": {
          "type": "boolean",
          "description": "Flag indicating whether to use the DC API for the presentation request."
        },
        "dcApiProtocol": {
          "type": "string",
          "description": "DC API sub-protocol: \"oid4vp\" (OpenID4VP via DC API) or \"iso-18013-7\" (org.iso.mdoc).\nNull/undefined means the standard OID4VP flow (useDcApi=false)."
        },
        "browserOrigin": {
          "type": "string",
          "description": "Browser page origin recorded at offer time for BrowserHandover session transcript.\nUsed exclusively by the ISO 18013-7 Annex C flow."
        },
        "tenantId": {
          "type": "string",
          "description": "Tenant ID for multi-tenancy support."
        },
        "tenant": {
          "description": "The tenant that owns this object.",
          "allOf": [
            {
              "$ref": "./TenantEntity.schema.json"
            }
          ]
        },
        "authorization_code": {
          "type": "string"
        },
        "refresh_token": {
          "type": "string",
          "description": "Refresh token for the session - used to obtain a new access token."
        },
        "refresh_token_expires_at": {
          "format": "date-time",
          "type": "string",
          "description": "Expiration timestamp for the refresh token.\nUsed to validate refresh_token grant requests."
        },
        "request_uri": {
          "type": "string",
          "description": "Request URI from the authorization request."
        },
        "auth_queries": {
          "description": "Authorization queries associated with the session.\nEncrypted at rest.",
          "allOf": [
            {
              "$ref": "./AuthorizeQueries.schema.json"
            }
          ]
        },
        "offer": {
          "nullable": true,
          "description": "Credential offer object containing details about the credential offer or presentation request.\nEncrypted at rest.",
          "type": "object"
        },
        "offerUrl": {
          "type": "string",
          "description": "Offer URL for the credential offer."
        },
        "credentialPayload": {
          "description": "Credential payload containing the offer request details.\nEncrypted at rest - may contain sensitive claim data.",
          "allOf": [
            {
              "$ref": "./OfferRequestDto.schema.json"
            }
          ]
        },
        "webhookEndpointId": {
          "type": "string",
          "description": "ID of the webhook endpoint to notify about issuance status."
        },
        "notifications": {
          "description": "Notifications associated with the session.",
          "type": "array",
          "items": {
            "type": "object"
          }
        },
        "requestId": {
          "type": "string"
        },
        "requestUrl": {
          "type": "string",
          "description": "The URL of the presentation auth request."
        },
        "requestObject": {
          "type": "string",
          "description": "Signed presentation auth request."
        },
        "responseEncryptionPrivateJwk": {
          "type": "object",
          "description": "Per-authorization-request private encryption key used to decrypt\nwallet responses. Encrypted at rest."
        },
        "credentials": {
          "description": "Verified credentials from the presentation process.\nEncrypted at rest - contains personal information.",
          "type": "array",
          "items": {
            "type": "object"
          }
        },
        "vp_nonce": {
          "type": "string",
          "description": "Nonce from the Verifiable Presentation request."
        },
        "clientId": {
          "type": "string",
          "description": "Client ID used in the OID4VP authorization request."
        },
        "walletNonce": {
          "type": "string",
          "description": "Cryptographic random nonce used in wallet-facing URLs (response_uri, request_uri, state).\nPer OID4VP spec Section 13.3, this separates the wallet-facing identifier (request-id)\nfrom the frontend-facing session ID (transaction-id) to prevent session fixation."
        },
        "responseCode": {
          "type": "string",
          "description": "Cryptographic random code generated after successful VP Token processing.\nPer OID4VP spec Section 13.3, included in redirect_uri so only the legitimate\nfrontend (which receives the redirect) can confirm the session completed."
        },
        "responseUri": {
          "type": "string",
          "description": "Response URI used in the OID4VP authorization request."
        },
        "redirectUri": {
          "type": "string",
          "nullable": true,
          "description": "Redirect URI to which the user-agent should be redirected after the presentation is completed."
        },
        "parsedWebhook": {
          "description": "Where to send the claims webhook response.",
          "allOf": [
            {
              "$ref": "./WebhookConfig.schema.json"
            }
          ]
        },
        "transaction_data": {
          "description": "Transaction data to include in the OID4VP authorization request.\nCan be overridden per-request from the presentation configuration.",
          "type": "array",
          "items": {
            "$ref": "./TransactionData.schema.json"
          }
        },
        "skewSeconds": {
          "type": "number",
          "description": "Per-session clock skew tolerance for presentation credential JWT time validation."
        },
        "externalIssuer": {
          "type": "string"
        },
        "externalSubject": {
          "type": "string",
          "description": "The subject (sub) from the external authorization server token.\nUsed to identify the user at the external AS."
        },
        "errorReason": {
          "type": "string",
          "description": "Error reason if the session failed.\nStores the error message when status is 'failed'."
        },
        "txCodeFailedAttempts": {
          "type": "number",
          "description": "Number of failed tx_code (transaction code) validation attempts.\nUsed to enforce brute-force protection in the pre-authorized code flow.\nReset implicitly when the session is consumed successfully."
        },
        "consumed": {
          "type": "boolean",
          "description": "Flag indicating whether the session offer has been consumed.\nPrevents replay attacks by ensuring each offer can only be used once.\nFor OID4VCI: set after successful token exchange.\nFor OID4VP: set after successful response validation."
        },
        "consumedAt": {
          "format": "date-time",
          "type": "string",
          "description": "Timestamp of the first consumption event for the session offer.\nFor OID4VCI this can be URI resolution or later flow completion.\nNull if no consumption event has happened yet."
        }
      },
      "required": [
        "status",
        "id",
        "createdAt",
        "updatedAt",
        "useDcApi",
        "tenantId",
        "tenant",
        "notifications",
        "txCodeFailedAttempts",
        "consumed"
      ],
      "additionalProperties": false
    }
  },
  {
    "uri": "./PaginatedSessionResponseDto.schema.json",
    "fileMatch": ["a://b/PaginatedSessionResponseDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./PaginatedSessionResponseDto.schema.json",
      "title": "PaginatedSessionResponseDto",
      "type": "object",
      "properties": {
        "items": {
          "description": "The sessions for the current page.",
          "type": "array",
          "items": {
            "$ref": "./Session.schema.json"
          }
        },
        "total": {
          "type": "number",
          "description": "Total number of sessions matching the query"
        },
        "page": {
          "type": "number",
          "description": "Current page number (1-based)"
        },
        "pageSize": {
          "type": "number",
          "description": "Number of items per page"
        },
        "totalPages": {
          "type": "number",
          "description": "Total number of pages"
        }
      },
      "required": ["items", "total", "page", "pageSize", "totalPages"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./SessionLogEntryResponseDto.schema.json",
    "fileMatch": ["a://b/SessionLogEntryResponseDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./SessionLogEntryResponseDto.schema.json",
      "title": "SessionLogEntryResponseDto",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "description": "Log entry ID"
        },
        "sessionId": {
          "type": "string",
          "description": "Session ID"
        },
        "timestamp": {
          "format": "date-time",
          "type": "string",
          "description": "Timestamp of the log entry"
        },
        "level": {
          "type": "string",
          "description": "Log level",
          "enum": ["info", "warn", "error"]
        },
        "stage": {
          "type": "string",
          "description": "Flow stage"
        },
        "message": {
          "type": "string",
          "description": "Log message"
        },
        "detail": {
          "type": "object",
          "additionalProperties": true,
          "description": "Additional structured detail"
        }
      },
      "required": ["id", "sessionId", "timestamp", "level", "message"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./StatusUpdateDto.schema.json",
    "fileMatch": ["a://b/StatusUpdateDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./StatusUpdateDto.schema.json",
      "title": "StatusUpdateDto",
      "type": "object",
      "properties": {
        "sessionId": {
          "type": "string",
          "minLength": 1,
          "description": "Session identifier used to locate credentials for status updates."
        },
        "credentialConfigurationId": {
          "type": "string",
          "description": "Optional credential configuration id. If omitted, all credentials linked to the session are updated.",
          "minLength": 1
        },
        "status": {
          "type": "integer",
          "minimum": 0,
          "maximum": 2,
          "description": "New credential status: 0 = valid, 1 = revoked, 2 = suspended."
        }
      },
      "required": ["sessionId", "status"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./UpdateSessionConfigDto.schema.json",
    "fileMatch": ["a://b/UpdateSessionConfigDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./UpdateSessionConfigDto.schema.json",
      "title": "UpdateSessionConfigDto",
      "type": "object",
      "properties": {
        "ttlSeconds": {
          "anyOf": [
            {
              "type": "integer",
              "minimum": 60,
              "maximum": 9007199254740991
            },
            {
              "type": "null"
            }
          ],
          "nullable": true,
          "description": "Time-to-live for sessions in seconds. Set to null to use global default.",
          "example": 86400,
          "minimum": 60
        },
        "cleanupMode": {
          "type": "string",
          "enum": ["full", "anonymize"],
          "description": "Cleanup mode: 'full' deletes everything, 'anonymize' keeps metadata but removes PII.",
          "default": "full"
        }
      },
      "additionalProperties": false
    }
  },
  {
    "uri": "./ManagedUserDto.schema.json",
    "fileMatch": ["a://b/ManagedUserDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./ManagedUserDto.schema.json",
      "title": "ManagedUserDto",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "example": "5a3412a4-9ccf-41aa-b79c-f7e2a8a9b0d1"
        },
        "username": {
          "type": "string",
          "example": "alice"
        },
        "email": {
          "type": "string",
          "example": "alice@example.com"
        },
        "enabled": {
          "type": "boolean",
          "example": true
        },
        "roles": {
          "type": "array",
          "items": {
            "type": "string",
            "enum": [
              "presentation:manage",
              "presentation:request",
              "issuance:manage",
              "issuance:offer",
              "clients:manage",
              "users:manage",
              "tenants:manage",
              "registrar:manage"
            ]
          }
        },
        "tenantId": {
          "type": "string",
          "example": "tenant-a"
        },
        "temporaryPassword": {
          "type": "string",
          "example": "Ab3!zK8pQ2",
          "description": "One-time temporary password returned only on user creation."
        }
      },
      "required": ["id", "username", "enabled", "roles"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./CreateUserDto.schema.json",
    "fileMatch": ["a://b/CreateUserDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./CreateUserDto.schema.json",
      "title": "CreateUserDto",
      "type": "object",
      "properties": {
        "username": {
          "type": "string",
          "minLength": 1
        },
        "email": {
          "type": "string",
          "format": "email",
          "pattern": "^(?!\\.)(?!.*\\.\\.)([A-Za-z0-9_'+\\-\\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\\-]*\\.)+[A-Za-z]{2,}$"
        },
        "roles": {
          "type": "array",
          "items": {
            "type": "string",
            "enum": [
              "tenants:manage",
              "issuance:offer",
              "issuance:manage",
              "presentation:request",
              "presentation:manage",
              "clients:manage",
              "users:manage",
              "registrar:manage"
            ]
          }
        },
        "enabled": {
          "type": "boolean"
        }
      },
      "required": ["username", "roles"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./UpdateUserDto.schema.json",
    "fileMatch": ["a://b/UpdateUserDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./UpdateUserDto.schema.json",
      "title": "UpdateUserDto",
      "type": "object",
      "properties": {
        "username": {
          "type": "string",
          "minLength": 1
        },
        "email": {
          "type": "string",
          "format": "email",
          "pattern": "^(?!\\.)(?!.*\\.\\.)([A-Za-z0-9_'+\\-\\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\\-]*\\.)+[A-Za-z]{2,}$"
        },
        "roles": {
          "type": "array",
          "items": {
            "type": "string",
            "enum": [
              "tenants:manage",
              "issuance:offer",
              "issuance:manage",
              "presentation:request",
              "presentation:manage",
              "clients:manage",
              "users:manage",
              "registrar:manage"
            ]
          }
        },
        "enabled": {
          "type": "boolean"
        },
        "password": {
          "type": "string",
          "minLength": 8
        }
      },
      "additionalProperties": false
    }
  },
  {
    "uri": "./AuthenticationMethodNone.schema.json",
    "fileMatch": ["a://b/AuthenticationMethodNone*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./AuthenticationMethodNone.schema.json",
      "title": "AuthenticationMethodNone",
      "type": "object",
      "properties": {
        "method": {
          "type": "string",
          "const": "none"
        }
      },
      "required": ["method"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./AuthenticationUrlConfig.schema.json",
    "fileMatch": ["a://b/AuthenticationUrlConfig*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./AuthenticationUrlConfig.schema.json",
      "title": "AuthenticationUrlConfig",
      "type": "object",
      "properties": {
        "url": {
          "type": "string",
          "description": "The URL used in the OID4VCI authorized code flow.\nThis URL is where users will be redirected for authentication."
        },
        "webhook": {
          "properties": {
            "url": {
              "type": "string"
            },
            "auth": {
              "oneOf": [
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "type": "string",
                      "const": "none"
                    }
                  },
                  "required": ["type"],
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "type": "string",
                      "const": "apiKey"
                    },
                    "config": {
                      "type": "object",
                      "properties": {
                        "headerName": {
                          "type": "string"
                        },
                        "value": {
                          "type": "string"
                        }
                      },
                      "required": ["headerName", "value"],
                      "additionalProperties": false
                    }
                  },
                  "required": ["type", "config"],
                  "additionalProperties": false
                }
              ]
            },
            "includeRawTokensFor": {
              "type": "array",
              "items": {
                "type": "string"
              }
            }
          },
          "additionalProperties": false,
          "description": "Optional webhook configuration for authentication callbacks",
          "allOf": [
            {
              "$ref": "./WebhookConfig.schema.json"
            }
          ]
        }
      },
      "required": ["url"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./AuthenticationMethodAuth.schema.json",
    "fileMatch": ["a://b/AuthenticationMethodAuth*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./AuthenticationMethodAuth.schema.json",
      "title": "AuthenticationMethodAuth",
      "type": "object",
      "properties": {
        "method": {
          "type": "string",
          "const": "auth"
        },
        "config": {
          "properties": {
            "url": {
              "type": "string"
            },
            "webhook": {
              "type": "object",
              "properties": {
                "url": {
                  "type": "string"
                },
                "auth": {
                  "oneOf": [
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "type": "string",
                          "const": "none"
                        }
                      },
                      "required": ["type"],
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "type": "string",
                          "const": "apiKey"
                        },
                        "config": {
                          "type": "object",
                          "properties": {
                            "headerName": {
                              "type": "string"
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "required": ["headerName", "value"],
                          "additionalProperties": false
                        }
                      },
                      "required": ["type", "config"],
                      "additionalProperties": false
                    }
                  ]
                },
                "includeRawTokensFor": {
                  "type": "array",
                  "items": {
                    "type": "string"
                  }
                }
              },
              "required": ["url", "auth"],
              "additionalProperties": false
            }
          },
          "additionalProperties": false,
          "allOf": [
            {
              "$ref": "./AuthenticationUrlConfig.schema.json"
            }
          ]
        }
      },
      "required": ["method", "config"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./PresentationDuringIssuanceConfig.schema.json",
    "fileMatch": ["a://b/PresentationDuringIssuanceConfig*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./PresentationDuringIssuanceConfig.schema.json",
      "title": "PresentationDuringIssuanceConfig",
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "description": "Link to the presentation configuration that is relevant for the issuance process"
        }
      },
      "required": ["type"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./AuthenticationMethodPresentation.schema.json",
    "fileMatch": ["a://b/AuthenticationMethodPresentation*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./AuthenticationMethodPresentation.schema.json",
      "title": "AuthenticationMethodPresentation",
      "type": "object",
      "properties": {
        "method": {
          "type": "string",
          "const": "presentationDuringIssuance"
        },
        "config": {
          "properties": {
            "type": {
              "type": "string"
            }
          },
          "additionalProperties": false,
          "allOf": [
            {
              "$ref": "./PresentationDuringIssuanceConfig.schema.json"
            }
          ]
        }
      },
      "required": ["method", "config"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./ManagedAuthorizationServerConfig.schema.json",
    "fileMatch": ["a://b/ManagedAuthorizationServerConfig*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./ManagedAuthorizationServerConfig.schema.json",
      "title": "ManagedAuthorizationServerConfig",
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": ["external", "oid4vp", "chained", "built-in"],
          "description": "Authorization server implementation type",
          "example": "external"
        },
        "id": {
          "type": "string",
          "description": "Unique identifier for this authorization server",
          "example": "pid-auth"
        },
        "label": {
          "type": "string",
          "description": "Human-friendly label for the UI",
          "example": "PID Authorization Server"
        },
        "enabled": {
          "type": "boolean",
          "description": "Whether this managed authorization server is enabled",
          "default": true
        }
      },
      "required": ["type", "id"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./ExternalAuthorizationServerConfig.schema.json",
    "fileMatch": ["a://b/ExternalAuthorizationServerConfig*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./ExternalAuthorizationServerConfig.schema.json",
      "title": "ExternalAuthorizationServerConfig",
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "const": "external",
          "description": "Authorization server implementation type",
          "enum": ["external"],
          "example": "external"
        },
        "id": {
          "type": "string",
          "description": "Unique identifier for this authorization server",
          "example": "external-auth"
        },
        "issuer": {
          "type": "string",
          "description": "Issuer URL for external authorization servers",
          "example": "https://auth.example.com"
        },
        "label": {
          "type": "string"
        },
        "enabled": {
          "type": "boolean"
        }
      },
      "required": ["type", "id", "issuer"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./ChainedAsTokenConfig.schema.json",
    "fileMatch": ["a://b/ChainedAsTokenConfig*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./ChainedAsTokenConfig.schema.json",
      "title": "ChainedAsTokenConfig",
      "type": "object",
      "properties": {
        "lifetimeSeconds": {
          "type": "number",
          "minimum": 60,
          "description": "Access token lifetime in seconds",
          "default": 3600
        },
        "signingKeyId": {
          "type": "string",
          "description": "Key ID for token signing"
        },
        "refreshTokenEnabled": {
          "type": "boolean",
          "description": "Whether refresh tokens should be issued",
          "default": true
        },
        "refreshTokenExpiresInSeconds": {
          "type": "number",
          "minimum": 60,
          "description": "Refresh token lifetime in seconds",
          "default": 2592000
        }
      },
      "additionalProperties": false
    }
  },
  {
    "uri": "./Oid4VpAuthorizationServerConfig.schema.json",
    "fileMatch": ["a://b/Oid4VpAuthorizationServerConfig*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./Oid4VpAuthorizationServerConfig.schema.json",
      "title": "Oid4VpAuthorizationServerConfig",
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "const": "oid4vp",
          "description": "Authorization server implementation type",
          "enum": ["oid4vp"],
          "example": "oid4vp"
        },
        "id": {
          "type": "string",
          "description": "Stable identifier used in the AS URL path",
          "example": "pid-auth"
        },
        "presentationConfigId": {
          "type": "string",
          "description": "Presentation configuration ID to use for OID4VP",
          "example": "playground-pid"
        },
        "immediateWalletRedirect": {
          "type": "boolean",
          "description": "Immediately redirect the browser into the wallet OID4VP request",
          "default": true
        },
        "token": {
          "properties": {
            "lifetimeSeconds": {
              "type": "number",
              "minimum": 60
            },
            "signingKeyId": {
              "type": "string"
            },
            "refreshTokenEnabled": {
              "type": "boolean"
            },
            "refreshTokenExpiresInSeconds": {
              "type": "number",
              "minimum": 60
            }
          },
          "additionalProperties": false,
          "description": "Token configuration for this authorization server",
          "allOf": [
            {
              "$ref": "./ChainedAsTokenConfig.schema.json"
            }
          ]
        },
        "requireDPoP": {
          "type": "boolean",
          "description": "Require DPoP for token requests issued by this authorization server",
          "default": false
        },
        "label": {
          "type": "string"
        },
        "enabled": {
          "type": "boolean"
        }
      },
      "required": ["type", "id", "presentationConfigId"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./UpstreamOidcConfig.schema.json",
    "fileMatch": ["a://b/UpstreamOidcConfig*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./UpstreamOidcConfig.schema.json",
      "title": "UpstreamOidcConfig",
      "type": "object",
      "properties": {
        "issuer": {
          "type": "string",
          "description": "The OIDC issuer URL of the upstream provider",
          "example": "https://auth.example.com/realms/myrealm"
        },
        "clientId": {
          "type": "string",
          "description": "The client ID registered with the upstream provider",
          "example": "eudiplo-chained-as"
        },
        "clientSecret": {
          "type": "string",
          "description": "The client secret for confidential clients"
        },
        "scopes": {
          "items": {
            "type": "string"
          },
          "description": "Scopes to request from the upstream provider",
          "default": ["openid", "profile"],
          "type": "array"
        }
      },
      "required": ["issuer", "clientId"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./ChainedAuthorizationServerConfig.schema.json",
    "fileMatch": ["a://b/ChainedAuthorizationServerConfig*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./ChainedAuthorizationServerConfig.schema.json",
      "title": "ChainedAuthorizationServerConfig",
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "const": "chained",
          "description": "Authorization server implementation type",
          "enum": ["chained"],
          "example": "chained"
        },
        "id": {
          "type": "string",
          "description": "Unique identifier for this authorization server",
          "example": "chained-auth"
        },
        "upstream": {
          "properties": {
            "issuer": {
              "type": "string"
            },
            "clientId": {
              "type": "string"
            },
            "clientSecret": {
              "type": "string"
            },
            "scopes": {
              "type": "array",
              "items": {
                "type": "string"
              }
            }
          },
          "additionalProperties": false,
          "description": "Upstream OIDC provider configuration for chained mode",
          "allOf": [
            {
              "$ref": "./UpstreamOidcConfig.schema.json"
            }
          ]
        },
        "token": {
          "properties": {
            "lifetimeSeconds": {
              "type": "number",
              "minimum": 60
            },
            "signingKeyId": {
              "type": "string"
            },
            "refreshTokenEnabled": {
              "type": "boolean"
            },
            "refreshTokenExpiresInSeconds": {
              "type": "number",
              "minimum": 60
            }
          },
          "additionalProperties": false,
          "description": "Token configuration for this authorization server",
          "allOf": [
            {
              "$ref": "./ChainedAsTokenConfig.schema.json"
            }
          ]
        },
        "requireDPoP": {
          "type": "boolean",
          "description": "Require DPoP for token requests issued by this authorization server",
          "default": false
        },
        "label": {
          "type": "string"
        },
        "enabled": {
          "type": "boolean"
        }
      },
      "required": ["type", "id", "upstream"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./BuiltInAuthorizationServerConfig.schema.json",
    "fileMatch": ["a://b/BuiltInAuthorizationServerConfig*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./BuiltInAuthorizationServerConfig.schema.json",
      "title": "BuiltInAuthorizationServerConfig",
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "const": "built-in",
          "description": "Authorization server implementation type",
          "enum": ["built-in"],
          "example": "built-in"
        },
        "id": {
          "type": "string",
          "description": "Unique identifier for this authorization server",
          "example": "issuer-built-in"
        },
        "token": {
          "properties": {
            "lifetimeSeconds": {
              "type": "number",
              "minimum": 60
            },
            "signingKeyId": {
              "type": "string"
            },
            "refreshTokenEnabled": {
              "type": "boolean"
            },
            "refreshTokenExpiresInSeconds": {
              "type": "number",
              "minimum": 60
            }
          },
          "additionalProperties": false,
          "description": "Token configuration for this authorization server",
          "allOf": [
            {
              "$ref": "./ChainedAsTokenConfig.schema.json"
            }
          ]
        },
        "requireDPoP": {
          "type": "boolean",
          "description": "Require DPoP for token requests issued by this authorization server",
          "default": false
        },
        "label": {
          "type": "string"
        },
        "enabled": {
          "type": "boolean"
        }
      },
      "required": ["type", "id"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./WalletProviderTrustListRefDto.schema.json",
    "fileMatch": ["a://b/WalletProviderTrustListRefDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./WalletProviderTrustListRefDto.schema.json",
      "title": "WalletProviderTrustListRefDto",
      "type": "object",
      "properties": {
        "url": {
          "type": "string",
          "format": "uri"
        },
        "verifierKey": {
          "type": "object",
          "additionalProperties": true,
          "description": "JWK used to verify the trust-list JWT signature."
        },
        "verifierX509Der": {
          "type": "string",
          "description": "Base64 DER-encoded X.509 certificate used to verify the trust-list JWT signature."
        }
      },
      "required": ["url"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./FederationTrustAnchorConfig.schema.json",
    "fileMatch": ["a://b/FederationTrustAnchorConfig*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./FederationTrustAnchorConfig.schema.json",
      "title": "FederationTrustAnchorConfig",
      "type": "object",
      "properties": {
        "entityId": {
          "type": "string",
          "description": "Entity identifier (sub) of the federation trust anchor.",
          "example": "https://ta.example.org"
        },
        "entityConfigurationUri": {
          "type": "string",
          "description": "Federation endpoint URL for the trust anchor entity configuration.",
          "example": "https://ta.example.org/.well-known/openid-federation"
        }
      },
      "required": ["entityId", "entityConfigurationUri"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./FederationConfig.schema.json",
    "fileMatch": ["a://b/FederationConfig*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./FederationConfig.schema.json",
      "title": "FederationConfig",
      "type": "object",
      "properties": {
        "role": {
          "type": "string",
          "enum": ["trust_anchor", "intermediate", "leaf"],
          "description": "Role this tenant plays in the OpenID Federation topology.",
          "default": "leaf"
        },
        "mode": {
          "type": "string",
          "enum": ["federation-only", "hybrid"],
          "description": "Trust decision strategy when both LoTE trust lists and OpenID Federation are configured.",
          "default": "hybrid"
        },
        "entityId": {
          "type": "string",
          "description": "Entity identifier of this issuer/verifier in the federation.",
          "example": "https://issuer.example.org"
        },
        "enforceSigningPolicy": {
          "type": "boolean",
          "description": "Whether federation checks are enforced for upstream metadata and signer trust decisions.",
          "default": true
        },
        "cacheTtlSeconds": {
          "type": "number",
          "description": "Cache TTL in seconds for federation entity statements and trust chain results.",
          "default": 300
        },
        "trustAnchors": {
          "items": {
            "type": "object",
            "properties": {
              "entityId": {
                "type": "string"
              },
              "entityConfigurationUri": {
                "type": "string"
              }
            },
            "required": ["entityId", "entityConfigurationUri"],
            "additionalProperties": false
          },
          "description": "Configured federation trust anchors.",
          "type": "array"
        }
      },
      "required": ["trustAnchors"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./IssuerRegistrationCertificateConfig.schema.json",
    "fileMatch": ["a://b/IssuerRegistrationCertificateConfig*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./IssuerRegistrationCertificateConfig.schema.json",
      "title": "IssuerRegistrationCertificateConfig",
      "type": "object",
      "properties": {
        "enabled": {
          "type": "boolean",
          "description": "Enable inclusion of a registration certificate in credential issuer metadata.",
          "default": false
        },
        "mode": {
          "type": "string",
          "enum": ["import", "generate"],
          "description": "import: use an existing JWT, generate: create via registrar using attestation data derived from configured credential configurations.",
          "default": "generate"
        },
        "jwt": {
          "type": "string",
          "description": "Existing registration certificate JWT used when mode is import."
        },
        "privacyPolicy": {
          "type": "string",
          "description": "Privacy policy URL used when generating a registration certificate (optional if registrar defaults are configured).",
          "example": "https://issuer.example/privacy"
        },
        "supportUri": {
          "type": "string",
          "description": "Support URI used when generating a registration certificate (optional if registrar defaults are configured).",
          "example": "mailto:support@issuer.example"
        }
      },
      "additionalProperties": false
    }
  },
  {
    "uri": "./IssuerRegistrationCertificateCache.schema.json",
    "fileMatch": ["a://b/IssuerRegistrationCertificateCache*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./IssuerRegistrationCertificateCache.schema.json",
      "title": "IssuerRegistrationCertificateCache",
      "type": "object",
      "properties": {
        "jwt": {
          "type": "string",
          "description": "Cached registration certificate JWT generated by EUDIPLO.",
          "readOnly": true
        },
        "fingerprint": {
          "type": "string",
          "description": "Config fingerprint used to detect cache invalidation.",
          "readOnly": true
        },
        "issuedAt": {
          "type": "number",
          "description": "JWT iat claim, seconds since epoch.",
          "readOnly": true
        },
        "expiresAt": {
          "type": "number",
          "description": "JWT exp claim, seconds since epoch.",
          "readOnly": true
        }
      },
      "additionalProperties": false
    }
  },
  {
    "uri": "./DisplayLogo.schema.json",
    "fileMatch": ["a://b/DisplayLogo*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./DisplayLogo.schema.json",
      "title": "DisplayLogo",
      "type": "object",
      "properties": {
        "uri": {
          "type": "string"
        },
        "alt_text": {
          "type": "string"
        }
      },
      "required": ["uri"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./DisplayInfo.schema.json",
    "fileMatch": ["a://b/DisplayInfo*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./DisplayInfo.schema.json",
      "title": "DisplayInfo",
      "type": "object",
      "properties": {
        "name": {
          "type": "string"
        },
        "locale": {
          "type": "string"
        },
        "logo": {
          "properties": {
            "uri": {
              "type": "string"
            },
            "alt_text": {
              "type": "string"
            }
          },
          "additionalProperties": {},
          "allOf": [
            {
              "$ref": "./DisplayLogo.schema.json"
            }
          ]
        }
      },
      "additionalProperties": false
    }
  },
  {
    "uri": "./UpdateIssuanceDto.schema.json",
    "fileMatch": ["a://b/UpdateIssuanceDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./UpdateIssuanceDto.schema.json",
      "title": "UpdateIssuanceDto",
      "type": "object",
      "properties": {
        "walletProviderTrustLists": {
          "description": "Trust lists containing trusted wallet providers.\nEach entry MUST include either `verifierKey` or `verifierX509Der`.",
          "type": "array",
          "items": {
            "$ref": "./WalletProviderTrustListRefDto.schema.json"
          }
        },
        "signingKeyId": {
          "type": "string",
          "description": "Key ID for signing access tokens. If unset, the default signing key is used."
        },
        "authorizationServers": {
          "type": "array",
          "description": "Dedicated managed authorization servers hosted by this issuer. At least one entry is required.",
          "items": {
            "oneOf": [
              {
                "$ref": "./ExternalAuthorizationServerConfig.schema.json"
              },
              {
                "$ref": "./Oid4VpAuthorizationServerConfig.schema.json"
              },
              {
                "$ref": "./ChainedAuthorizationServerConfig.schema.json"
              },
              {
                "$ref": "./BuiltInAuthorizationServerConfig.schema.json"
              }
            ],
            "discriminator": {
              "propertyName": "type",
              "mapping": {
                "external": "./ExternalAuthorizationServerConfig.schema.json",
                "oid4vp": "./Oid4VpAuthorizationServerConfig.schema.json",
                "chained": "./ChainedAuthorizationServerConfig.schema.json",
                "built-in": "./BuiltInAuthorizationServerConfig.schema.json"
              }
            },
            "type": "object",
            "properties": {
              "type": {
                "type": "string",
                "enum": ["external", "oid4vp", "chained", "built-in"]
              }
            }
          }
        },
        "federation": {
          "nullable": true,
          "description": "Optional OpenID Federation configuration used for trust evaluation.\nWhen omitted, trust checks rely on existing LoTE trust-list behavior.",
          "type": "object",
          "allOf": [
            {
              "$ref": "./FederationConfig.schema.json"
            }
          ]
        },
        "registrationCertificate": {
          "nullable": true,
          "description": "Optional registration certificate configuration for issuer metadata (`issuer_info`).\nSupports importing an existing JWT or generating one via registrar.",
          "type": "object",
          "allOf": [
            {
              "$ref": "./IssuerRegistrationCertificateConfig.schema.json"
            }
          ]
        },
        "registrationCertificateCache": {
          "nullable": true,
          "description": "Server-managed cache for generated issuer registration certificates.",
          "readOnly": true,
          "type": "object",
          "allOf": [
            {
              "$ref": "./IssuerRegistrationCertificateCache.schema.json"
            }
          ]
        },
        "credentialResponseEncryption": {
          "type": "boolean",
          "description": "Whether `credential_response_encryption` should be advertised in the credential issuer metadata.",
          "default": false
        },
        "credentialRequestEncryption": {
          "type": "boolean",
          "description": "Whether `credential_request_encryption` should be advertised in the credential issuer metadata.",
          "default": false
        },
        "notificationEndpointEnabled": {
          "type": "boolean",
          "description": "Whether the issuer notification endpoint is enabled and advertised in metadata.",
          "default": true
        },
        "txCodeMaxAttempts": {
          "type": "number",
          "description": "Maximum failed tx_code attempts before the pre-authorized code is invalidated. Defaults to 5.",
          "default": 5,
          "nullable": true
        },
        "batchSize": {
          "type": "number",
          "description": "Value to determine the amount of credentials that are issued in a batch.\nDefault is 1."
        },
        "dPopRequired": {
          "type": "boolean",
          "description": "Indicates whether DPoP is required for the issuance process. Default value is true."
        },
        "walletAttestationRequired": {
          "type": "boolean",
          "description": "Indicates whether wallet attestation is required for the token endpoint.\nWhen enabled, wallets must provide OAuth-Client-Attestation headers.\nDefault value is false."
        },
        "display": {
          "type": "array",
          "items": {
            "$ref": "./DisplayInfo.schema.json"
          }
        }
      },
      "additionalProperties": false
    }
  },
  {
    "uri": "./ClaimsQuery.schema.json",
    "fileMatch": ["a://b/ClaimsQuery*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./ClaimsQuery.schema.json",
      "title": "ClaimsQuery",
      "type": "object",
      "properties": {
        "id": {
          "type": "string"
        },
        "path": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "values": {
          "type": "array",
          "items": {
            "type": "string"
          }
        }
      },
      "required": ["path"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./CredentialSetQuery.schema.json",
    "fileMatch": ["a://b/CredentialSetQuery*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./CredentialSetQuery.schema.json",
      "title": "CredentialSetQuery",
      "type": "object",
      "properties": {
        "options": {
          "type": "array",
          "items": {
            "type": "array",
            "items": {
              "type": "string"
            }
          }
        },
        "required": {
          "type": "boolean"
        }
      },
      "required": ["options"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./PolicyCredential.schema.json",
    "fileMatch": ["a://b/PolicyCredential*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./PolicyCredential.schema.json",
      "title": "PolicyCredential",
      "type": "object",
      "properties": {
        "claims": {
          "items": {},
          "type": "array"
        },
        "credentials": {
          "items": {},
          "type": "array"
        },
        "credential_sets": {
          "items": {},
          "type": "array"
        }
      },
      "required": ["credentials"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./AttestationBasedPolicy.schema.json",
    "fileMatch": ["a://b/AttestationBasedPolicy*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./AttestationBasedPolicy.schema.json",
      "title": "AttestationBasedPolicy",
      "type": "object",
      "properties": {
        "policy": {
          "type": "string",
          "const": "attestationBased"
        },
        "values": {
          "items": {
            "type": "object",
            "properties": {
              "claims": {
                "type": "array",
                "items": {}
              },
              "credentials": {
                "type": "array",
                "items": {}
              },
              "credential_sets": {
                "type": "array",
                "items": {}
              }
            },
            "required": ["credentials"],
            "additionalProperties": false
          },
          "type": "array"
        }
      },
      "required": ["policy", "values"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./NoneTrustPolicy.schema.json",
    "fileMatch": ["a://b/NoneTrustPolicy*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./NoneTrustPolicy.schema.json",
      "title": "NoneTrustPolicy",
      "type": "object",
      "properties": {
        "policy": {
          "type": "string"
        }
      },
      "required": ["policy"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./AllowListPolicy.schema.json",
    "fileMatch": ["a://b/AllowListPolicy*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./AllowListPolicy.schema.json",
      "title": "AllowListPolicy",
      "type": "object",
      "properties": {
        "policy": {
          "type": "string"
        },
        "values": {
          "type": "array",
          "items": {
            "type": "string"
          }
        }
      },
      "required": ["policy", "values"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./RootOfTrustPolicy.schema.json",
    "fileMatch": ["a://b/RootOfTrustPolicy*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./RootOfTrustPolicy.schema.json",
      "title": "RootOfTrustPolicy",
      "type": "object",
      "properties": {
        "policy": {
          "type": "string"
        },
        "values": {
          "type": "string"
        }
      },
      "required": ["policy", "values"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./IaeActionOpenid4vpPresentation.schema.json",
    "fileMatch": ["a://b/IaeActionOpenid4vpPresentation*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./IaeActionOpenid4vpPresentation.schema.json",
      "title": "IaeActionOpenid4vpPresentation",
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "const": "openid4vp_presentation",
          "enum": ["openid4vp_presentation"],
          "description": "Action type discriminator",
          "example": "openid4vp_presentation"
        },
        "presentationConfigId": {
          "type": "string",
          "description": "ID of the presentation configuration to use for this step",
          "example": "pid-presentation-config"
        },
        "label": {
          "type": "string"
        }
      },
      "required": ["type", "presentationConfigId"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./IaeActionRedirectToWeb.schema.json",
    "fileMatch": ["a://b/IaeActionRedirectToWeb*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./IaeActionRedirectToWeb.schema.json",
      "title": "IaeActionRedirectToWeb",
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "const": "redirect_to_web",
          "enum": ["redirect_to_web"],
          "description": "Action type discriminator",
          "example": "redirect_to_web"
        },
        "url": {
          "type": "string",
          "format": "uri",
          "description": "URL to redirect the user to for web-based interaction",
          "example": "https://example.com/verify?session={auth_session}"
        },
        "callbackUrl": {
          "type": "string",
          "format": "uri",
          "description": "URL where the external service should redirect back after completion. If not provided, the service must call back to the IAE endpoint.",
          "example": "https://issuer.example.com/{tenantId}/authorize/interactive/callback"
        },
        "description": {
          "type": "string",
          "description": "Description of what the user should do on the web page (for wallet display)",
          "example": "Please complete the identity verification form"
        },
        "label": {
          "type": "string"
        }
      },
      "required": ["type", "url"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./WebhookEndpointEntity.schema.json",
    "fileMatch": ["a://b/WebhookEndpointEntity*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./WebhookEndpointEntity.schema.json",
      "title": "WebhookEndpointEntity",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "description": "Unique identifier for the webhook endpoint"
        },
        "auth": {
          "oneOf": [
            {
              "$ref": "./WebHookAuthConfigNone.schema.json"
            },
            {
              "$ref": "./WebHookAuthConfigHeader.schema.json"
            }
          ]
        },
        "tenantId": {
          "type": "string"
        },
        "tenant": {
          "$ref": "./TenantEntity.schema.json"
        },
        "name": {
          "type": "string"
        },
        "description": {
          "type": "string",
          "nullable": true
        },
        "url": {
          "type": "string"
        }
      },
      "required": ["id", "auth", "tenantId", "tenant", "name", "url"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./SchemaUriEntry.schema.json",
    "fileMatch": ["a://b/SchemaUriEntry*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./SchemaUriEntry.schema.json",
      "title": "SchemaUriEntry",
      "type": "object",
      "properties": {
        "credentialConfigId": {
          "type": "string",
          "description": "Credential config ID to resolve and upload its schema content. When set, uri can be omitted and is resolved server-side.",
          "example": "pid_de_credential_config"
        },
        "format": {
          "type": "string",
          "description": "Attestation format this schema URI applies to (e.g. dc+sd-jwt, mso_mdoc)",
          "example": "dc+sd-jwt"
        },
        "uri": {
          "type": "string",
          "description": "URI pointing to the schema document for this format"
        },
        "meta": {
          "type": "object",
          "propertyNames": {
            "type": "string"
          },
          "additionalProperties": true,
          "description": "Schema-format specific metadata (for example { vct: 'urn:example:vct' } for dc+sd-jwt)."
        }
      },
      "additionalProperties": false
    }
  },
  {
    "uri": "./TrustAuthorityEntry.schema.json",
    "fileMatch": ["a://b/TrustAuthorityEntry*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./TrustAuthorityEntry.schema.json",
      "title": "TrustAuthorityEntry",
      "type": "object",
      "properties": {
        "trustListId": {
          "type": "string",
          "description": "Trust list ID to resolve from the database. When set, frameworkType, value, and verificationMethod are derived automatically."
        },
        "frameworkType": {
          "type": "string",
          "enum": ["aki", "etsi_tl", "openid_federation"],
          "description": "Trust framework type (ignored when trustListId is set)"
        },
        "value": {
          "type": "string",
          "description": "URI of the trust list or trust anchor (ignored when trustListId is set)"
        },
        "verificationMethod": {
          "anyOf": [
            {
              "type": "object",
              "propertyNames": {
                "type": "string"
              },
              "additionalProperties": {}
            },
            {
              "type": "string"
            }
          ],
          "description": "Optional verification material for external trusted authorities (for example a JWK). For internal trust-list URLs, EUDIPLO resolves verification material from the database.",
          "oneOf": [
            {
              "type": "object",
              "additionalProperties": true
            },
            {
              "type": "string",
              "description": "JSON string representing an object. Parsed server-side for form submissions."
            }
          ]
        }
      },
      "additionalProperties": false
    }
  },
  {
    "uri": "./SchemaMetaConfig.schema.json",
    "fileMatch": ["a://b/SchemaMetaConfig*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./SchemaMetaConfig.schema.json",
      "title": "SchemaMetaConfig",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "description": "Optional override for the schema ID (attestation identifier URI). When not set, derived from vct (dc+sd-jwt) or docType (mso_mdoc).",
          "example": "https://example.com/attestations/my-credential"
        },
        "name": {
          "type": "string",
          "description": "Human-readable name of the schema metadata entry. Required when publishing new schema metadata; optional when linking an existing schema metadata id to a credential config.",
          "example": "German PID"
        },
        "version": {
          "type": "string",
          "description": "Schema version in SemVer format",
          "example": "1.0.0"
        },
        "rulebookURI": {
          "type": "string",
          "description": "URI of the Attestation Rulebook. Required when publishing new schema metadata; optional when linking an existing schema metadata id to a credential config.",
          "example": "https://example.com/rulebooks/my-credential/1.0.0.md"
        },
        "attestationLoS": {
          "type": "string",
          "enum": [
            "iso_18045_high",
            "iso_18045_moderate",
            "iso_18045_enhanced-basic",
            "iso_18045_basic"
          ],
          "description": "Attestation Level of Security"
        },
        "bindingType": {
          "type": "string",
          "enum": ["claim", "key", "biometric", "none"],
          "description": "Cryptographic binding type"
        },
        "schemaURIs": {
          "items": {
            "type": "object",
            "properties": {
              "credentialConfigId": {
                "type": "string"
              },
              "format": {
                "type": "string"
              },
              "uri": {
                "type": "string"
              },
              "meta": {
                "type": "object",
                "propertyNames": {
                  "type": "string"
                },
                "additionalProperties": {}
              }
            },
            "additionalProperties": false
          },
          "description": "Schema URIs per attestation format. When omitted, the format is derived from the credential config format field.",
          "type": "array"
        },
        "trustedAuthorities": {
          "items": {
            "type": "object",
            "properties": {
              "trustListId": {
                "type": "string"
              },
              "frameworkType": {
                "type": "string",
                "enum": ["aki", "etsi_tl", "openid_federation"]
              },
              "value": {
                "type": "string"
              },
              "verificationMethod": {
                "anyOf": [
                  {
                    "type": "object",
                    "propertyNames": {
                      "type": "string"
                    },
                    "additionalProperties": {}
                  },
                  {
                    "type": "string"
                  }
                ]
              }
            },
            "additionalProperties": false
          },
          "description": "Trust authorities for this attestation schema",
          "type": "array"
        }
      },
      "additionalProperties": false
    }
  },
  {
    "uri": "./KeyAttestationsRequired.schema.json",
    "fileMatch": ["a://b/KeyAttestationsRequired*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./KeyAttestationsRequired.schema.json",
      "title": "KeyAttestationsRequired",
      "type": "object",
      "properties": {
        "key_storage": {
          "items": {
            "type": "string"
          },
          "description": "List of required key storage types (e.g., iso_18045_high, iso_18045_moderate)",
          "example": ["iso_18045_high", "iso_18045_moderate"],
          "type": "array"
        },
        "user_authentication": {
          "items": {
            "type": "string"
          },
          "description": "List of required user authentication types (e.g., iso_18045_high, iso_18045_moderate)",
          "example": ["iso_18045_high", "iso_18045_moderate"],
          "type": "array"
        }
      },
      "additionalProperties": false
    }
  },
  {
    "uri": "./DisplayImage.schema.json",
    "fileMatch": ["a://b/DisplayImage*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./DisplayImage.schema.json",
      "title": "DisplayImage",
      "type": "object",
      "properties": {
        "uri": {
          "type": "string"
        }
      },
      "required": ["uri"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./Display.schema.json",
    "fileMatch": ["a://b/Display*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./Display.schema.json",
      "title": "Display",
      "type": "object",
      "properties": {
        "name": {
          "type": "string"
        },
        "description": {
          "type": "string"
        },
        "locale": {
          "type": "string"
        },
        "background_color": {
          "type": "string"
        },
        "text_color": {
          "type": "string"
        },
        "background_image": {
          "$ref": "./DisplayImage.schema.json"
        },
        "logo": {
          "$ref": "./DisplayImage.schema.json"
        }
      },
      "required": ["name", "description", "locale"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./IssuerMetadataCredentialConfig.schema.json",
    "fileMatch": ["a://b/IssuerMetadataCredentialConfig*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./IssuerMetadataCredentialConfig.schema.json",
      "title": "IssuerMetadataCredentialConfig",
      "type": "object",
      "properties": {
        "keyAttestationsRequired": {
          "description": "Key attestation requirements for JWT proofs for this credential.\nWhen set, this is published in proof_types_supported.jwt.key_attestations_required\nfor this specific credential configuration.",
          "allOf": [
            {
              "$ref": "./KeyAttestationsRequired.schema.json"
            }
          ]
        },
        "proofTypesSupported": {
          "description": "Supported proof types for this credential configuration. Defaults to ['attestation', 'jwt'].",
          "type": "array",
          "items": {
            "type": "string",
            "enum": ["jwt", "attestation"]
          },
          "example": ["attestation", "jwt"]
        },
        "format": {
          "type": "string",
          "enum": ["mso_mdoc", "dc+sd-jwt"]
        },
        "display": {
          "type": "array",
          "items": {
            "$ref": "./Display.schema.json"
          }
        },
        "scope": {
          "type": "string"
        },
        "docType": {
          "type": "string",
          "description": "Document type for mDOC credentials (e.g., \"org.iso.18013.5.1.mDL\").\nOnly applicable when format is \"mso_mdoc\"."
        }
      },
      "required": ["format", "display"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./FieldDisplayDto.schema.json",
    "fileMatch": ["a://b/FieldDisplayDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./FieldDisplayDto.schema.json",
      "title": "FieldDisplayDto",
      "type": "object",
      "properties": {
        "name": {
          "type": "string",
          "description": "Display name",
          "example": "Given Name"
        },
        "description": {
          "type": "string",
          "description": "Optional display description",
          "example": "Primary first name"
        },
        "locale": {
          "type": "string"
        }
      },
      "required": ["name", "locale"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./ClaimFieldDefinitionDto.schema.json",
    "fileMatch": ["a://b/ClaimFieldDefinitionDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./ClaimFieldDefinitionDto.schema.json",
      "title": "ClaimFieldDefinitionDto",
      "type": "object",
      "properties": {
        "path": {
          "type": "array",
          "items": {
            "oneOf": [
              {
                "type": "string"
              },
              {
                "type": "number"
              },
              {
                "type": "null"
              }
            ]
          },
          "description": "Path to claim value. For nested child fields this can be relative to the parent path.",
          "example": ["address", "locality"]
        },
        "type": {
          "type": "string",
          "enum": ["string", "number", "integer", "boolean", "object", "array"],
          "description": "Claim value type"
        },
        "defaultValue": {
          "description": "Default value",
          "oneOf": [
            {
              "type": "string"
            },
            {
              "type": "number"
            },
            {
              "type": "boolean"
            },
            {
              "type": "object",
              "additionalProperties": true
            },
            {
              "type": "array",
              "items": {}
            },
            {
              "type": "null"
            }
          ]
        },
        "mandatory": {
          "type": "boolean",
          "description": "Whether claim is mandatory"
        },
        "disclosable": {
          "type": "boolean",
          "description": "Whether claim is disclosable in SD-JWT"
        },
        "namespace": {
          "type": "string",
          "description": "Namespace for mDOC field. Optional when the namespace is already present as the first path segment.",
          "example": "eu.europa.ec.eudi.pid.1"
        },
        "display": {
          "items": {
            "type": "object",
            "properties": {
              "locale": {
                "type": "string"
              },
              "name": {
                "type": "string"
              },
              "description": {
                "type": "string"
              }
            },
            "required": ["locale", "name"],
            "additionalProperties": false
          },
          "type": "array"
        },
        "constraints": {
          "type": "object",
          "propertyNames": {
            "type": "string"
          },
          "additionalProperties": true,
          "description": "Additional JSON schema constraints for this field"
        },
        "children": {
          "items": {
            "$ref": "./ClaimFieldDefinitionDto.schema.json"
          },
          "description": "Optional nested child fields. Child paths may be specified relative to the parent field path.",
          "type": "array"
        }
      },
      "required": ["path", "type"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./AttributeProviderEntity.schema.json",
    "fileMatch": ["a://b/AttributeProviderEntity*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./AttributeProviderEntity.schema.json",
      "title": "AttributeProviderEntity",
      "type": "object",
      "properties": {
        "auth": {
          "oneOf": [
            {
              "$ref": "./WebHookAuthConfigNone.schema.json"
            },
            {
              "$ref": "./WebHookAuthConfigHeader.schema.json"
            }
          ]
        },
        "id": {
          "type": "string"
        },
        "tenantId": {
          "type": "string"
        },
        "tenant": {
          "$ref": "./TenantEntity.schema.json"
        },
        "name": {
          "type": "string"
        },
        "description": {
          "type": "string",
          "nullable": true
        },
        "url": {
          "type": "string"
        }
      },
      "required": ["auth", "id", "tenantId", "tenant", "name", "url"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./KeyChainEntity.schema.json",
    "fileMatch": ["a://b/KeyChainEntity*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./KeyChainEntity.schema.json",
      "title": "KeyChainEntity",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "description": "Unique identifier for the key chain.\nThis is the ID referenced by other entities (e.g., issuance config's signingKeyId)."
        },
        "tenantId": {
          "type": "string",
          "description": "Tenant ID for the key chain."
        },
        "tenant": {
          "description": "The tenant that owns this key chain.",
          "allOf": [
            {
              "$ref": "./TenantEntity.schema.json"
            }
          ]
        },
        "description": {
          "type": "string",
          "description": "Human-readable description of the key chain."
        },
        "usageType": {
          "type": "string",
          "description": "The purpose/role of this key chain in the system.",
          "enum": ["access", "attestation", "trustList", "statusList", "encrypt"]
        },
        "usage": {
          "type": "string",
          "description": "The usage type of the keys (sign or encrypt).",
          "enum": ["sign", "encrypt"]
        },
        "kmsProvider": {
          "type": "string",
          "description": "The KMS provider used for this key chain.\nReferences a configured KMS provider name."
        },
        "externalKeyId": {
          "type": "string",
          "description": "External key identifier for cloud KMS providers.\nThis field stores the provider-specific key reference for the active signing key."
        },
        "rootExternalKeyId": {
          "type": "string",
          "description": "External key identifier for cloud KMS providers for the root CA key.\nUsed when rotating internal-chain key chains backed by external KMS."
        },
        "rootJwk": {
          "type": "object"
        },
        "rootCertificate": {
          "type": "string",
          "description": "Root CA certificate in PEM format.\nSelf-signed certificate for the root CA key."
        },
        "activeJwk": {
          "type": "object"
        },
        "activeCertificate": {
          "type": "string",
          "description": "Certificate for the active signing key in PEM format.\nEither CA-signed (if rootKey exists) or self-signed."
        },
        "rotationEnabled": {
          "type": "boolean"
        },
        "rotationIntervalDays": {
          "type": "number",
          "description": "Rotation interval in days. Key material will be rotated after this many days."
        },
        "certValidityDays": {
          "type": "number",
          "description": "Certificate validity in days when generating new certificates."
        },
        "lastRotatedAt": {
          "format": "date-time",
          "type": "string",
          "description": "Timestamp of when the key was last rotated."
        },
        "previousJwk": {
          "type": "object"
        },
        "previousCertificate": {
          "type": "string",
          "description": "Certificate for the previous signing key in PEM format."
        },
        "previousKeyExpiry": {
          "format": "date-time",
          "type": "string",
          "description": "Expiry date for the previous key.\nAfter this date, the previous key should be deleted."
        },
        "createdAt": {
          "format": "date-time",
          "type": "string"
        },
        "updatedAt": {
          "format": "date-time",
          "type": "string",
          "description": "The timestamp when the key chain was last updated."
        }
      },
      "required": [
        "id",
        "tenantId",
        "tenant",
        "usageType",
        "usage",
        "kmsProvider",
        "activeJwk",
        "activeCertificate",
        "rotationEnabled",
        "createdAt",
        "updatedAt"
      ],
      "additionalProperties": false
    }
  },
  {
    "uri": "./CredentialConfig.schema.json",
    "fileMatch": ["a://b/CredentialConfig*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./CredentialConfig.schema.json",
      "title": "CredentialConfig",
      "type": "object",
      "properties": {
        "vct": {
          "description": "VCT as a URI string (e.g., urn:eudi:pid:de:1) or as an object for EUDIPLO-hosted VCT",
          "anyOf": [
            {
              "type": "string",
              "description": "VCT URI string"
            },
            {
              "$ref": "./VCT.schema.json"
            },
            {
              "type": "null"
            }
          ]
        },
        "iaeActions": {
          "type": "array",
          "nullable": true,
          "description": "List of IAE actions to execute before credential issuance",
          "example": "",
          "items": {
            "oneOf": [
              {
                "$ref": "./IaeActionOpenid4vpPresentation.schema.json"
              },
              {
                "$ref": "./IaeActionRedirectToWeb.schema.json"
              }
            ]
          }
        },
        "schemaMeta": {
          "nullable": true,
          "description": "TS11 schema metadata configuration for EUDI Catalogue of Attestations.\n\nWhen present, EUDIPLO can generate a SchemaMeta object per the TS11 spec\nusing the GET /issuer/credentials/:id/schema-metadata endpoint.\n\n The underlying TS11 specification is not yet finalized.",
          "type": "object",
          "allOf": [
            {
              "$ref": "./SchemaMetaConfig.schema.json"
            }
          ]
        },
        "embeddedDisclosurePolicy": {
          "nullable": true,
          "description": "Embedded disclosure policy (discriminated union by `policy`).\nThe discriminator metadata is retained for OpenAPI schema generation.",
          "oneOf": [
            {
              "$ref": "./AttestationBasedPolicy.schema.json"
            },
            {
              "$ref": "./NoneTrustPolicy.schema.json"
            },
            {
              "$ref": "./AllowListPolicy.schema.json"
            },
            {
              "$ref": "./RootOfTrustPolicy.schema.json"
            }
          ],
          "allOf": [
            {
              "$ref": "./EmbeddedDisclosurePolicy.schema.json"
            }
          ]
        },
        "id": {
          "type": "string"
        },
        "description": {
          "type": "string",
          "nullable": true
        },
        "tenant": {
          "description": "The tenant that owns this object.",
          "allOf": [
            {
              "$ref": "./TenantEntity.schema.json"
            }
          ]
        },
        "config": {
          "$ref": "./IssuerMetadataCredentialConfig.schema.json"
        },
        "fields": {
          "type": "array",
          "items": {
            "$ref": "./ClaimFieldDefinitionDto.schema.json"
          }
        },
        "attributeProviderId": {
          "type": "string",
          "nullable": true,
          "description": "Reference to the attribute provider used for fetching claims.\nOptional: if set, claims will be fetched from this provider during issuance."
        },
        "attributeProvider": {
          "$ref": "./AttributeProviderEntity.schema.json"
        },
        "webhookEndpointId": {
          "type": "string",
          "nullable": true,
          "description": "Reference to the webhook endpoint used for notifications.\nOptional: if set, notifications will be sent to this endpoint."
        },
        "webhookEndpoint": {
          "$ref": "./WebhookEndpointEntity.schema.json"
        },
        "keyBinding": {
          "type": "boolean"
        },
        "keyChainId": {
          "type": "string",
          "description": "Reference to the key chain used for signing.\nOptional: if not specified, the default attestation key chain will be used."
        },
        "keyChain": {
          "$ref": "./KeyChainEntity.schema.json"
        },
        "statusManagement": {
          "type": "boolean"
        },
        "sdJwtTrustFormat": {
          "nullable": true,
          "description": "For SD-JWT credentials: determines whether to include certificate chain (x5c)\nor use federation-based trust (iss claim).\nDefault: \"x5c\" (federation must be explicitly selected)",
          "enum": ["x5c", "federation"],
          "type": "string"
        },
        "lifeTime": {
          "type": "number"
        }
      },
      "required": ["id", "tenant", "config", "fields"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./CredentialConfigUpdate.schema.json",
    "fileMatch": ["a://b/CredentialConfigUpdate*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./CredentialConfigUpdate.schema.json",
      "title": "CredentialConfigUpdate",
      "type": "object",
      "properties": {
        "vct": {
          "description": "VCT as a URI string (e.g., urn:eudi:pid:de:1) or as an object for EUDIPLO-hosted VCT",
          "anyOf": [
            {
              "type": "string",
              "description": "VCT URI string"
            },
            {
              "$ref": "./VCT.schema.json"
            },
            {
              "type": "null"
            }
          ]
        },
        "iaeActions": {
          "type": "array",
          "nullable": true,
          "description": "List of IAE actions to execute before credential issuance",
          "example": "",
          "items": {
            "oneOf": [
              {
                "$ref": "./IaeActionOpenid4vpPresentation.schema.json"
              },
              {
                "$ref": "./IaeActionRedirectToWeb.schema.json"
              }
            ]
          }
        },
        "schemaMeta": {
          "nullable": true,
          "description": "TS11 schema metadata configuration for EUDI Catalogue of Attestations.\n\nWhen present, EUDIPLO can generate a SchemaMeta object per the TS11 spec\nusing the GET /issuer/credentials/:id/schema-metadata endpoint.\n\n The underlying TS11 specification is not yet finalized.",
          "type": "object",
          "allOf": [
            {
              "$ref": "./SchemaMetaConfig.schema.json"
            }
          ]
        },
        "embeddedDisclosurePolicy": {
          "nullable": true,
          "description": "Embedded disclosure policy (discriminated union by `policy`).\nThe discriminator metadata is retained for OpenAPI schema generation.",
          "oneOf": [
            {
              "$ref": "./AttestationBasedPolicy.schema.json"
            },
            {
              "$ref": "./NoneTrustPolicy.schema.json"
            },
            {
              "$ref": "./AllowListPolicy.schema.json"
            },
            {
              "$ref": "./RootOfTrustPolicy.schema.json"
            }
          ],
          "allOf": [
            {
              "$ref": "./EmbeddedDisclosurePolicy.schema.json"
            }
          ]
        },
        "id": {
          "type": "string"
        },
        "description": {
          "type": "string",
          "nullable": true
        },
        "config": {
          "$ref": "./IssuerMetadataCredentialConfig.schema.json"
        },
        "fields": {
          "type": "array",
          "items": {
            "$ref": "./ClaimFieldDefinitionDto.schema.json"
          }
        },
        "attributeProviderId": {
          "type": "string",
          "nullable": true,
          "description": "Reference to the attribute provider used for fetching claims.\nOptional: if set, claims will be fetched from this provider during issuance."
        },
        "webhookEndpointId": {
          "type": "string",
          "nullable": true,
          "description": "Reference to the webhook endpoint used for notifications.\nOptional: if set, notifications will be sent to this endpoint."
        },
        "keyBinding": {
          "type": "boolean"
        },
        "keyChainId": {
          "type": "string",
          "description": "Reference to the key chain used for signing.\nOptional: if not specified, the default attestation key chain will be used."
        },
        "statusManagement": {
          "type": "boolean"
        },
        "sdJwtTrustFormat": {
          "nullable": true,
          "description": "For SD-JWT credentials: determines whether to include certificate chain (x5c)\nor use federation-based trust (iss claim).\nDefault: \"x5c\" (federation must be explicitly selected)",
          "enum": ["x5c", "federation"],
          "type": "string"
        },
        "lifeTime": {
          "type": "number"
        }
      },
      "additionalProperties": false
    }
  },
  {
    "uri": "./SignSchemaMetaConfigDto.schema.json",
    "fileMatch": ["a://b/SignSchemaMetaConfigDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./SignSchemaMetaConfigDto.schema.json",
      "title": "SignSchemaMetaConfigDto",
      "type": "object",
      "properties": {
        "config": {
          "properties": {
            "id": {
              "type": "string"
            },
            "name": {
              "type": "string"
            },
            "version": {
              "type": "string"
            },
            "rulebookURI": {
              "type": "string"
            },
            "attestationLoS": {
              "type": "string",
              "enum": [
                "iso_18045_high",
                "iso_18045_moderate",
                "iso_18045_enhanced-basic",
                "iso_18045_basic"
              ]
            },
            "bindingType": {
              "type": "string",
              "enum": ["claim", "key", "biometric", "none"]
            },
            "schemaURIs": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "credentialConfigId": {
                    "type": "string"
                  },
                  "format": {
                    "type": "string"
                  },
                  "uri": {
                    "type": "string"
                  },
                  "meta": {
                    "type": "object",
                    "propertyNames": {
                      "type": "string"
                    },
                    "additionalProperties": {}
                  }
                },
                "additionalProperties": false
              }
            },
            "trustedAuthorities": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "trustListId": {
                    "type": "string"
                  },
                  "frameworkType": {
                    "type": "string",
                    "enum": ["aki", "etsi_tl", "openid_federation"]
                  },
                  "value": {
                    "type": "string"
                  },
                  "verificationMethod": {
                    "anyOf": [
                      {
                        "type": "object",
                        "propertyNames": {
                          "type": "string"
                        },
                        "additionalProperties": {}
                      },
                      {
                        "type": "string"
                      }
                    ]
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false,
          "description": "The schema metadata configuration to submit. Registrar builds and signs the final schema metadata.",
          "allOf": [
            {
              "$ref": "./SchemaMetaConfig.schema.json"
            }
          ]
        },
        "credentialConfigId": {
          "type": "string",
          "description": "ID of the credential config to link back after submission. When provided, schemaMeta.id on the credential config is updated with the reserved attestation ID."
        },
        "pinMode": {
          "type": "string",
          "enum": ["keep_current", "update_to_new_version", "replace_id"],
          "description": "How to update credential config pinning after publish. keep_current: do not change existing pin (unless empty). update_to_new_version: update pinned version under current id. replace_id: repoint pin to a different schema id.",
          "default": "keep_current"
        }
      },
      "required": ["config"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./SignVersionSchemaMetaConfigDto.schema.json",
    "fileMatch": ["a://b/SignVersionSchemaMetaConfigDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./SignVersionSchemaMetaConfigDto.schema.json",
      "title": "SignVersionSchemaMetaConfigDto",
      "type": "object",
      "properties": {
        "config": {
          "properties": {
            "id": {
              "type": "string"
            },
            "name": {
              "type": "string"
            },
            "version": {
              "type": "string"
            },
            "rulebookURI": {
              "type": "string"
            },
            "attestationLoS": {
              "type": "string",
              "enum": [
                "iso_18045_high",
                "iso_18045_moderate",
                "iso_18045_enhanced-basic",
                "iso_18045_basic"
              ]
            },
            "bindingType": {
              "type": "string",
              "enum": ["claim", "key", "biometric", "none"]
            },
            "schemaURIs": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "credentialConfigId": {
                    "type": "string"
                  },
                  "format": {
                    "type": "string"
                  },
                  "uri": {
                    "type": "string"
                  },
                  "meta": {
                    "type": "object",
                    "propertyNames": {
                      "type": "string"
                    },
                    "additionalProperties": {}
                  }
                },
                "additionalProperties": false
              }
            },
            "trustedAuthorities": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "trustListId": {
                    "type": "string"
                  },
                  "frameworkType": {
                    "type": "string",
                    "enum": ["aki", "etsi_tl", "openid_federation"]
                  },
                  "value": {
                    "type": "string"
                  },
                  "verificationMethod": {
                    "anyOf": [
                      {
                        "type": "object",
                        "propertyNames": {
                          "type": "string"
                        },
                        "additionalProperties": {}
                      },
                      {
                        "type": "string"
                      }
                    ]
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false,
          "description": "The schema metadata configuration to submit as a new version. Must include the existing id.",
          "allOf": [
            {
              "$ref": "./SchemaMetaConfig.schema.json"
            }
          ]
        },
        "credentialConfigId": {
          "type": "string",
          "description": "Optional credential config to update pinning for after successful version publish."
        },
        "pinMode": {
          "type": "string",
          "enum": ["keep_current", "update_to_new_version", "replace_id"],
          "description": "How to update credential config pinning after version publish. keep_current: do not change existing pin (unless empty). update_to_new_version: update pinned version under current id. replace_id: repoint pin to config.id.",
          "default": "keep_current"
        }
      },
      "required": ["config"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./VocabularyEntryDto.schema.json",
    "fileMatch": ["a://b/VocabularyEntryDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./VocabularyEntryDto.schema.json",
      "title": "VocabularyEntryDto",
      "type": "object",
      "properties": {
        "code": {
          "type": "string",
          "description": "Stable machine-readable value to submit in schema metadata category/tags fields."
        },
        "label": {
          "type": "string",
          "description": "Display label for UI rendering."
        },
        "status": {
          "enum": ["active", "deprecated"],
          "type": "string",
          "description": "Vocabulary lifecycle status."
        },
        "replacedBy": {
          "type": "string",
          "description": "Replacement code when status is deprecated."
        }
      },
      "required": ["code", "label", "status"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./SchemaMetadataVocabulariesDto.schema.json",
    "fileMatch": ["a://b/SchemaMetadataVocabulariesDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./SchemaMetadataVocabulariesDto.schema.json",
      "title": "SchemaMetadataVocabulariesDto",
      "type": "object",
      "properties": {
        "version": {
          "type": "string",
          "description": "Vocabulary publication version for cache invalidation."
        },
        "categories": {
          "description": "Allowed category values that can be used when updating schema metadata category.",
          "type": "array",
          "items": {
            "$ref": "./VocabularyEntryDto.schema.json"
          }
        },
        "tags": {
          "description": "Allowed tag values that can be used when updating schema metadata tags.",
          "type": "array",
          "items": {
            "$ref": "./VocabularyEntryDto.schema.json"
          }
        }
      },
      "required": ["version", "categories", "tags"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./MetadataSchemaDto.schema.json",
    "fileMatch": ["a://b/MetadataSchemaDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./MetadataSchemaDto.schema.json",
      "title": "MetadataSchemaDto",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "description": "Unique identifier for this schema entry"
        },
        "formatIdentifier": {
          "enum": ["dc+sd-jwt", "mso_mdoc"],
          "type": "string",
          "description": "The credential format identifier"
        },
        "uri": {
          "type": "string",
          "description": "URI to the schema definition"
        },
        "meta": {
          "type": "object",
          "additionalProperties": true,
          "description": "Format-specific metadata for the schema entry"
        },
        "integrity": {
          "type": "string",
          "description": "Subresource Integrity hash for the schema"
        }
      },
      "required": ["id", "formatIdentifier"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./TrustAuthorityDto.schema.json",
    "fileMatch": ["a://b/TrustAuthorityDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./TrustAuthorityDto.schema.json",
      "title": "TrustAuthorityDto",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "description": "Unique identifier for this trust authority entry"
        },
        "frameworkType": {
          "type": "string",
          "description": "Type of trust framework",
          "enum": ["etsi_tl"]
        },
        "value": {
          "type": "string",
          "description": "URI or identifier for the trust list / authority"
        },
        "verificationMethod": {
          "type": "object",
          "additionalProperties": true,
          "description": "Verification method for the trust list signature (e.g., JWK)"
        }
      },
      "required": ["id", "frameworkType", "value"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./IssuerOfferEntryDto.schema.json",
    "fileMatch": ["a://b/IssuerOfferEntryDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./IssuerOfferEntryDto.schema.json",
      "title": "IssuerOfferEntryDto",
      "type": "object",
      "properties": {
        "credentialOfferUrl": {
          "type": "string",
          "description": "URL where the user can receive a credential offer from this issuer."
        },
        "description": {
          "type": "string",
          "description": "Human-readable description explaining when this issuer offer is relevant for the user."
        }
      },
      "required": ["credentialOfferUrl", "description"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./AccessCertificateRefDto.schema.json",
    "fileMatch": ["a://b/AccessCertificateRefDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./AccessCertificateRefDto.schema.json",
      "title": "AccessCertificateRefDto",
      "type": "object",
      "properties": {
        "id": {
          "type": "string"
        },
        "relyingPartyId": {
          "type": "string"
        },
        "certificate": {
          "type": "string"
        },
        "revoked": {
          "type": "string"
        },
        "createdAt": {
          "type": "string"
        }
      },
      "required": ["id", "relyingPartyId", "certificate", "revoked", "createdAt"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./SchemaMetadataResponseDto.schema.json",
    "fileMatch": ["a://b/SchemaMetadataResponseDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./SchemaMetadataResponseDto.schema.json",
      "title": "SchemaMetadataResponseDto",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "description": "The unique, server-assigned identifier (UUID) for the schema metadata"
        },
        "version": {
          "type": "string",
          "description": "Version of this schema metadata (SemVer)"
        },
        "rulebookURI": {
          "type": "string",
          "description": "URI of the human-readable Rulebook document"
        },
        "rulebookIntegrity": {
          "type": "string",
          "description": "Subresource Integrity hash for the rulebook URI"
        },
        "attestationLoS": {
          "enum": [
            "iso_18045_high",
            "iso_18045_moderate",
            "iso_18045_enhanced-basic",
            "iso_18045_basic"
          ],
          "type": "string",
          "description": "Level of security (LoS) of this attestation"
        },
        "bindingType": {
          "enum": ["claim", "key", "biometric", "none"],
          "type": "string",
          "description": "Required binding type between attestation and holder"
        },
        "supportedFormats": {
          "type": "array",
          "items": {
            "type": "string",
            "enum": ["dc+sd-jwt", "mso_mdoc"]
          },
          "description": "Credential formats in which this attestation is available"
        },
        "schemaURIs": {
          "description": "Format-specific schema URIs for this schema metadata",
          "type": "array",
          "items": {
            "$ref": "./MetadataSchemaDto.schema.json"
          }
        },
        "trustedAuthorities": {
          "description": "Trust frameworks / trust anchors applicable to this schema metadata",
          "type": "array",
          "items": {
            "$ref": "./TrustAuthorityDto.schema.json"
          }
        },
        "category": {
          "enum": ["identity", "health", "finance", "education", "mobility", "employment", "other"],
          "type": "string",
          "description": "Domain category for filtering"
        },
        "tags": {
          "description": "Free-form tags for filtering and search",
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "displayName": {
          "type": "string",
          "description": "Optional human-readable schema name for UI display and filtering."
        },
        "issuerOffers": {
          "description": "Issuer offer entries for this schema metadata. Each entry provides a credential offer URL and user-facing description.",
          "type": "array",
          "items": {
            "$ref": "./IssuerOfferEntryDto.schema.json"
          }
        },
        "signedJwt": {
          "type": "string",
          "description": "The original signed JWT"
        },
        "issuer": {
          "type": "string",
          "description": "Issuer from the JWT (`iss` claim)"
        },
        "signerCertificate": {
          "description": "The access certificate used to sign this schema metadata",
          "allOf": [
            {
              "$ref": "./AccessCertificateRefDto.schema.json"
            }
          ]
        },
        "issuedAt": {
          "type": "string",
          "description": "Timestamp when the JWT was issued (from the `iat` claim)"
        },
        "createdAt": {
          "type": "string",
          "description": "Server creation timestamp"
        },
        "updatedAt": {
          "type": "string",
          "description": "Last update timestamp"
        },
        "deprecated": {
          "type": "boolean",
          "description": "Whether this version is deprecated"
        },
        "deprecationMessage": {
          "type": "string",
          "description": "Deprecation message shown to consumers"
        },
        "supersededByVersion": {
          "type": "string",
          "description": "The version that supersedes this one"
        },
        "deprecatedAt": {
          "type": "string",
          "description": "Timestamp when this version was marked as deprecated"
        }
      },
      "required": [
        "id",
        "version",
        "attestationLoS",
        "bindingType",
        "supportedFormats",
        "schemaURIs",
        "trustedAuthorities",
        "issuerOffers",
        "signedJwt",
        "issuer",
        "issuedAt",
        "createdAt",
        "updatedAt",
        "deprecated"
      ],
      "additionalProperties": false
    }
  },
  {
    "uri": "./UpdateIssuerOfferDto.schema.json",
    "fileMatch": ["a://b/UpdateIssuerOfferDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./UpdateIssuerOfferDto.schema.json",
      "title": "UpdateIssuerOfferDto",
      "type": "object",
      "properties": {
        "credentialOfferUrl": {
          "type": "string",
          "description": "URL where the user can receive a credential offer from this issuer."
        },
        "description": {
          "type": "string",
          "description": "Human-readable description to help users choose the right issuer."
        }
      },
      "additionalProperties": false
    }
  },
  {
    "uri": "./UpdateSchemaMetadataDto.schema.json",
    "fileMatch": ["a://b/UpdateSchemaMetadataDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./UpdateSchemaMetadataDto.schema.json",
      "title": "UpdateSchemaMetadataDto",
      "type": "object",
      "properties": {
        "category": {
          "type": "string",
          "enum": ["identity", "health", "finance", "education", "mobility", "employment", "other"],
          "description": "Domain category for filtering"
        },
        "tags": {
          "type": "array",
          "items": {
            "type": "string",
            "enum": [
              "pid",
              "eudi",
              "kyc",
              "aml",
              "age-verification",
              "residency",
              "membership",
              "education",
              "employment",
              "mobility"
            ]
          },
          "description": "Predefined tags for filtering and search"
        },
        "displayName": {
          "type": "string",
          "description": "Optional human-readable schema name for UI display and search"
        },
        "issuerOffers": {
          "items": {
            "type": "object",
            "properties": {
              "credentialOfferUrl": {
                "type": "string"
              },
              "description": {
                "type": "string"
              }
            },
            "additionalProperties": false
          },
          "description": "Issuer offer entries shown to users, each with credential-offer URL and description",
          "type": "array"
        }
      },
      "additionalProperties": false
    }
  },
  {
    "uri": "./DeprecateSchemaMetadataDto.schema.json",
    "fileMatch": ["a://b/DeprecateSchemaMetadataDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./DeprecateSchemaMetadataDto.schema.json",
      "title": "DeprecateSchemaMetadataDto",
      "type": "object",
      "properties": {
        "deprecated": {
          "type": "boolean",
          "description": "Whether to mark this version as deprecated"
        },
        "message": {
          "type": "string",
          "description": "Deprecation message shown to consumers"
        },
        "supersededByVersion": {
          "type": "string",
          "description": "The version that supersedes this one"
        }
      },
      "required": ["deprecated"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./TrustListEntityInfo.schema.json",
    "fileMatch": ["a://b/TrustListEntityInfo*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./TrustListEntityInfo.schema.json",
      "title": "TrustListEntityInfo",
      "type": "object",
      "properties": {
        "name": {
          "type": "string"
        },
        "lang": {
          "type": "string"
        },
        "uri": {
          "type": "string"
        },
        "country": {
          "type": "string"
        },
        "locality": {
          "type": "string"
        },
        "postalCode": {
          "type": "string"
        },
        "streetAddress": {
          "type": "string"
        },
        "contactUri": {
          "type": "string"
        }
      },
      "required": ["name"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./InternalTrustListEntity.schema.json",
    "fileMatch": ["a://b/InternalTrustListEntity*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./InternalTrustListEntity.schema.json",
      "title": "InternalTrustListEntity",
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": ["internal"]
        },
        "issuerKeyChainId": {
          "type": "string"
        },
        "revocationKeyChainId": {
          "type": "string"
        },
        "info": {
          "$ref": "./TrustListEntityInfo.schema.json"
        }
      },
      "required": ["type", "issuerKeyChainId", "revocationKeyChainId", "info"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./ExternalTrustListEntity.schema.json",
    "fileMatch": ["a://b/ExternalTrustListEntity*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./ExternalTrustListEntity.schema.json",
      "title": "ExternalTrustListEntity",
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": ["external"]
        },
        "issuerCertPem": {
          "type": "string"
        },
        "revocationCertPem": {
          "type": "string"
        },
        "info": {
          "$ref": "./TrustListEntityInfo.schema.json"
        }
      },
      "required": ["type", "issuerCertPem", "revocationCertPem", "info"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./TrustList.schema.json",
    "fileMatch": ["a://b/TrustList*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./TrustList.schema.json",
      "title": "TrustList",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "description": "Unique identifier for the trust list"
        },
        "description": {
          "type": "string"
        },
        "tenantId": {
          "type": "string",
          "description": "The tenant ID for which the VP request is made."
        },
        "tenant": {
          "description": "The tenant that owns this object.",
          "allOf": [
            {
              "$ref": "./TenantEntity.schema.json"
            }
          ]
        },
        "keyChainId": {
          "type": "string"
        },
        "keyChain": {
          "$ref": "./KeyChainEntity.schema.json"
        },
        "data": {
          "type": "object",
          "description": "The full trust list JSON (generated LoTE structure)"
        },
        "entityConfig": {
          "description": "The original entity configuration used to create this trust list.\nStored for round-tripping when editing.",
          "type": "array",
          "items": {
            "type": "object"
          }
        },
        "sequenceNumber": {
          "type": "number",
          "description": "The sequence number for versioning (incremented on updates)"
        },
        "jwt": {
          "type": "string",
          "description": "The signed JWT representation of this trust list"
        },
        "createdAt": {
          "format": "date-time",
          "type": "string"
        },
        "updatedAt": {
          "format": "date-time",
          "type": "string"
        }
      },
      "required": [
        "id",
        "tenantId",
        "tenant",
        "keyChainId",
        "keyChain",
        "sequenceNumber",
        "jwt",
        "createdAt",
        "updatedAt"
      ],
      "additionalProperties": false
    }
  },
  {
    "uri": "./TrustListVersion.schema.json",
    "fileMatch": ["a://b/TrustListVersion*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./TrustListVersion.schema.json",
      "title": "TrustListVersion",
      "type": "object",
      "properties": {
        "id": {
          "type": "string"
        },
        "trustListId": {
          "type": "string"
        },
        "trustList": {
          "$ref": "./TrustList.schema.json"
        },
        "tenantId": {
          "type": "string"
        },
        "sequenceNumber": {
          "type": "number",
          "description": "The sequence number at the time this version was created"
        },
        "data": {
          "type": "object",
          "description": "The full trust list JSON at this version"
        },
        "entityConfig": {
          "type": "object",
          "description": "The entity configuration at this version"
        },
        "jwt": {
          "type": "string",
          "description": "The signed JWT at this version"
        },
        "createdAt": {
          "format": "date-time",
          "type": "string"
        }
      },
      "required": [
        "id",
        "trustListId",
        "trustList",
        "tenantId",
        "sequenceNumber",
        "data",
        "jwt",
        "createdAt"
      ],
      "additionalProperties": false
    }
  },
  {
    "uri": "./TrustListRef.schema.json",
    "fileMatch": ["a://b/TrustListRef*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./TrustListRef.schema.json",
      "title": "TrustListRef",
      "type": "object",
      "properties": {
        "trustListId": {
          "type": "string",
          "description": "Managed local trust-list identifier. When provided, verifier material is resolved server-side from the trust list key chain."
        },
        "url": {
          "type": "string",
          "description": "Trust-list JWT URL. Required for external trust lists when trustListId is not set."
        },
        "verifierKey": {
          "type": "object",
          "additionalProperties": true,
          "description": "JWK used to verify trust-list JWT signatures for external trusted authority values."
        },
        "verifierX509Der": {
          "type": "string",
          "description": "Base64 DER-encoded X.509 certificate used to verify trust-list JWT signatures for external trusted authority values."
        }
      },
      "additionalProperties": false
    }
  },
  {
    "uri": "./TrustedAuthorityQueryEtsiTl.schema.json",
    "fileMatch": ["a://b/TrustedAuthorityQueryEtsiTl*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./TrustedAuthorityQueryEtsiTl.schema.json",
      "title": "TrustedAuthorityQueryEtsiTl",
      "type": "object",
      "properties": {
        "type": {
          "enum": ["etsi_tl"],
          "type": "string",
          "default": "etsi_tl"
        },
        "values": {
          "type": "array",
          "items": {
            "$ref": "./TrustListRef.schema.json"
          }
        }
      },
      "required": ["type", "values"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./TrustedAuthorityQueryOpenIdFederation.schema.json",
    "fileMatch": ["a://b/TrustedAuthorityQueryOpenIdFederation*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./TrustedAuthorityQueryOpenIdFederation.schema.json",
      "title": "TrustedAuthorityQueryOpenIdFederation",
      "type": "object",
      "properties": {
        "type": {
          "enum": ["openid_federation"],
          "type": "string",
          "default": "openid_federation"
        },
        "values": {
          "type": "array",
          "items": {
            "type": "string"
          }
        }
      },
      "required": ["type", "values"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./DcSdJwtCredentialQueryMeta.schema.json",
    "fileMatch": ["a://b/DcSdJwtCredentialQueryMeta*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./DcSdJwtCredentialQueryMeta.schema.json",
      "title": "DcSdJwtCredentialQueryMeta",
      "type": "object",
      "properties": {
        "vct_values": {
          "type": "array",
          "items": {
            "type": "string"
          },
          "description": "VCT identifiers accepted for dc+sd-jwt credentials."
        }
      },
      "required": ["vct_values"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./MsoMdocCredentialQueryMeta.schema.json",
    "fileMatch": ["a://b/MsoMdocCredentialQueryMeta*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./MsoMdocCredentialQueryMeta.schema.json",
      "title": "MsoMdocCredentialQueryMeta",
      "type": "object",
      "properties": {
        "doctype_value": {
          "type": "string",
          "description": "Document type identifier accepted for mso_mdoc credentials."
        }
      },
      "required": ["doctype_value"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./MsoMdocClaimsQuery.schema.json",
    "fileMatch": ["a://b/MsoMdocClaimsQuery*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./MsoMdocClaimsQuery.schema.json",
      "title": "MsoMdocClaimsQuery",
      "type": "object",
      "properties": {
        "intent_to_retain": {
          "type": "boolean",
          "description": "Whether the holder should be allowed to retain the claim in an mso_mdoc response."
        },
        "id": {
          "type": "string"
        },
        "path": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "values": {
          "type": "array",
          "items": {
            "type": "string"
          }
        }
      },
      "required": ["path"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./CredentialQueryDcSdJwt.schema.json",
    "fileMatch": ["a://b/CredentialQueryDcSdJwt*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./CredentialQueryDcSdJwt.schema.json",
      "title": "CredentialQueryDcSdJwt",
      "type": "object",
      "properties": {
        "format": {
          "type": "string",
          "default": "dc+sd-jwt",
          "enum": ["dc+sd-jwt"],
          "description": "Credential format discriminator."
        },
        "claim_sets": {
          "type": "array",
          "items": {
            "type": "array",
            "items": {
              "type": "string"
            }
          },
          "description": "Ordered alternative claim combinations for this credential query."
        },
        "trusted_authorities": {
          "type": "array",
          "description": "Trusted authority constraints (discriminated by type) for this credential query.",
          "items": {
            "oneOf": [
              {
                "$ref": "./TrustedAuthorityQueryEtsiTl.schema.json"
              },
              {
                "$ref": "./TrustedAuthorityQueryOpenIdFederation.schema.json"
              }
            ],
            "discriminator": {
              "propertyName": "type",
              "mapping": {
                "etsi_tl": "./TrustedAuthorityQueryEtsiTl.schema.json",
                "openid_federation": "./TrustedAuthorityQueryOpenIdFederation.schema.json"
              }
            },
            "type": "object",
            "properties": {
              "type": {
                "type": "string",
                "enum": ["etsi_tl", "openid_federation"]
              }
            }
          }
        },
        "meta": {
          "description": "dc+sd-jwt schema metadata for the requested credential.",
          "allOf": [
            {
              "$ref": "./DcSdJwtCredentialQueryMeta.schema.json"
            }
          ]
        },
        "claims": {
          "type": "array",
          "items": {
            "$ref": "./ClaimsQuery.schema.json"
          }
        },
        "id": {
          "type": "string"
        },
        "multiple": {
          "type": "boolean"
        }
      },
      "required": ["format", "meta", "id"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./CredentialQueryMsoMdoc.schema.json",
    "fileMatch": ["a://b/CredentialQueryMsoMdoc*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./CredentialQueryMsoMdoc.schema.json",
      "title": "CredentialQueryMsoMdoc",
      "type": "object",
      "properties": {
        "format": {
          "type": "string",
          "default": "mso_mdoc",
          "enum": ["mso_mdoc"],
          "description": "Credential format discriminator."
        },
        "claim_sets": {
          "type": "array",
          "items": {
            "type": "array",
            "items": {
              "type": "string"
            }
          },
          "description": "Ordered alternative claim combinations for this credential query."
        },
        "trusted_authorities": {
          "type": "array",
          "description": "Trusted authority constraints (discriminated by type) for this credential query.",
          "items": {
            "oneOf": [
              {
                "$ref": "./TrustedAuthorityQueryEtsiTl.schema.json"
              },
              {
                "$ref": "./TrustedAuthorityQueryOpenIdFederation.schema.json"
              }
            ],
            "discriminator": {
              "propertyName": "type",
              "mapping": {
                "etsi_tl": "./TrustedAuthorityQueryEtsiTl.schema.json",
                "openid_federation": "./TrustedAuthorityQueryOpenIdFederation.schema.json"
              }
            },
            "type": "object",
            "properties": {
              "type": {
                "type": "string",
                "enum": ["etsi_tl", "openid_federation"]
              }
            }
          }
        },
        "meta": {
          "description": "mso_mdoc document type metadata for the requested credential.",
          "allOf": [
            {
              "$ref": "./MsoMdocCredentialQueryMeta.schema.json"
            }
          ]
        },
        "claims": {
          "type": "array",
          "items": {
            "$ref": "./MsoMdocClaimsQuery.schema.json"
          }
        },
        "id": {
          "type": "string"
        },
        "multiple": {
          "type": "boolean"
        }
      },
      "required": ["format", "meta", "id"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./RegistrationCertificatePurpose.schema.json",
    "fileMatch": ["a://b/RegistrationCertificatePurpose*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./RegistrationCertificatePurpose.schema.json",
      "title": "RegistrationCertificatePurpose",
      "type": "object",
      "properties": {
        "lang": {
          "type": "string"
        },
        "content": {
          "type": "string"
        }
      },
      "required": ["lang", "content"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./RegistrationCertificateBody.schema.json",
    "fileMatch": ["a://b/RegistrationCertificateBody*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./RegistrationCertificateBody.schema.json",
      "title": "RegistrationCertificateBody",
      "type": "object",
      "properties": {
        "privacy_policy": {
          "type": "string"
        },
        "support_uri": {
          "type": "string"
        },
        "intermediary": {
          "type": "string"
        },
        "purpose": {
          "items": {
            "type": "object",
            "properties": {
              "lang": {
                "type": "string"
              },
              "content": {
                "type": "string"
              }
            },
            "required": ["lang", "content"],
            "additionalProperties": false
          },
          "type": "array"
        },
        "credentials": {
          "items": {
            "type": "object",
            "propertyNames": {
              "type": "string"
            },
            "additionalProperties": {}
          },
          "type": "array"
        },
        "provided_attestations": {
          "items": {
            "type": "object",
            "propertyNames": {
              "type": "string"
            },
            "additionalProperties": {}
          },
          "type": "array"
        }
      },
      "additionalProperties": false
    }
  },
  {
    "uri": "./RegistrationCertificateRequest.schema.json",
    "fileMatch": ["a://b/RegistrationCertificateRequest*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./RegistrationCertificateRequest.schema.json",
      "title": "RegistrationCertificateRequest",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "description": "Optional registrar-side certificate identifier.\nIf provided and still valid, EUDIPLO reuses it instead of creating a new certificate."
        },
        "body": {
          "properties": {
            "privacy_policy": {
              "type": "string"
            },
            "support_uri": {
              "type": "string"
            },
            "intermediary": {
              "type": "string"
            },
            "purpose": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "lang": {
                    "type": "string"
                  },
                  "content": {
                    "type": "string"
                  }
                },
                "required": ["lang", "content"],
                "additionalProperties": false
              }
            },
            "credentials": {
              "type": "array",
              "items": {
                "type": "object",
                "propertyNames": {
                  "type": "string"
                },
                "additionalProperties": {}
              }
            },
            "provided_attestations": {
              "type": "array",
              "items": {
                "type": "object",
                "propertyNames": {
                  "type": "string"
                },
                "additionalProperties": {}
              }
            }
          },
          "additionalProperties": false,
          "description": "Registration certificate creation payload.\nThis is merged with tenant-level registrar defaults when a certificate is created.",
          "allOf": [
            {
              "$ref": "./RegistrationCertificateBody.schema.json"
            }
          ]
        },
        "jwt": {
          "type": "string",
          "description": "Optional pre-existing registration certificate JWT.\nIf provided, EUDIPLO forwards it as-is and does not create a new one."
        }
      },
      "additionalProperties": false
    }
  },
  {
    "uri": "./PresentationAttachment.schema.json",
    "fileMatch": ["a://b/PresentationAttachment*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./PresentationAttachment.schema.json",
      "title": "PresentationAttachment",
      "type": "object",
      "properties": {
        "format": {
          "type": "string"
        },
        "data": {
          "type": "object"
        },
        "credential_ids": {
          "type": "array",
          "items": {
            "type": "string"
          }
        }
      },
      "required": ["format", "data"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./PresentationConfig.schema.json",
    "fileMatch": ["a://b/PresentationConfig*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./PresentationConfig.schema.json",
      "title": "PresentationConfig",
      "type": "object",
      "properties": {
        "skewSeconds": {
          "type": "number",
          "description": "Clock skew tolerance for credential JWT time validation, in seconds.",
          "default": 60
        },
        "statusCheckMode": {
          "description": "Status list verification mode for presentations: strict (default), best_effort, or disabled.",
          "enum": ["strict", "best_effort", "disabled"],
          "type": "string",
          "default": "strict"
        },
        "registrationCertCache": {
          "type": "object",
          "nullable": true,
          "description": "Server-managed cache of the materialized registration certificate. Read-only; values supplied by clients are ignored.",
          "example": "",
          "readOnly": true,
          "additionalProperties": true
        },
        "id": {
          "type": "string",
          "description": "Unique identifier for the VP request."
        },
        "tenant": {
          "description": "The tenant that owns this object.",
          "allOf": [
            {
              "$ref": "./TenantEntity.schema.json"
            }
          ]
        },
        "description": {
          "type": "string",
          "nullable": true,
          "description": "Description of the presentation configuration."
        },
        "lifeTime": {
          "type": "number",
          "description": "Lifetime how long the presentation request is valid after creation, in seconds."
        },
        "dcql_query": {
          "description": "The DCQL query to be used for the VP request.",
          "allOf": [
            {
              "$ref": "./DCQL.schema.json"
            }
          ]
        },
        "transaction_data": {
          "type": "array",
          "items": {
            "$ref": "./TransactionData.schema.json"
          }
        },
        "registration_cert": {
          "nullable": true,
          "description": "The registration certificate request containing the necessary details.",
          "type": "object",
          "allOf": [
            {
              "$ref": "./RegistrationCertificateRequest.schema.json"
            }
          ]
        },
        "webhookEndpointId": {
          "type": "string",
          "nullable": true,
          "description": "Reference to the webhook endpoint used for notifications.\nOptional: if set, notifications will be sent to this endpoint."
        },
        "createdAt": {
          "format": "date-time",
          "type": "string",
          "description": "The timestamp when the VP request was created."
        },
        "updatedAt": {
          "format": "date-time",
          "type": "string",
          "description": "The timestamp when the VP request was last updated."
        },
        "attached": {
          "nullable": true,
          "description": "Attestation that should be attached",
          "type": "array",
          "items": {
            "$ref": "./PresentationAttachment.schema.json"
          }
        },
        "redirectUri": {
          "type": "string",
          "nullable": true,
          "description": "Redirect URI to which the user-agent should be redirected after the presentation is completed.\nYou can use the `{sessionId}` placeholder in the URI, which will be replaced with the actual session ID.",
          "example": "https://example.com/callback?session={sessionId}"
        },
        "accessKeyChainId": {
          "type": "string",
          "nullable": true,
          "description": "Optional ID of the access certificate to use for signing the presentation request.\nIf not provided, the default access certificate for the tenant will be used.\n\nNote: This is intentionally NOT a TypeORM relationship because CertEntity uses\na composite primary key (id + tenantId), and SQLite cannot create foreign keys\nthat reference only part of a composite primary key. The relationship is handled\nat the application level in the service layer."
        },
        "readerAuth": {
          "type": "boolean",
          "nullable": true,
          "description": "Enable reader authentication for the ISO 18013-7 Annex C (DC API) flow.\n\nWhen `true`, the DeviceRequest embeds a detached `readerAuth` COSE_Sign1\nsigned with the tenant's Access key chain (selected by\n{@link accessKeyChainId}), letting the wallet cryptographically\nauthenticate the verifier — the mDOC equivalent of the signed request\nobject used in the OID4VP flow. Defaults to disabled (null/false).\n\nOnly affects `response_type: \"iso-18013-7\"` offers."
        }
      },
      "required": ["id", "tenant", "dcql_query", "createdAt", "updatedAt"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./ResolveIssuerMetadataDto.schema.json",
    "fileMatch": ["a://b/ResolveIssuerMetadataDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./ResolveIssuerMetadataDto.schema.json",
      "title": "ResolveIssuerMetadataDto",
      "type": "object",
      "properties": {
        "issuerUrl": {
          "type": "string",
          "format": "uri",
          "description": "Issuer URL or full OpenID4VCI metadata URL to resolve server-side.",
          "example": "https://issuer.example.com/issuers/tenant-a"
        }
      },
      "required": ["issuerUrl"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./ResolveSchemaMetadataDto.schema.json",
    "fileMatch": ["a://b/ResolveSchemaMetadataDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./ResolveSchemaMetadataDto.schema.json",
      "title": "ResolveSchemaMetadataDto",
      "type": "object",
      "properties": {
        "schemaMetadataUrl": {
          "type": "string",
          "format": "uri",
          "description": "Schema metadata URL to resolve server-side. The response must contain a signedJwt field.",
          "example": "https://registrar.example.com/schema-metadata/5c0d7dbb-ef2e-448b-b84f-b8103575947b"
        }
      },
      "required": ["schemaMetadataUrl"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./ResolveSchemaMetadataJwtDto.schema.json",
    "fileMatch": ["a://b/ResolveSchemaMetadataJwtDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./ResolveSchemaMetadataJwtDto.schema.json",
      "title": "ResolveSchemaMetadataJwtDto",
      "type": "object",
      "properties": {
        "signedJwt": {
          "type": "string",
          "description": "Signed schema metadata JWT to resolve server-side. The JWT will be verified, resolved, and converted to DCQL.",
          "example": "eyJ0eXAiOiJhdHRlc3RhdGlvbi1zY2hlbWErand0IiwiYWxnIjoiRVMyNTYiLCJ4NWMiOlsiTUlJQ01qQ0NBZGlnQXdJQkFnSVVDa0hwaTlPWHQ0QUJTY2NWbEl3UlJRdlE5cU1Rd0NnWUlLb1pJemowRUF3SXdLREVMTUFrR0ExVUVCaE1DUkVVeEdUQVhCZ05WQkFNTUVFZGxjbTFoYmlCU1pXZHBjM1J5WVhJd0hoY05Nall3TVRFMk1UQXdOVEE0V2hjTk1qZ3dNVEUyTVRBd05UQTRXakFvTVFzd0NRWURWUVFHRXdKRVJURVpNQmNHQTFVRUF3d1FSMlZ5YldGdUlGSmxaMmx6ZEhKaGNqQlpNQk1HQnlxR1NNNDlBZ0VHQ0NxR1NNNDlBd0VIQTBJQUJBUXQrK1dGQnJkVVJjYXkycmtyMG9pdW9zMDE2dlVLT2tsWVNJUVF4K1cvclcyOVc4bkE3SFMrNHMrNW0zWW5tUmRRcXphYWZDT3ZHYXhjSUd5UXFjQ2pnZDh3Z2R3d0hRWURWUjBPQkJZRUZQNGwyNXhUZWxBbnNEa0U2QXFlc09zd3pxWWxNQjhHQTFVZEl3UVlNQmFBRlA0bDI1eFRlbEFuc0RrRTZBcWVzT3N3enFZbE1CSUdBMVVkRXdFQi93UUlNQVlCQWY4Q0FRQXdEZ1lEVlIwUEFRSC9CQVFEQWdFR01Dd0dBMVVkRWdRbE1DT0dJV2gwZEhCek9pOHZjbVZuYVhOMGNtRnlMbVYxWkdrdGQyRnNiR1YwTG1SbGRqQklCZ05WSFI4RVFUQS9NRDJnTzZBNWhqZG9kSFJ3Y3pvdkwzSmxaMmx6ZEhKaGNpNWxkV1JwTFhkaGJHeGxkQzVrWlhZdmMzUmhkSFZ6TFcxaGJtRm5aVzFsYm5RdlkzSnNNQW9HQ0NxR1NNNDlCQU1DQTBnQU1FVUNJRFcxTXA0ZDc3a2oxWVVIWHlhVU1mMmNpbGtxTmpkL2RpdWpud3A4Ti9ISkFpRUF2WXlaK1IyUXFuUUJJUnZBL281aEVjVHJuNTNMQ2ZEQWZnWGt1OWxzZUIwPSJdIn0.eyJpZCI6Imh0dHA6Ly9sb2NhbGhvc3Q6MzAwMS9zY2hlbWEtbWV0YWRhdGEvNWMzNzFhMjEtZWIxOC00NzY3LTk4MTktMGIwMGY2NTQzY2QzIiwidmVyc2lvbiI6IjEuMC4wIn0.signature"
        }
      },
      "required": ["signedJwt"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./PresentationConfigUpdateDto.schema.json",
    "fileMatch": ["a://b/PresentationConfigUpdateDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./PresentationConfigUpdateDto.schema.json",
      "title": "PresentationConfigUpdateDto",
      "type": "object",
      "properties": {
        "skewSeconds": {
          "type": "number",
          "description": "Clock skew tolerance for credential JWT time validation, in seconds.",
          "default": 60
        },
        "statusCheckMode": {
          "description": "Status list verification mode for presentations: strict (default), best_effort, or disabled.",
          "enum": ["strict", "best_effort", "disabled"],
          "type": "string",
          "default": "strict"
        },
        "id": {
          "type": "string",
          "description": "Unique identifier for the VP request."
        },
        "description": {
          "type": "string",
          "nullable": true,
          "description": "Description of the presentation configuration."
        },
        "lifeTime": {
          "type": "number",
          "description": "Lifetime how long the presentation request is valid after creation, in seconds."
        },
        "dcql_query": {
          "description": "The DCQL query to be used for the VP request.",
          "allOf": [
            {
              "$ref": "./DCQL.schema.json"
            }
          ]
        },
        "transaction_data": {
          "type": "array",
          "items": {
            "$ref": "./TransactionData.schema.json"
          }
        },
        "registration_cert": {
          "nullable": true,
          "description": "The registration certificate request containing the necessary details.",
          "type": "object",
          "allOf": [
            {
              "$ref": "./RegistrationCertificateRequest.schema.json"
            }
          ]
        },
        "webhookEndpointId": {
          "type": "string",
          "nullable": true,
          "description": "Reference to the webhook endpoint used for notifications.\nOptional: if set, notifications will be sent to this endpoint."
        },
        "attached": {
          "nullable": true,
          "description": "Attestation that should be attached",
          "type": "array",
          "items": {
            "$ref": "./PresentationAttachment.schema.json"
          }
        },
        "redirectUri": {
          "type": "string",
          "nullable": true,
          "description": "Redirect URI to which the user-agent should be redirected after the presentation is completed.\nYou can use the `{sessionId}` placeholder in the URI, which will be replaced with the actual session ID.",
          "example": "https://example.com/callback?session={sessionId}"
        },
        "accessKeyChainId": {
          "type": "string",
          "nullable": true,
          "description": "Optional ID of the access certificate to use for signing the presentation request.\nIf not provided, the default access certificate for the tenant will be used.\n\nNote: This is intentionally NOT a TypeORM relationship because CertEntity uses\na composite primary key (id + tenantId), and SQLite cannot create foreign keys\nthat reference only part of a composite primary key. The relationship is handled\nat the application level in the service layer."
        },
        "readerAuth": {
          "type": "boolean",
          "nullable": true,
          "description": "Enable reader authentication for the ISO 18013-7 Annex C (DC API) flow.\n\nWhen `true`, the DeviceRequest embeds a detached `readerAuth` COSE_Sign1\nsigned with the tenant's Access key chain (selected by\n{@link accessKeyChainId}), letting the wallet cryptographically\nauthenticate the verifier — the mDOC equivalent of the signed request\nobject used in the OID4VP flow. Defaults to disabled (null/false).\n\nOnly affects `response_type: \"iso-18013-7\"` offers."
        }
      },
      "additionalProperties": false
    }
  },
  {
    "uri": "./RegistrationCertificateDefaults.schema.json",
    "fileMatch": ["a://b/RegistrationCertificateDefaults*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./RegistrationCertificateDefaults.schema.json",
      "title": "RegistrationCertificateDefaults",
      "type": "object",
      "properties": {
        "privacy_policy": {
          "type": "string",
          "description": "Default privacy policy URL for registration certificate creation.",
          "example": "https://verifier.example/privacy"
        },
        "support_uri": {
          "type": "string",
          "description": "Default support contact URI for registration certificate creation.",
          "example": "mailto:support@verifier.example"
        }
      },
      "additionalProperties": false
    }
  },
  {
    "uri": "./RegistrarConfigResponseDto.schema.json",
    "fileMatch": ["a://b/RegistrarConfigResponseDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./RegistrarConfigResponseDto.schema.json",
      "title": "RegistrarConfigResponseDto",
      "type": "object",
      "properties": {
        "registrarUrl": {
          "type": "string",
          "description": "The base URL of the registrar API",
          "example": "https://sandbox.eudi-wallet.org/api"
        },
        "oidcUrl": {
          "type": "string",
          "description": "The OIDC issuer URL for authentication (e.g., Keycloak realm URL)",
          "example": "https://auth.example.com/realms/my-realm"
        },
        "clientId": {
          "type": "string",
          "description": "The OIDC client ID for the registrar",
          "example": "registrar-client"
        },
        "clientSecret": {
          "type": "string",
          "description": "The OIDC client secret (optional, for confidential clients)"
        },
        "username": {
          "type": "string",
          "description": "The username for OIDC login",
          "example": "admin@example.com"
        },
        "registrationCertificateDefaults": {
          "nullable": true,
          "description": "Optional default values merged into registration certificate creation requests (for example privacy_policy, support_uri)",
          "additionalProperties": true,
          "type": "object",
          "allOf": [
            {
              "$ref": "./RegistrationCertificateDefaults.schema.json"
            }
          ]
        },
        "hasPassword": {
          "type": "boolean",
          "description": "Indicates whether a password is configured (actual password is never returned)",
          "example": true
        }
      },
      "required": ["registrarUrl", "oidcUrl", "clientId", "username", "hasPassword"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./DeferredCredentialRequestDto.schema.json",
    "fileMatch": ["a://b/DeferredCredentialRequestDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./DeferredCredentialRequestDto.schema.json",
      "title": "DeferredCredentialRequestDto",
      "type": "object",
      "properties": {
        "transaction_id": {
          "type": "string",
          "description": "The transaction identifier previously returned by the Credential Endpoint",
          "example": "8xLOxBtZp8"
        }
      },
      "required": ["transaction_id"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./NotificationRequestDto.schema.json",
    "fileMatch": ["a://b/NotificationRequestDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./NotificationRequestDto.schema.json",
      "title": "NotificationRequestDto",
      "type": "object",
      "properties": {
        "notification_id": {
          "type": "string"
        },
        "event": {
          "type": "string",
          "enum": ["credential_accepted", "credential_failure", "credential_deleted"]
        }
      },
      "required": ["notification_id", "event"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./OfferResponse.schema.json",
    "fileMatch": ["a://b/OfferResponse*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./OfferResponse.schema.json",
      "title": "OfferResponse",
      "type": "object",
      "properties": {
        "uri": {
          "type": "string"
        },
        "crossDeviceUri": {
          "type": "string",
          "description": "URI for cross-device flows (no redirect after completion)"
        },
        "session": {
          "type": "string"
        }
      },
      "required": ["uri", "session"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./CompleteDeferredDto.schema.json",
    "fileMatch": ["a://b/CompleteDeferredDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./CompleteDeferredDto.schema.json",
      "title": "CompleteDeferredDto",
      "type": "object",
      "properties": {
        "claims": {
          "type": "object",
          "propertyNames": {
            "type": "string"
          },
          "additionalProperties": true,
          "description": "Claims to include in the credential. The structure should match the credential configuration's expected claims.",
          "example": {
            "given_name": "John",
            "family_name": "Doe",
            "birthdate": "1990-01-15"
          }
        }
      },
      "required": ["claims"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./DeferredOperationResponse.schema.json",
    "fileMatch": ["a://b/DeferredOperationResponse*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./DeferredOperationResponse.schema.json",
      "title": "DeferredOperationResponse",
      "type": "object",
      "properties": {
        "transactionId": {
          "type": "string",
          "description": "The transaction ID"
        },
        "status": {
          "description": "The new status of the transaction",
          "enum": ["pending", "ready", "retrieved", "expired", "failed"],
          "type": "string"
        },
        "message": {
          "type": "string",
          "description": "Optional message"
        }
      },
      "required": ["transactionId", "status"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./FailDeferredDto.schema.json",
    "fileMatch": ["a://b/FailDeferredDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./FailDeferredDto.schema.json",
      "title": "FailDeferredDto",
      "type": "object",
      "properties": {
        "error": {
          "type": "string",
          "description": "Optional error message explaining why the issuance failed",
          "example": "Identity verification failed"
        }
      },
      "additionalProperties": false
    }
  },
  {
    "uri": "./EC_Public.schema.json",
    "fileMatch": ["a://b/EC_Public*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./EC_Public.schema.json",
      "title": "EC_Public",
      "type": "object",
      "properties": {
        "kty": {
          "type": "string",
          "description": "The key type, which is always 'EC' for Elliptic Curve keys."
        },
        "crv": {
          "type": "string",
          "description": "The algorithm intended for use with the key, such as 'ES256'."
        },
        "x": {
          "type": "string",
          "description": "The x coordinate of the EC public key."
        },
        "y": {
          "type": "string",
          "description": "The y coordinate of the EC public key."
        }
      },
      "required": ["kty", "crv", "x", "y"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./JwksResponseDto.schema.json",
    "fileMatch": ["a://b/JwksResponseDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./JwksResponseDto.schema.json",
      "title": "JwksResponseDto",
      "type": "object",
      "properties": {
        "keys": {
          "description": "An array of EC public keys in JWK format.",
          "type": "array",
          "items": {
            "$ref": "./EC_Public.schema.json"
          }
        }
      },
      "required": ["keys"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./AuthorizationResponse.schema.json",
    "fileMatch": ["a://b/AuthorizationResponse*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./AuthorizationResponse.schema.json",
      "title": "AuthorizationResponse",
      "type": "object",
      "properties": {
        "response": {
          "type": "string",
          "description": "The response string containing the authorization details (JWE-encrypted VP token).\nRequired for success responses, absent for error responses."
        },
        "sendResponse": {
          "type": "boolean",
          "description": "When set to true, the authorization response will be sent to the client."
        },
        "error": {
          "type": "string"
        },
        "error_description": {
          "type": "string",
          "description": "Human-readable description of the error."
        },
        "error_uri": {
          "type": "string",
          "description": "URI with additional information about the error."
        },
        "state": {
          "type": "string",
          "description": "State value from the authorization request (for correlation)."
        }
      },
      "additionalProperties": false
    }
  },
  {
    "uri": "./Object.schema.json",
    "fileMatch": ["a://b/Object*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./Object.schema.json",
      "title": "Object",
      "type": "object",
      "properties": {},
      "additionalProperties": false
    }
  },
  {
    "uri": "./ParResponseDto.schema.json",
    "fileMatch": ["a://b/ParResponseDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./ParResponseDto.schema.json",
      "title": "ParResponseDto",
      "type": "object",
      "properties": {
        "request_uri": {
          "type": "string",
          "description": "The request URI for the Pushed Authorization Request."
        },
        "expires_in": {
          "type": "number",
          "description": "The expiration time for the request URI in seconds."
        }
      },
      "required": ["request_uri", "expires_in"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./InteractiveAuthorizationRequestDto.schema.json",
    "fileMatch": ["a://b/InteractiveAuthorizationRequestDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./InteractiveAuthorizationRequestDto.schema.json",
      "title": "InteractiveAuthorizationRequestDto",
      "type": "object",
      "properties": {
        "response_type": {
          "type": "string",
          "description": "Response type (for initial request)"
        },
        "client_id": {
          "type": "string",
          "description": "Client identifier (for initial request)"
        },
        "interaction_types_supported": {
          "type": "string",
          "description": "Comma-separated list of supported interaction types (for initial request)"
        },
        "redirect_uri": {
          "type": "string",
          "description": "Redirect URI (for initial request)"
        },
        "scope": {
          "type": "string",
          "description": "OAuth scope"
        },
        "code_challenge": {
          "type": "string",
          "description": "PKCE code challenge"
        },
        "code_challenge_method": {
          "type": "string",
          "description": "PKCE code challenge method"
        },
        "authorization_details": {
          "anyOf": [
            {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "type": {
                    "type": "string"
                  },
                  "format": {
                    "type": "string"
                  },
                  "vct": {
                    "type": "string"
                  },
                  "credential_configuration_id": {
                    "type": "string"
                  }
                },
                "required": ["type"],
                "additionalProperties": false
              }
            },
            {
              "type": "string"
            }
          ],
          "description": "Authorization details"
        },
        "state": {
          "type": "string",
          "description": "State parameter"
        },
        "issuer_state": {
          "type": "string",
          "description": "Issuer state from credential offer"
        },
        "auth_session": {
          "type": "string",
          "description": "Auth session identifier (for follow-up request)"
        },
        "openid4vp_response": {
          "type": "string",
          "description": "OpenID4VP response (for follow-up request)"
        },
        "code_verifier": {
          "type": "string",
          "description": "PKCE code verifier (for follow-up request)"
        },
        "request": {
          "type": "string",
          "description": "JAR request JWT (by value)"
        },
        "request_uri": {
          "type": "string",
          "description": "JAR request URI (by reference)"
        }
      },
      "additionalProperties": false
    }
  },
  {
    "uri": "./InteractiveAuthorizationCodeResponseDto.schema.json",
    "fileMatch": ["a://b/InteractiveAuthorizationCodeResponseDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./InteractiveAuthorizationCodeResponseDto.schema.json",
      "title": "InteractiveAuthorizationCodeResponseDto",
      "type": "object",
      "properties": {
        "status": {
          "type": "string",
          "description": "Response status",
          "example": "ok"
        },
        "code": {
          "type": "string",
          "description": "Authorization code",
          "example": "auth-code-123"
        }
      },
      "required": ["status", "code"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./InteractiveAuthorizationErrorResponseDto.schema.json",
    "fileMatch": ["a://b/InteractiveAuthorizationErrorResponseDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./InteractiveAuthorizationErrorResponseDto.schema.json",
      "title": "InteractiveAuthorizationErrorResponseDto",
      "type": "object",
      "properties": {
        "error": {
          "type": "string",
          "description": "OAuth error code",
          "example": "invalid_request"
        },
        "error_description": {
          "type": "string",
          "description": "Human-readable error description",
          "example": "Missing required parameter: interaction_types_supported"
        }
      },
      "required": ["error"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./ChainedAsParResponseDto.schema.json",
    "fileMatch": ["a://b/ChainedAsParResponseDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./ChainedAsParResponseDto.schema.json",
      "title": "ChainedAsParResponseDto",
      "type": "object",
      "properties": {
        "request_uri": {
          "type": "string",
          "description": "The request URI to use at the authorization endpoint",
          "example": "urn:ietf:params:oauth:request_uri:abc123"
        },
        "expires_in": {
          "type": "number",
          "description": "The lifetime of the request URI in seconds",
          "example": 600
        }
      },
      "required": ["request_uri", "expires_in"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./ChainedAsErrorResponseDto.schema.json",
    "fileMatch": ["a://b/ChainedAsErrorResponseDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./ChainedAsErrorResponseDto.schema.json",
      "title": "ChainedAsErrorResponseDto",
      "type": "object",
      "properties": {
        "error": {
          "type": "string",
          "description": "Error code",
          "example": "invalid_request"
        },
        "error_description": {
          "type": "string",
          "description": "Human-readable error description"
        }
      },
      "required": ["error"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./ChainedAsTokenRequestDto.schema.json",
    "fileMatch": ["a://b/ChainedAsTokenRequestDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./ChainedAsTokenRequestDto.schema.json",
      "title": "ChainedAsTokenRequestDto",
      "type": "object",
      "properties": {
        "grant_type": {
          "type": "string",
          "description": "Grant type ('authorization_code' or 'refresh_token')",
          "example": "authorization_code"
        },
        "code": {
          "type": "string",
          "description": "Authorization code received in the callback (authorization_code grant)"
        },
        "refresh_token": {
          "type": "string",
          "description": "Refresh token (refresh_token grant)"
        },
        "client_id": {
          "type": "string",
          "description": "Client identifier"
        },
        "redirect_uri": {
          "type": "string",
          "description": "Redirect URI (must match the one used in PAR)"
        },
        "code_verifier": {
          "type": "string",
          "description": "PKCE code verifier"
        }
      },
      "required": ["grant_type"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./ChainedAsTokenResponseDto.schema.json",
    "fileMatch": ["a://b/ChainedAsTokenResponseDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./ChainedAsTokenResponseDto.schema.json",
      "title": "ChainedAsTokenResponseDto",
      "type": "object",
      "properties": {
        "access_token": {
          "type": "string",
          "description": "The access token"
        },
        "token_type": {
          "type": "string",
          "description": "Token type (Bearer or DPoP)",
          "example": "DPoP"
        },
        "expires_in": {
          "type": "number",
          "description": "Token lifetime in seconds",
          "example": 3600
        },
        "scope": {
          "type": "string",
          "description": "Scope granted"
        },
        "authorization_details": {
          "description": "Authorized credential configurations",
          "type": "array",
          "items": {
            "type": "object"
          }
        },
        "c_nonce": {
          "type": "string",
          "description": "C_NONCE for credential request"
        },
        "c_nonce_expires_in": {
          "type": "number",
          "description": "C_NONCE lifetime in seconds"
        },
        "refresh_token": {
          "type": "string",
          "description": "Refresh token (issued when refresh tokens are enabled)"
        }
      },
      "required": ["access_token", "token_type", "expires_in"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./KmsProviderCapabilitiesDto.schema.json",
    "fileMatch": ["a://b/KmsProviderCapabilitiesDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./KmsProviderCapabilitiesDto.schema.json",
      "title": "KmsProviderCapabilitiesDto",
      "type": "object",
      "properties": {
        "canImport": {
          "type": "boolean",
          "description": "Whether the provider supports importing existing keys.",
          "example": true
        },
        "canCreate": {
          "type": "boolean",
          "description": "Whether the provider supports generating new keys.",
          "example": true
        },
        "canDelete": {
          "type": "boolean",
          "description": "Whether the provider supports deleting keys.",
          "example": true
        },
        "supportedAlgs": {
          "description": "Signing algorithms supported by the provider.",
          "example": ["ES256"],
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "defaultAlg": {
          "type": "string",
          "description": "Default signing algorithm used when caller does not specify one.",
          "example": "ES256"
        }
      },
      "required": ["canImport", "canCreate", "canDelete", "supportedAlgs", "defaultAlg"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./KmsProviderInfoDto.schema.json",
    "fileMatch": ["a://b/KmsProviderInfoDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./KmsProviderInfoDto.schema.json",
      "title": "KmsProviderInfoDto",
      "type": "object",
      "properties": {
        "name": {
          "type": "string",
          "description": "Unique provider ID (matches the id in kms.json).",
          "example": "main-vault"
        },
        "type": {
          "type": "string",
          "description": "Type of the KMS provider (db, vault, aws-kms).",
          "example": "vault"
        },
        "description": {
          "type": "string",
          "description": "Human-readable description of this provider instance.",
          "example": "Production HashiCorp Vault"
        },
        "capabilities": {
          "description": "Capabilities of this provider.",
          "allOf": [
            {
              "$ref": "./KmsProviderCapabilitiesDto.schema.json"
            }
          ]
        }
      },
      "required": ["name", "type", "capabilities"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./KmsProvidersResponseDto.schema.json",
    "fileMatch": ["a://b/KmsProvidersResponseDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./KmsProvidersResponseDto.schema.json",
      "title": "KmsProvidersResponseDto",
      "type": "object",
      "properties": {
        "providers": {
          "description": "Detailed info for each registered KMS provider.",
          "type": "array",
          "items": {
            "$ref": "./KmsProviderInfoDto.schema.json"
          }
        },
        "default": {
          "type": "string",
          "description": "The default KMS provider name.",
          "example": "db"
        }
      },
      "required": ["providers", "default"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./KmsTenantConfigResponseDto.schema.json",
    "fileMatch": ["a://b/KmsTenantConfigResponseDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./KmsTenantConfigResponseDto.schema.json",
      "title": "KmsTenantConfigResponseDto",
      "type": "object",
      "properties": {
        "tenantConfig": {
          "nullable": true,
          "description": "Tenant-specific KMS configuration from <CONFIG_FOLDER>/<tenantId>/kms.json. Null when no tenant file exists.",
          "type": "object",
          "allOf": [
            {
              "$ref": "./KmsConfigDto.schema.json"
            }
          ]
        },
        "effectiveConfig": {
          "description": "Effective configuration used at runtime for the tenant (global + tenant merge).",
          "allOf": [
            {
              "$ref": "./KmsConfigDto.schema.json"
            }
          ]
        }
      },
      "required": ["effectiveConfig"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./CertificateInfoDto.schema.json",
    "fileMatch": ["a://b/CertificateInfoDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./CertificateInfoDto.schema.json",
      "title": "CertificateInfoDto",
      "type": "object",
      "properties": {
        "pem": {
          "type": "string",
          "description": "Certificate in PEM format."
        },
        "subject": {
          "type": "string",
          "description": "Certificate subject (CN)."
        },
        "issuer": {
          "type": "string",
          "description": "Certificate issuer (CN)."
        },
        "notBefore": {
          "format": "date-time",
          "type": "string",
          "description": "Certificate not before date."
        },
        "notAfter": {
          "format": "date-time",
          "type": "string",
          "description": "Certificate not after date."
        },
        "serialNumber": {
          "type": "string",
          "description": "Serial number."
        }
      },
      "required": ["pem"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./PublicKeyInfoDto.schema.json",
    "fileMatch": ["a://b/PublicKeyInfoDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./PublicKeyInfoDto.schema.json",
      "title": "PublicKeyInfoDto",
      "type": "object",
      "properties": {
        "kty": {
          "type": "string",
          "description": "Key type (e.g., EC).",
          "example": "EC"
        },
        "alg": {
          "type": "string",
          "description": "Key algorithm (e.g., ES256).",
          "example": "ES256"
        },
        "kid": {
          "type": "string",
          "description": "Key ID."
        },
        "crv": {
          "type": "string",
          "description": "Curve (for EC keys).",
          "example": "P-256"
        }
      },
      "required": ["kty"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./RotationPolicyResponseDto.schema.json",
    "fileMatch": ["a://b/RotationPolicyResponseDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./RotationPolicyResponseDto.schema.json",
      "title": "RotationPolicyResponseDto",
      "type": "object",
      "properties": {
        "enabled": {
          "type": "boolean",
          "description": "Whether automatic key rotation is enabled."
        },
        "intervalDays": {
          "type": "number",
          "description": "Rotation interval in days."
        },
        "certValidityDays": {
          "type": "number",
          "description": "Certificate validity in days."
        },
        "nextRotationAt": {
          "format": "date-time",
          "type": "string",
          "description": "Next scheduled rotation date."
        }
      },
      "required": ["enabled"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./KeyChainResponseDto.schema.json",
    "fileMatch": ["a://b/KeyChainResponseDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./KeyChainResponseDto.schema.json",
      "title": "KeyChainResponseDto",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "description": "Unique identifier for the key chain."
        },
        "usageType": {
          "enum": ["access", "attestation", "trustList", "statusList", "encrypt"],
          "type": "string",
          "description": "Usage type of the key chain."
        },
        "type": {
          "enum": ["standalone", "internalChain"],
          "type": "string",
          "description": "Type of key chain (standalone or internalChain)."
        },
        "description": {
          "type": "string",
          "description": "Human-readable description."
        },
        "kmsProvider": {
          "type": "string",
          "description": "KMS provider used for this key chain."
        },
        "rootCertificate": {
          "description": "Root CA certificate (only for internalChain type).",
          "allOf": [
            {
              "$ref": "./CertificateInfoDto.schema.json"
            }
          ]
        },
        "activePublicKey": {
          "description": "Active signing key's public key info.",
          "allOf": [
            {
              "$ref": "./PublicKeyInfoDto.schema.json"
            }
          ]
        },
        "activeCertificate": {
          "description": "Active signing key's certificate. Not present for encryption keys.",
          "allOf": [
            {
              "$ref": "./CertificateInfoDto.schema.json"
            }
          ]
        },
        "previousPublicKey": {
          "description": "Previous signing key's public key info (if in grace period).",
          "allOf": [
            {
              "$ref": "./PublicKeyInfoDto.schema.json"
            }
          ]
        },
        "previousCertificate": {
          "description": "Previous signing key's certificate (if in grace period).",
          "allOf": [
            {
              "$ref": "./CertificateInfoDto.schema.json"
            }
          ]
        },
        "previousKeyExpiry": {
          "format": "date-time",
          "type": "string",
          "description": "Previous key expiry date."
        },
        "rotationPolicy": {
          "description": "Rotation policy configuration.",
          "allOf": [
            {
              "$ref": "./RotationPolicyResponseDto.schema.json"
            }
          ]
        },
        "createdAt": {
          "format": "date-time",
          "type": "string",
          "description": "Timestamp when the key chain was created."
        },
        "updatedAt": {
          "format": "date-time",
          "type": "string",
          "description": "Timestamp when the key chain was last updated."
        }
      },
      "required": [
        "id",
        "usageType",
        "type",
        "kmsProvider",
        "activePublicKey",
        "rotationPolicy",
        "createdAt",
        "updatedAt"
      ],
      "additionalProperties": false
    }
  },
  {
    "uri": "./ExportEcJwk.schema.json",
    "fileMatch": ["a://b/ExportEcJwk*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./ExportEcJwk.schema.json",
      "title": "ExportEcJwk",
      "type": "object",
      "properties": {
        "kty": {
          "type": "string",
          "description": "Key type",
          "example": "EC"
        },
        "crv": {
          "type": "string",
          "description": "Curve",
          "example": "P-256"
        },
        "x": {
          "type": "string",
          "description": "X coordinate (base64url)"
        },
        "y": {
          "type": "string",
          "description": "Y coordinate (base64url)"
        },
        "d": {
          "type": "string",
          "description": "Private key (base64url)"
        },
        "alg": {
          "type": "string",
          "description": "Algorithm",
          "example": "ES256"
        },
        "kid": {
          "type": "string",
          "description": "Key ID"
        }
      },
      "required": ["kty", "crv", "x", "y", "d"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./ExportRotationPolicyDto.schema.json",
    "fileMatch": ["a://b/ExportRotationPolicyDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./ExportRotationPolicyDto.schema.json",
      "title": "ExportRotationPolicyDto",
      "type": "object",
      "properties": {
        "enabled": {
          "type": "boolean",
          "description": "Whether rotation is enabled."
        },
        "intervalDays": {
          "type": "number",
          "description": "Rotation interval in days."
        },
        "certValidityDays": {
          "type": "number",
          "description": "Certificate validity in days."
        }
      },
      "required": ["enabled"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./KeyChainExportDto.schema.json",
    "fileMatch": ["a://b/KeyChainExportDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./KeyChainExportDto.schema.json",
      "title": "KeyChainExportDto",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "description": "Key chain ID."
        },
        "description": {
          "type": "string",
          "description": "Human-readable description."
        },
        "usageType": {
          "enum": ["access", "attestation", "trustList", "statusList", "encrypt"],
          "type": "string",
          "description": "Usage type for this key chain."
        },
        "key": {
          "description": "The private key in JWK format (EC).",
          "allOf": [
            {
              "$ref": "./ExportEcJwk.schema.json"
            }
          ]
        },
        "crt": {
          "description": "Certificate chain in PEM format (leaf first, then intermediates/CA).",
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "kmsProvider": {
          "type": "string",
          "description": "KMS provider name."
        },
        "rotationPolicy": {
          "description": "Rotation policy.",
          "allOf": [
            {
              "$ref": "./ExportRotationPolicyDto.schema.json"
            }
          ]
        }
      },
      "required": ["id", "usageType", "key"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./EcJwk.schema.json",
    "fileMatch": ["a://b/EcJwk*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./EcJwk.schema.json",
      "title": "EcJwk",
      "type": "object",
      "properties": {
        "kty": {
          "type": "string"
        },
        "x": {
          "type": "string"
        },
        "y": {
          "type": "string"
        },
        "crv": {
          "type": "string"
        },
        "d": {
          "type": "string"
        },
        "alg": {
          "type": "string"
        },
        "kid": {
          "type": "string"
        }
      },
      "required": ["kty", "x", "y", "crv", "d"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./RotationPolicyImportDto.schema.json",
    "fileMatch": ["a://b/RotationPolicyImportDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./RotationPolicyImportDto.schema.json",
      "title": "RotationPolicyImportDto",
      "type": "object",
      "properties": {
        "enabled": {
          "type": "boolean",
          "description": "Whether rotation is enabled. When true, the imported key becomes a root CA signer.",
          "default": false
        },
        "intervalDays": {
          "type": "number",
          "minimum": 1,
          "maximum": 3650,
          "description": "Rotation interval in days.",
          "example": 90
        },
        "certValidityDays": {
          "type": "number",
          "minimum": 1,
          "maximum": 3650,
          "description": "Certificate validity in days.",
          "example": 365
        }
      },
      "required": ["enabled"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./PresentationRequest.schema.json",
    "fileMatch": ["a://b/PresentationRequest*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./PresentationRequest.schema.json",
      "title": "PresentationRequest",
      "type": "object",
      "properties": {
        "webhook": {
          "properties": {
            "url": {
              "type": "string"
            },
            "auth": {
              "oneOf": [
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "type": "string",
                      "const": "none"
                    }
                  },
                  "required": ["type"],
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "type": "string",
                      "const": "apiKey"
                    },
                    "config": {
                      "type": "object",
                      "properties": {
                        "headerName": {
                          "type": "string"
                        },
                        "value": {
                          "type": "string"
                        }
                      },
                      "required": ["headerName", "value"],
                      "additionalProperties": false
                    }
                  },
                  "required": ["type", "config"],
                  "additionalProperties": false
                }
              ]
            },
            "includeRawTokensFor": {
              "type": "array",
              "items": {
                "type": "string"
              }
            }
          },
          "additionalProperties": false,
          "description": "Webhook configuration to receive the response.\nIf not provided, the configured webhook from the configuration will be used.",
          "allOf": [
            {
              "$ref": "./WebhookConfig.schema.json"
            }
          ]
        },
        "response_type": {
          "anyOf": [
            {
              "type": "string",
              "const": "uri"
            },
            {
              "type": "string",
              "const": "dc-api"
            },
            {
              "type": "string",
              "const": "iso-18013-7"
            }
          ],
          "description": "The type of response expected from the presentation request.",
          "enum": ["uri", "dc-api", "iso-18013-7"]
        },
        "requestId": {
          "type": "string",
          "description": "Identifier of the presentation configuration"
        },
        "redirectUri": {
          "type": "string",
          "description": "Optional redirect URI to which the user-agent should be redirected after the presentation is completed.\nYou can use the `{sessionId}` placeholder in the URI, which will be replaced with the actual session ID.",
          "example": "https://example.com/callback?session={sessionId}"
        },
        "expected_origin": {
          "type": "string",
          "description": "Optional expected browser origin for DC API key-binding audience.\nExample: \"http://localhost:8080\""
        },
        "transaction_data": {
          "items": {
            "type": "object",
            "propertyNames": {
              "type": "string"
            },
            "additionalProperties": {}
          },
          "description": "Optional transaction data to include in the OID4VP request.\nIf provided, this will override the transaction_data from the presentation configuration.",
          "type": "array"
        },
        "skewSeconds": {
          "type": "number",
          "minimum": 0,
          "description": "Optional clock skew tolerance for this presentation offer, in seconds.\nIf provided, this overrides the presentation configuration for the created session."
        }
      },
      "required": ["response_type", "requestId"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./FileUploadDto.schema.json",
    "fileMatch": ["a://b/FileUploadDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "./FileUploadDto.schema.json",
      "title": "FileUploadDto",
      "type": "object",
      "properties": {
        "file": {
          "type": "string",
          "format": "binary"
        }
      },
      "required": ["file"],
      "additionalProperties": false
    }
  },
  {
    "uri": "./AttributeProviderAuth.schema.json",
    "fileMatch": ["a://b/AttributeProviderAuth*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "oneOf": [
        {
          "type": "object",
          "properties": {
            "type": {
              "type": "string",
              "const": "none",
              "description": "Disable authentication for attribute provider calls."
            }
          },
          "required": ["type"],
          "additionalProperties": false,
          "description": "No authentication variant."
        },
        {
          "type": "object",
          "properties": {
            "type": {
              "type": "string",
              "const": "apiKey",
              "description": "Use API key authentication."
            },
            "config": {
              "type": "object",
              "properties": {
                "headerName": {
                  "type": "string",
                  "minLength": 1,
                  "description": "HTTP header name carrying the API key."
                },
                "value": {
                  "type": "string",
                  "minLength": 1,
                  "description": "API key value."
                }
              },
              "required": ["headerName", "value"],
              "additionalProperties": false,
              "description": "API key authentication settings."
            }
          },
          "required": ["type", "config"],
          "additionalProperties": false,
          "description": "API key authentication variant."
        }
      ],
      "description": "Authentication method used to call the attribute provider.",
      "$id": "./AttributeProviderAuth.schema.json",
      "title": "AttributeProviderAuth"
    }
  },
  {
    "uri": "./CertImportDto.schema.json",
    "fileMatch": ["a://b/CertImportDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "id": {
          "description": "Optional certificate id. If omitted, one may be generated.",
          "type": "string",
          "minLength": 1
        },
        "keyId": {
          "description": "Optional key chain id associated with this certificate chain.",
          "type": "string",
          "minLength": 1
        },
        "description": {
          "description": "Optional certificate description.",
          "type": "string"
        },
        "crt": {
          "minItems": 1,
          "type": "array",
          "items": {
            "type": "string",
            "minLength": 1
          },
          "description": "Certificate chain entries, typically PEM-encoded certificates."
        }
      },
      "required": ["crt"],
      "additionalProperties": false,
      "$id": "./CertImportDto.schema.json",
      "title": "CertImportDto"
    }
  },
  {
    "uri": "./CreateAttributeProviderDto.schema.json",
    "fileMatch": ["a://b/CreateAttributeProviderDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "minLength": 1,
          "description": "Unique attribute provider identifier."
        },
        "name": {
          "type": "string",
          "minLength": 1,
          "description": "Display name of the attribute provider."
        },
        "description": {
          "anyOf": [
            {
              "type": "string",
              "minLength": 1
            },
            {
              "type": "null"
            }
          ],
          "description": "Optional attribute provider description."
        },
        "url": {
          "type": "string",
          "format": "uri",
          "description": "Base URL of the attribute provider endpoint."
        },
        "auth": {
          "oneOf": [
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "const": "none",
                  "description": "Disable authentication for attribute provider calls."
                }
              },
              "required": ["type"],
              "additionalProperties": false,
              "description": "No authentication variant."
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "const": "apiKey",
                  "description": "Use API key authentication."
                },
                "config": {
                  "type": "object",
                  "properties": {
                    "headerName": {
                      "type": "string",
                      "minLength": 1,
                      "description": "HTTP header name carrying the API key."
                    },
                    "value": {
                      "type": "string",
                      "minLength": 1,
                      "description": "API key value."
                    }
                  },
                  "required": ["headerName", "value"],
                  "additionalProperties": false,
                  "description": "API key authentication settings."
                }
              },
              "required": ["type", "config"],
              "additionalProperties": false,
              "description": "API key authentication variant."
            }
          ],
          "description": "Authentication configuration for outbound provider requests."
        }
      },
      "required": ["id", "name", "url", "auth"],
      "additionalProperties": false,
      "$id": "./CreateAttributeProviderDto.schema.json",
      "title": "CreateAttributeProviderDto"
    }
  },
  {
    "uri": "./CreateClientDto.schema.json",
    "fileMatch": ["a://b/CreateClientDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "clientId": {
          "type": "string",
          "minLength": 1,
          "pattern": "^[A-Za-z0-9._:-]+$",
          "description": "Unique client identifier."
        },
        "secret": {
          "description": "Optional client secret for confidential clients.",
          "type": "string",
          "minLength": 1
        },
        "description": {
          "description": "Optional human-readable client description.",
          "type": "string",
          "minLength": 1
        },
        "roles": {
          "minItems": 1,
          "type": "array",
          "items": {
            "type": "string",
            "enum": [
              "presentation:manage",
              "presentation:request",
              "issuance:manage",
              "issuance:offer",
              "clients:manage",
              "users:manage",
              "tenants:manage",
              "tenant:admin",
              "registrar:manage"
            ]
          },
          "description": "Roles assigned to the client. At least one role is required."
        },
        "allowedPresentationConfigs": {
          "description": "Optional allow-list of presentation config ids this client can use.",
          "anyOf": [
            {
              "type": "array",
              "items": {
                "type": "string",
                "minLength": 1
              }
            },
            {
              "type": "null"
            }
          ]
        },
        "allowedIssuanceConfigs": {
          "description": "Optional allow-list of issuance config ids this client can use.",
          "anyOf": [
            {
              "type": "array",
              "items": {
                "type": "string",
                "minLength": 1
              }
            },
            {
              "type": "null"
            }
          ]
        }
      },
      "required": ["clientId", "roles"],
      "additionalProperties": false,
      "$id": "./CreateClientDto.schema.json",
      "title": "CreateClientDto"
    }
  },
  {
    "uri": "./CreateRegistrarConfigDto.schema.json",
    "fileMatch": ["a://b/CreateRegistrarConfigDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "registrarUrl": {
          "type": "string",
          "format": "uri",
          "description": "Base URL of the registrar service."
        },
        "oidcUrl": {
          "type": "string",
          "format": "uri",
          "description": "OIDC discovery or issuer URL used for authentication."
        },
        "clientId": {
          "type": "string",
          "minLength": 1,
          "description": "OAuth client ID used against the registrar."
        },
        "clientSecret": {
          "description": "Optional OAuth client secret for registrar authentication.",
          "type": "string",
          "minLength": 1
        },
        "username": {
          "type": "string",
          "minLength": 1,
          "description": "Username used for registrar authentication."
        },
        "password": {
          "type": "string",
          "minLength": 1,
          "description": "Password used for registrar authentication."
        },
        "registrationCertificateDefaults": {
          "description": "Optional default registration certificate values.",
          "anyOf": [
            {
              "type": "object",
              "propertyNames": {
                "type": "string"
              },
              "additionalProperties": {}
            },
            {
              "type": "null"
            }
          ]
        }
      },
      "required": ["registrarUrl", "oidcUrl", "clientId", "username", "password"],
      "additionalProperties": false,
      "$id": "./CreateRegistrarConfigDto.schema.json",
      "title": "CreateRegistrarConfigDto"
    }
  },
  {
    "uri": "./CreateStatusListDto.schema.json",
    "fileMatch": ["a://b/CreateStatusListDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "credentialConfigurationId": {
          "description": "Optional credential configuration binding.",
          "type": "string",
          "minLength": 1
        },
        "keyChainId": {
          "description": "Optional key chain to sign the list with.",
          "type": "string",
          "minLength": 1
        },
        "bits": {
          "description": "Optional bits-per-status value.",
          "anyOf": [
            {
              "type": "number",
              "const": 1
            },
            {
              "type": "number",
              "const": 2
            },
            {
              "type": "number",
              "const": 4
            },
            {
              "type": "number",
              "const": 8
            }
          ]
        },
        "capacity": {
          "description": "Optional status list capacity.",
          "type": "integer",
          "minimum": 1000,
          "maximum": 9007199254740991
        }
      },
      "additionalProperties": false,
      "$id": "./CreateStatusListDto.schema.json",
      "title": "CreateStatusListDto"
    }
  },
  {
    "uri": "./CreateTenantDto.schema.json",
    "fileMatch": ["a://b/CreateTenantDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "minLength": 1,
          "description": "Unique tenant identifier."
        },
        "name": {
          "default": "EUDIPLO",
          "description": "Display name of the tenant.",
          "type": "string",
          "minLength": 1
        },
        "description": {
          "description": "Optional tenant description.",
          "type": "string",
          "minLength": 1
        },
        "roles": {
          "description": "Optional default role assignments for the tenant.",
          "type": "array",
          "items": {
            "type": "string",
            "enum": [
              "tenants:manage",
              "issuance:offer",
              "issuance:manage",
              "presentation:request",
              "presentation:manage",
              "clients:manage",
              "users:manage",
              "registrar:manage",
              "tenant:admin"
            ]
          }
        },
        "sessionConfig": {
          "description": "Optional tenant-specific session storage configuration.",
          "type": "object",
          "properties": {
            "ttlSeconds": {
              "description": "Session time-to-live in seconds.",
              "type": "integer",
              "minimum": 60,
              "maximum": 9007199254740991
            },
            "cleanupMode": {
              "description": "Whether to fully delete or anonymize expired sessions.",
              "type": "string",
              "enum": ["full", "anonymize"]
            }
          },
          "additionalProperties": false
        },
        "statusListConfig": {
          "description": "Optional tenant-specific status list defaults.",
          "type": "object",
          "properties": {
            "capacity": {
              "description": "Default status list capacity.",
              "type": "integer",
              "minimum": 100,
              "maximum": 9007199254740991
            },
            "bits": {
              "description": "Bits-per-status setting (1, 2, 4, or 8).",
              "anyOf": [
                {
                  "type": "number",
                  "const": 1
                },
                {
                  "type": "number",
                  "const": 2
                },
                {
                  "type": "number",
                  "const": 4
                },
                {
                  "type": "number",
                  "const": 8
                }
              ]
            },
            "ttl": {
              "description": "JWT TTL for status list tokens in seconds.",
              "type": "integer",
              "minimum": 60,
              "maximum": 9007199254740991
            },
            "immediateUpdate": {
              "description": "Regenerate status list JWTs immediately after status updates.",
              "type": "boolean"
            },
            "enableAggregation": {
              "description": "Include aggregation_uri in generated status list JWTs.",
              "type": "boolean"
            }
          },
          "additionalProperties": false
        }
      },
      "required": ["id", "name"],
      "additionalProperties": false,
      "description": "Payload for creating a tenant.",
      "$id": "./CreateTenantDto.schema.json",
      "title": "CreateTenantDto"
    }
  },
  {
    "uri": "./CreateWebhookEndpointDto.schema.json",
    "fileMatch": ["a://b/CreateWebhookEndpointDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "minLength": 1,
          "description": "Unique webhook endpoint identifier."
        },
        "name": {
          "type": "string",
          "minLength": 1,
          "description": "Display name of the webhook endpoint."
        },
        "description": {
          "anyOf": [
            {
              "type": "string",
              "minLength": 1
            },
            {
              "type": "null"
            }
          ],
          "description": "Optional webhook endpoint description."
        },
        "url": {
          "type": "string",
          "format": "uri",
          "description": "Destination URL for webhook delivery."
        },
        "auth": {
          "oneOf": [
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "const": "none",
                  "description": "Disable webhook authentication."
                }
              },
              "required": ["type"],
              "additionalProperties": false,
              "description": "No webhook authentication variant."
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "const": "apiKey",
                  "description": "Use API key authentication for webhook requests."
                },
                "config": {
                  "type": "object",
                  "properties": {
                    "headerName": {
                      "type": "string",
                      "minLength": 1,
                      "description": "HTTP header name for the API key."
                    },
                    "value": {
                      "type": "string",
                      "minLength": 1,
                      "description": "API key value sent with webhook requests."
                    }
                  },
                  "required": ["headerName", "value"],
                  "additionalProperties": false,
                  "description": "API key webhook authentication settings."
                }
              },
              "required": ["type", "config"],
              "additionalProperties": false,
              "description": "API key webhook authentication variant."
            }
          ],
          "description": "Authentication configuration applied to outgoing webhook requests."
        }
      },
      "required": ["id", "name", "url", "auth"],
      "additionalProperties": false,
      "$id": "./CreateWebhookEndpointDto.schema.json",
      "title": "CreateWebhookEndpointDto"
    }
  },
  {
    "uri": "./CredentialConfigCreate.schema.json",
    "fileMatch": ["a://b/CredentialConfigCreate*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "minLength": 1,
          "description": "Credential configuration identifier."
        },
        "description": {
          "description": "Optional description for operators and tooling.",
          "anyOf": [
            {
              "type": "string"
            },
            {
              "type": "null"
            }
          ]
        },
        "config": {
          "type": "object",
          "properties": {
            "format": {
              "type": "string",
              "enum": ["mso_mdoc", "dc+sd-jwt"],
              "description": "Credential format emitted by this configuration."
            },
            "display": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "locale": {
                    "type": "string",
                    "minLength": 1,
                    "description": "Locale tag for the display entry."
                  },
                  "name": {
                    "type": "string",
                    "minLength": 1,
                    "description": "Human-readable field name."
                  },
                  "description": {
                    "description": "Optional field description for this locale.",
                    "type": "string"
                  },
                  "background_color": {
                    "description": "Optional background color for card-style rendering.",
                    "type": "string"
                  },
                  "text_color": {
                    "description": "Optional text color for card-style rendering.",
                    "type": "string"
                  },
                  "background_image": {
                    "description": "Optional background image.",
                    "type": "object",
                    "properties": {
                      "uri": {
                        "type": "string",
                        "minLength": 1,
                        "description": "Image URI."
                      }
                    },
                    "required": ["uri"],
                    "additionalProperties": false
                  },
                  "logo": {
                    "description": "Optional logo image.",
                    "type": "object",
                    "properties": {
                      "uri": {
                        "type": "string",
                        "minLength": 1,
                        "description": "Image URI."
                      }
                    },
                    "required": ["uri"],
                    "additionalProperties": false
                  }
                },
                "required": ["locale", "name"],
                "additionalProperties": false
              },
              "description": "Display metadata shown by wallets."
            },
            "scope": {
              "description": "Optional OAuth scope associated with this credential type.",
              "type": "string"
            },
            "docType": {
              "description": "Optional mDoc document type.",
              "type": "string"
            },
            "keyAttestationsRequired": {
              "description": "Optional key attestation requirements.",
              "type": "object",
              "properties": {
                "key_storage": {
                  "description": "Required key storage attestations.",
                  "type": "array",
                  "items": {
                    "type": "string"
                  }
                },
                "user_authentication": {
                  "description": "Required user authentication attestations.",
                  "type": "array",
                  "items": {
                    "type": "string"
                  }
                }
              },
              "additionalProperties": false
            },
            "proofTypesSupported": {
              "description": "Supported proof types for issuance requests.",
              "type": "array",
              "items": {
                "type": "string",
                "enum": ["jwt", "attestation"]
              }
            },
            "credentialReusePolicy": {
              "description": "Optional PID/EAA reuse policy published in credential metadata.",
              "type": "object",
              "properties": {
                "id": {
                  "type": "string",
                  "minLength": 1
                },
                "options": {
                  "type": "array",
                  "items": {
                    "type": "object",
                    "properties": {
                      "details": {
                        "minItems": 1,
                        "type": "array",
                        "items": {
                          "type": "string",
                          "enum": [
                            "once_only",
                            "limited_time",
                            "limited-time",
                            "rotating-batch",
                            "per-relying-party"
                          ]
                        }
                      },
                      "batch_size": {
                        "type": "integer",
                        "minimum": 2,
                        "maximum": 9007199254740991
                      },
                      "reissue_trigger_unused": {
                        "type": "integer",
                        "minimum": 0,
                        "maximum": 9007199254740991
                      },
                      "reissue_trigger_lifetime_left": {
                        "type": "integer",
                        "minimum": 0,
                        "maximum": 9007199254740991
                      }
                    },
                    "required": ["details"],
                    "additionalProperties": false
                  }
                }
              },
              "required": ["id"],
              "additionalProperties": false
            }
          },
          "required": ["format", "display"],
          "additionalProperties": false,
          "description": "Issuer metadata-facing credential configuration."
        },
        "fields": {
          "type": "array",
          "items": {
            "$ref": "#/$defs/__schema0"
          },
          "description": "Claim field definitions for credential issuance."
        },
        "attributeProviderId": {
          "description": "Optional attribute provider id used to resolve claim values.",
          "anyOf": [
            {
              "type": "string"
            },
            {
              "type": "null"
            }
          ]
        },
        "webhookEndpointId": {
          "description": "Optional webhook endpoint id notified during issuance events.",
          "anyOf": [
            {
              "type": "string"
            },
            {
              "type": "null"
            }
          ]
        },
        "vct": {
          "description": "Optional VCT value or structured VCT metadata.",
          "anyOf": [
            {
              "type": "string"
            },
            {
              "type": "object",
              "properties": {
                "vct": {
                  "description": "VCT identifier.",
                  "type": "string"
                },
                "name": {
                  "description": "Human-readable VCT name.",
                  "type": "string"
                },
                "description": {
                  "description": "Optional VCT description.",
                  "type": "string"
                },
                "extends": {
                  "description": "Optional base VCT reference.",
                  "type": "string"
                },
                "extends#integrity": {
                  "description": "Integrity hash for the extends reference.",
                  "type": "string"
                },
                "schema_uri": {
                  "description": "Optional schema URI for the VCT.",
                  "type": "string"
                },
                "schema_uri#integrity": {
                  "description": "Integrity hash for schema_uri.",
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "null"
            }
          ]
        },
        "keyBinding": {
          "description": "Enable key binding requirements.",
          "type": "boolean"
        },
        "keyChainId": {
          "description": "Optional key chain id used for credential signing.",
          "type": "string",
          "minLength": 1
        },
        "statusManagement": {
          "description": "Enable status management for issued credentials.",
          "type": "boolean"
        },
        "iaeActions": {
          "description": "Optional in-app experience actions for wallet flows.",
          "anyOf": [
            {
              "type": "array",
              "items": {
                "oneOf": [
                  {
                    "type": "object",
                    "properties": {
                      "type": {
                        "type": "string",
                        "const": "openid4vp_presentation",
                        "description": "Trigger an OpenID4VP presentation action."
                      },
                      "label": {
                        "description": "Optional UI label for the action.",
                        "type": "string"
                      },
                      "presentationConfigId": {
                        "type": "string",
                        "minLength": 1,
                        "description": "Presentation configuration id to execute."
                      }
                    },
                    "required": ["type", "presentationConfigId"],
                    "additionalProperties": false
                  },
                  {
                    "type": "object",
                    "properties": {
                      "type": {
                        "type": "string",
                        "const": "redirect_to_web",
                        "description": "Trigger a redirect-to-web action."
                      },
                      "label": {
                        "description": "Optional UI label for the action.",
                        "type": "string"
                      },
                      "url": {
                        "type": "string",
                        "format": "uri",
                        "description": "Destination URL for the redirect action."
                      },
                      "callbackUrl": {
                        "description": "Optional callback URL after redirect completion.",
                        "type": "string",
                        "format": "uri"
                      },
                      "description": {
                        "description": "Optional action description.",
                        "type": "string"
                      }
                    },
                    "required": ["type", "url"],
                    "additionalProperties": false
                  }
                ],
                "description": "In-app experience action definitions."
              }
            },
            {
              "type": "null"
            }
          ]
        },
        "sdJwtTrustFormat": {
          "description": "Trust format used for SD-JWT verification metadata.",
          "anyOf": [
            {
              "type": "string",
              "enum": ["x5c", "federation"]
            },
            {
              "type": "null"
            }
          ]
        },
        "lifeTime": {
          "description": "Credential lifetime in seconds.",
          "type": "integer",
          "minimum": 1,
          "maximum": 9007199254740991
        },
        "schemaMeta": {
          "description": "Optional schema metadata and trust bindings.",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "id": {
                  "description": "Optional schema metadata identifier.",
                  "type": "string"
                },
                "name": {
                  "description": "Optional schema metadata name.",
                  "type": "string"
                },
                "version": {
                  "type": "string",
                  "description": "Schema metadata version."
                },
                "rulebookURI": {
                  "description": "Optional rulebook URI reference.",
                  "type": "string"
                },
                "attestationLoS": {
                  "type": "string",
                  "enum": [
                    "iso_18045_high",
                    "iso_18045_moderate",
                    "iso_18045_enhanced-basic",
                    "iso_18045_basic"
                  ],
                  "description": "Assurance level for attestation requirements."
                },
                "bindingType": {
                  "type": "string",
                  "enum": ["claim", "key", "biometric", "none"],
                  "description": "Subject binding type."
                },
                "schemaURIs": {
                  "description": "Optional schema URI entries.",
                  "type": "array",
                  "items": {
                    "type": "object",
                    "properties": {
                      "credentialConfigId": {
                        "description": "Optional credential configuration id this schema URI applies to.",
                        "type": "string"
                      },
                      "format": {
                        "description": "Optional credential format for this schema URI.",
                        "type": "string"
                      },
                      "uri": {
                        "description": "Schema URI reference.",
                        "type": "string"
                      },
                      "meta": {
                        "description": "Optional metadata attached to the schema URI.",
                        "type": "object",
                        "propertyNames": {
                          "type": "string"
                        },
                        "additionalProperties": {}
                      }
                    },
                    "additionalProperties": false
                  }
                },
                "trustedAuthorities": {
                  "description": "Optional trusted authority entries.",
                  "type": "array",
                  "items": {
                    "type": "object",
                    "properties": {
                      "trustListId": {
                        "description": "Optional trust list id.",
                        "type": "string"
                      },
                      "frameworkType": {
                        "description": "Trust framework type.",
                        "type": "string",
                        "enum": ["aki", "etsi_tl", "openid_federation"]
                      },
                      "value": {
                        "description": "Framework-specific authority value.",
                        "type": "string"
                      },
                      "verificationMethod": {
                        "description": "Verification method descriptor.",
                        "anyOf": [
                          {
                            "type": "object",
                            "propertyNames": {
                              "type": "string"
                            },
                            "additionalProperties": {}
                          },
                          {
                            "type": "string"
                          }
                        ]
                      }
                    },
                    "additionalProperties": false
                  }
                }
              },
              "required": ["version", "attestationLoS", "bindingType"],
              "additionalProperties": false
            },
            {
              "type": "null"
            }
          ]
        },
        "embeddedDisclosurePolicy": {
          "description": "Optional embedded disclosure policy.",
          "anyOf": [
            {
              "oneOf": [
                {
                  "type": "object",
                  "properties": {
                    "policy": {
                      "type": "string",
                      "const": "attestationBased",
                      "description": "Attestation-based policy discriminator."
                    },
                    "values": {
                      "type": "array",
                      "items": {
                        "type": "object",
                        "properties": {
                          "claims": {
                            "description": "Claims constraints considered by policy evaluation.",
                            "type": "array",
                            "items": {}
                          },
                          "credentials": {
                            "type": "array",
                            "items": {},
                            "description": "Credential constraints considered by policy evaluation."
                          },
                          "credential_sets": {
                            "description": "Optional credential set constraints.",
                            "type": "array",
                            "items": {}
                          }
                        },
                        "required": ["credentials"],
                        "additionalProperties": false
                      },
                      "description": "Attestation requirements used for policy enforcement."
                    }
                  },
                  "required": ["policy", "values"],
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "policy": {
                      "type": "string",
                      "const": "none",
                      "description": "No disclosure policy enforcement."
                    }
                  },
                  "required": ["policy"],
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "policy": {
                      "type": "string",
                      "const": "allowList",
                      "description": "Allow-list based policy discriminator."
                    },
                    "values": {
                      "type": "array",
                      "items": {
                        "type": "string"
                      },
                      "description": "Allowed values for policy checks."
                    }
                  },
                  "required": ["policy", "values"],
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "policy": {
                      "type": "string",
                      "const": "rootOfTrust",
                      "description": "Root-of-trust policy discriminator."
                    },
                    "values": {
                      "type": "string",
                      "description": "Root-of-trust identifier or reference."
                    }
                  },
                  "required": ["policy", "values"],
                  "additionalProperties": false
                }
              ],
              "description": "Embedded disclosure policy configuration."
            },
            {
              "type": "null"
            }
          ]
        }
      },
      "required": ["id", "config", "fields"],
      "additionalProperties": false,
      "$defs": {
        "__schema0": {
          "type": "object",
          "properties": {
            "path": {
              "type": "array",
              "items": {
                "anyOf": [
                  {
                    "type": "string"
                  },
                  {
                    "type": "number"
                  },
                  {
                    "type": "null"
                  }
                ]
              },
              "description": "Path to this claim inside the credential payload."
            },
            "type": {
              "type": "string",
              "enum": ["string", "number", "integer", "boolean", "object", "array"],
              "description": "Data type of the claim value."
            },
            "defaultValue": {
              "description": "Optional default value for this field."
            },
            "mandatory": {
              "description": "Whether the field is required at issuance time.",
              "type": "boolean"
            },
            "disclosable": {
              "description": "Whether the claim is selectively disclosable.",
              "type": "boolean"
            },
            "namespace": {
              "description": "Optional namespace for claim grouping.",
              "type": "string"
            },
            "display": {
              "description": "Localized display metadata for this field.",
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "locale": {
                    "type": "string",
                    "minLength": 1,
                    "description": "Locale tag for the display entry."
                  },
                  "name": {
                    "type": "string",
                    "minLength": 1,
                    "description": "Human-readable field name."
                  },
                  "description": {
                    "description": "Optional field description for this locale.",
                    "type": "string"
                  }
                },
                "required": ["locale", "name"],
                "additionalProperties": false
              }
            },
            "constraints": {
              "description": "Optional validation constraints for the claim value.",
              "type": "object",
              "propertyNames": {
                "type": "string"
              },
              "additionalProperties": {}
            },
            "children": {
              "description": "Nested child claim definitions for object or array fields.",
              "type": "array",
              "items": {
                "$ref": "#/$defs/__schema0"
              }
            }
          },
          "required": ["path", "type"],
          "additionalProperties": false
        }
      },
      "$id": "./CredentialConfigCreate.schema.json",
      "title": "CredentialConfigCreate"
    }
  },
  {
    "uri": "./DCQL.schema.json",
    "fileMatch": ["a://b/DCQL*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "credentials": {
          "minItems": 1,
          "type": "array",
          "items": {
            "oneOf": [
              {
                "type": "object",
                "properties": {
                  "id": {
                    "type": "string",
                    "minLength": 1,
                    "pattern": "^[A-Za-z0-9_-]+$",
                    "description": "Credential query identifier."
                  },
                  "multiple": {
                    "description": "Allow multiple matching credentials.",
                    "type": "boolean"
                  },
                  "claim_sets": {
                    "description": "Optional claim set constraints.",
                    "type": "array",
                    "items": {
                      "type": "array",
                      "items": {
                        "type": "string"
                      }
                    }
                  },
                  "trusted_authorities": {
                    "description": "Optional trusted authority constraints.",
                    "type": "array",
                    "items": {
                      "oneOf": [
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "type": "string",
                              "const": "etsi_tl",
                              "description": "Trusted authority type discriminator for ETSI trust lists."
                            },
                            "values": {
                              "type": "array",
                              "items": {
                                "type": "object",
                                "properties": {
                                  "trustListId": {
                                    "description": "Optional trust list id reference.",
                                    "type": "string"
                                  },
                                  "url": {
                                    "description": "Optional trust list URL reference.",
                                    "anyOf": [
                                      {
                                        "type": "string",
                                        "format": "uri"
                                      },
                                      {
                                        "type": "string",
                                        "pattern": "^<TENANT_URL>(?:\\/.*)?$"
                                      }
                                    ]
                                  },
                                  "verifierKey": {
                                    "description": "Optional verifier key material.",
                                    "type": "object",
                                    "propertyNames": {
                                      "type": "string"
                                    },
                                    "additionalProperties": {}
                                  },
                                  "verifierX509Der": {
                                    "description": "Optional verifier certificate in DER/base64 form.",
                                    "type": "string"
                                  }
                                },
                                "additionalProperties": false
                              },
                              "description": "Trust list references for ETSI TL verification."
                            }
                          },
                          "required": ["type", "values"],
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "type": "string",
                              "const": "openid_federation",
                              "description": "Trusted authority type discriminator for OpenID Federation."
                            },
                            "values": {
                              "type": "array",
                              "items": {
                                "type": "string"
                              },
                              "description": "OpenID Federation authority identifiers."
                            }
                          },
                          "required": ["type", "values"],
                          "additionalProperties": false
                        }
                      ]
                    }
                  },
                  "format": {
                    "type": "string",
                    "const": "dc+sd-jwt",
                    "description": "Credential format discriminator."
                  },
                  "meta": {
                    "type": "object",
                    "properties": {
                      "vct_values": {
                        "minItems": 1,
                        "type": "array",
                        "items": {
                          "type": "string"
                        },
                        "description": "Accepted VCT values."
                      }
                    },
                    "required": ["vct_values"],
                    "additionalProperties": false
                  },
                  "claims": {
                    "description": "Optional claim-level constraints.",
                    "type": "array",
                    "items": {
                      "type": "object",
                      "properties": {
                        "id": {
                          "description": "Optional claim query id.",
                          "type": "string"
                        },
                        "path": {
                          "type": "array",
                          "items": {
                            "anyOf": [
                              {
                                "type": "string"
                              },
                              {
                                "type": "number"
                              }
                            ]
                          },
                          "description": "Path to the claim value in presented credentials."
                        },
                        "values": {
                          "description": "Optional allowed values for the claim.",
                          "type": "array",
                          "items": {
                            "type": "string"
                          }
                        }
                      },
                      "required": ["path"],
                      "additionalProperties": false
                    }
                  }
                },
                "required": ["id", "format", "meta"],
                "additionalProperties": false
              },
              {
                "type": "object",
                "properties": {
                  "id": {
                    "type": "string",
                    "minLength": 1,
                    "pattern": "^[A-Za-z0-9_-]+$",
                    "description": "Credential query identifier."
                  },
                  "multiple": {
                    "description": "Allow multiple matching credentials.",
                    "type": "boolean"
                  },
                  "claim_sets": {
                    "description": "Optional claim set constraints.",
                    "type": "array",
                    "items": {
                      "type": "array",
                      "items": {
                        "type": "string"
                      }
                    }
                  },
                  "trusted_authorities": {
                    "description": "Optional trusted authority constraints.",
                    "type": "array",
                    "items": {
                      "oneOf": [
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "type": "string",
                              "const": "etsi_tl",
                              "description": "Trusted authority type discriminator for ETSI trust lists."
                            },
                            "values": {
                              "type": "array",
                              "items": {
                                "type": "object",
                                "properties": {
                                  "trustListId": {
                                    "description": "Optional trust list id reference.",
                                    "type": "string"
                                  },
                                  "url": {
                                    "description": "Optional trust list URL reference.",
                                    "anyOf": [
                                      {
                                        "type": "string",
                                        "format": "uri"
                                      },
                                      {
                                        "type": "string",
                                        "pattern": "^<TENANT_URL>(?:\\/.*)?$"
                                      }
                                    ]
                                  },
                                  "verifierKey": {
                                    "description": "Optional verifier key material.",
                                    "type": "object",
                                    "propertyNames": {
                                      "type": "string"
                                    },
                                    "additionalProperties": {}
                                  },
                                  "verifierX509Der": {
                                    "description": "Optional verifier certificate in DER/base64 form.",
                                    "type": "string"
                                  }
                                },
                                "additionalProperties": false
                              },
                              "description": "Trust list references for ETSI TL verification."
                            }
                          },
                          "required": ["type", "values"],
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "type": "string",
                              "const": "openid_federation",
                              "description": "Trusted authority type discriminator for OpenID Federation."
                            },
                            "values": {
                              "type": "array",
                              "items": {
                                "type": "string"
                              },
                              "description": "OpenID Federation authority identifiers."
                            }
                          },
                          "required": ["type", "values"],
                          "additionalProperties": false
                        }
                      ]
                    }
                  },
                  "format": {
                    "type": "string",
                    "const": "mso_mdoc",
                    "description": "Credential format discriminator."
                  },
                  "meta": {
                    "type": "object",
                    "properties": {
                      "doctype_value": {
                        "type": "string",
                        "minLength": 1,
                        "description": "Expected mDoc doctype value."
                      }
                    },
                    "required": ["doctype_value"],
                    "additionalProperties": false
                  },
                  "claims": {
                    "description": "Optional mDoc claim-level constraints.",
                    "type": "array",
                    "items": {
                      "type": "object",
                      "properties": {
                        "id": {
                          "description": "Optional claim query id.",
                          "type": "string"
                        },
                        "path": {
                          "type": "array",
                          "items": {
                            "anyOf": [
                              {
                                "type": "string"
                              },
                              {
                                "type": "number"
                              }
                            ]
                          },
                          "description": "Path to the claim value in presented credentials."
                        },
                        "values": {
                          "description": "Optional allowed values for the claim.",
                          "type": "array",
                          "items": {
                            "type": "string"
                          }
                        },
                        "intent_to_retain": {
                          "description": "Whether relying party intends to retain the claim.",
                          "type": "boolean"
                        }
                      },
                      "required": ["path"],
                      "additionalProperties": false
                    }
                  }
                },
                "required": ["id", "format", "meta"],
                "additionalProperties": false
              }
            ]
          },
          "description": "Credential queries requested by the verifier."
        },
        "credential_sets": {
          "description": "Optional higher-level credential set requirements.",
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "options": {
                "minItems": 1,
                "type": "array",
                "items": {
                  "minItems": 1,
                  "type": "array",
                  "items": {
                    "type": "string"
                  }
                },
                "description": "Alternative credential query id combinations."
              },
              "required": {
                "description": "Whether this credential set is mandatory.",
                "type": "boolean"
              }
            },
            "required": ["options"],
            "additionalProperties": false
          }
        }
      },
      "required": ["credentials"],
      "additionalProperties": false,
      "$id": "./DCQL.schema.json",
      "title": "DCQL"
    }
  },
  {
    "uri": "./EmbeddedDisclosurePolicy.schema.json",
    "fileMatch": ["a://b/EmbeddedDisclosurePolicy*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "oneOf": [
        {
          "type": "object",
          "properties": {
            "policy": {
              "type": "string",
              "const": "attestationBased",
              "description": "Attestation-based policy discriminator."
            },
            "values": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "claims": {
                    "description": "Claims constraints considered by policy evaluation.",
                    "type": "array",
                    "items": {}
                  },
                  "credentials": {
                    "type": "array",
                    "items": {},
                    "description": "Credential constraints considered by policy evaluation."
                  },
                  "credential_sets": {
                    "description": "Optional credential set constraints.",
                    "type": "array",
                    "items": {}
                  }
                },
                "required": ["credentials"],
                "additionalProperties": false
              },
              "description": "Attestation requirements used for policy enforcement."
            }
          },
          "required": ["policy", "values"],
          "additionalProperties": false
        },
        {
          "type": "object",
          "properties": {
            "policy": {
              "type": "string",
              "const": "none",
              "description": "No disclosure policy enforcement."
            }
          },
          "required": ["policy"],
          "additionalProperties": false
        },
        {
          "type": "object",
          "properties": {
            "policy": {
              "type": "string",
              "const": "allowList",
              "description": "Allow-list based policy discriminator."
            },
            "values": {
              "type": "array",
              "items": {
                "type": "string"
              },
              "description": "Allowed values for policy checks."
            }
          },
          "required": ["policy", "values"],
          "additionalProperties": false
        },
        {
          "type": "object",
          "properties": {
            "policy": {
              "type": "string",
              "const": "rootOfTrust",
              "description": "Root-of-trust policy discriminator."
            },
            "values": {
              "type": "string",
              "description": "Root-of-trust identifier or reference."
            }
          },
          "required": ["policy", "values"],
          "additionalProperties": false
        }
      ],
      "description": "Embedded disclosure policy configuration.",
      "$id": "./EmbeddedDisclosurePolicy.schema.json",
      "title": "EmbeddedDisclosurePolicy"
    }
  },
  {
    "uri": "./ImportTenantDto.schema.json",
    "fileMatch": ["a://b/ImportTenantDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "name": {
          "default": "EUDIPLO",
          "description": "Display name of the tenant.",
          "type": "string",
          "minLength": 1
        },
        "description": {
          "description": "Optional tenant description.",
          "type": "string",
          "minLength": 1
        },
        "sessionConfig": {
          "description": "Optional tenant-specific session storage configuration.",
          "type": "object",
          "properties": {
            "ttlSeconds": {
              "description": "Session time-to-live in seconds.",
              "type": "integer",
              "minimum": 60,
              "maximum": 9007199254740991
            },
            "cleanupMode": {
              "description": "Whether to fully delete or anonymize expired sessions.",
              "type": "string",
              "enum": ["full", "anonymize"]
            }
          },
          "additionalProperties": false
        },
        "statusListConfig": {
          "description": "Optional tenant-specific status list defaults.",
          "type": "object",
          "properties": {
            "capacity": {
              "description": "Default status list capacity.",
              "type": "integer",
              "minimum": 100,
              "maximum": 9007199254740991
            },
            "bits": {
              "description": "Bits-per-status setting (1, 2, 4, or 8).",
              "anyOf": [
                {
                  "type": "number",
                  "const": 1
                },
                {
                  "type": "number",
                  "const": 2
                },
                {
                  "type": "number",
                  "const": 4
                },
                {
                  "type": "number",
                  "const": 8
                }
              ]
            },
            "ttl": {
              "description": "JWT TTL for status list tokens in seconds.",
              "type": "integer",
              "minimum": 60,
              "maximum": 9007199254740991
            },
            "immediateUpdate": {
              "description": "Regenerate status list JWTs immediately after status updates.",
              "type": "boolean"
            },
            "enableAggregation": {
              "description": "Include aggregation_uri in generated status list JWTs.",
              "type": "boolean"
            }
          },
          "additionalProperties": false
        }
      },
      "required": ["name"],
      "additionalProperties": false,
      "description": "Payload used when importing tenant metadata from config files.",
      "$id": "./ImportTenantDto.schema.json",
      "title": "ImportTenantDto"
    }
  },
  {
    "uri": "./IssuanceConfig.schema.json",
    "fileMatch": ["a://b/IssuanceConfig*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "batchSize": {
          "description": "Optional issuance batch size.",
          "type": "integer",
          "minimum": 1,
          "maximum": 9007199254740991
        },
        "dPopRequired": {
          "description": "Require DPoP proofs for issuance endpoints.",
          "type": "boolean"
        },
        "walletAttestationRequired": {
          "description": "Require wallet attestation in issuance flows.",
          "type": "boolean"
        },
        "walletProviderTrustLists": {
          "description": "Optional wallet provider trust list references.",
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "url": {
                "type": "string",
                "format": "uri",
                "description": "URL of the wallet provider trust list."
              },
              "verifierKey": {
                "description": "Optional verifier key material used for trust list verification.",
                "type": "object",
                "propertyNames": {
                  "type": "string"
                },
                "additionalProperties": {}
              },
              "verifierX509Der": {
                "description": "Optional verifier certificate in DER/base64 form.",
                "type": "string"
              }
            },
            "required": ["url"],
            "additionalProperties": false
          }
        },
        "signingKeyId": {
          "description": "Default signing key chain id for credential issuance.",
          "type": "string",
          "minLength": 1
        },
        "authorizationServers": {
          "minItems": 1,
          "type": "array",
          "items": {
            "oneOf": [
              {
                "type": "object",
                "properties": {
                  "type": {
                    "type": "string",
                    "const": "external",
                    "description": "Use an externally managed authorization server."
                  },
                  "id": {
                    "type": "string",
                    "minLength": 1,
                    "description": "Authorization server identifier."
                  },
                  "issuer": {
                    "type": "string",
                    "format": "uri",
                    "description": "Issuer URL for the external authorization server."
                  },
                  "sessionBinding": {
                    "description": "Explicit mapping from an external access-token claim to an existing issuance session.",
                    "type": "object",
                    "properties": {
                      "method": {
                        "type": "string",
                        "const": "access_token_claim",
                        "description": "Read the correlation value from a configured access-token claim."
                      },
                      "claim": {
                        "type": "string",
                        "minLength": 1,
                        "description": "Claim name that contains the issuance-session correlation value."
                      }
                    },
                    "required": ["method", "claim"],
                    "additionalProperties": false
                  },
                  "label": {
                    "description": "Optional display label for UI selection.",
                    "type": "string"
                  },
                  "enabled": {
                    "description": "Whether this authorization server entry is enabled.",
                    "type": "boolean"
                  }
                },
                "required": ["type", "id", "issuer"],
                "additionalProperties": false
              },
              {
                "type": "object",
                "properties": {
                  "type": {
                    "type": "string",
                    "const": "oid4vp",
                    "description": "Use OID4VP-based authorization server chaining."
                  },
                  "id": {
                    "type": "string",
                    "minLength": 1,
                    "description": "Authorization server identifier."
                  },
                  "presentationConfigId": {
                    "type": "string",
                    "minLength": 1,
                    "description": "Presentation configuration id used during authorization."
                  },
                  "immediateWalletRedirect": {
                    "description": "Redirect wallets immediately after authorization response creation.",
                    "type": "boolean"
                  },
                  "token": {
                    "description": "Optional token issuance settings.",
                    "type": "object",
                    "properties": {
                      "lifetimeSeconds": {
                        "description": "Access token lifetime in seconds.",
                        "type": "number",
                        "minimum": 60
                      },
                      "signingKeyId": {
                        "description": "Optional key chain id used to sign issued tokens.",
                        "type": "string",
                        "minLength": 1
                      },
                      "refreshTokenEnabled": {
                        "description": "Enable issuing refresh tokens.",
                        "type": "boolean"
                      },
                      "refreshTokenExpiresInSeconds": {
                        "description": "Refresh token lifetime in seconds.",
                        "type": "number",
                        "minimum": 60
                      }
                    },
                    "additionalProperties": false
                  },
                  "requireDPoP": {
                    "description": "Require DPoP proofs for token/credential requests.",
                    "type": "boolean"
                  },
                  "label": {
                    "description": "Optional display label for UI selection.",
                    "type": "string"
                  },
                  "enabled": {
                    "description": "Whether this authorization server entry is enabled.",
                    "type": "boolean"
                  }
                },
                "required": ["type", "id", "presentationConfigId"],
                "additionalProperties": false
              },
              {
                "type": "object",
                "properties": {
                  "type": {
                    "type": "string",
                    "const": "chained",
                    "description": "Use upstream OIDC as authorization source."
                  },
                  "id": {
                    "type": "string",
                    "minLength": 1,
                    "description": "Authorization server identifier."
                  },
                  "upstream": {
                    "type": "object",
                    "properties": {
                      "issuer": {
                        "type": "string",
                        "format": "uri",
                        "description": "Upstream OIDC issuer URL."
                      },
                      "clientId": {
                        "type": "string",
                        "minLength": 1,
                        "description": "Client id for upstream OIDC authentication."
                      },
                      "clientSecret": {
                        "description": "Optional client secret for upstream OIDC authentication.",
                        "type": "string",
                        "minLength": 1
                      },
                      "scopes": {
                        "description": "Optional scopes requested from the upstream issuer.",
                        "type": "array",
                        "items": {
                          "type": "string",
                          "minLength": 1
                        }
                      }
                    },
                    "required": ["issuer", "clientId"],
                    "additionalProperties": false,
                    "description": "Upstream OIDC connection settings."
                  },
                  "token": {
                    "description": "Optional token issuance settings.",
                    "type": "object",
                    "properties": {
                      "lifetimeSeconds": {
                        "description": "Access token lifetime in seconds.",
                        "type": "number",
                        "minimum": 60
                      },
                      "signingKeyId": {
                        "description": "Optional key chain id used to sign issued tokens.",
                        "type": "string",
                        "minLength": 1
                      },
                      "refreshTokenEnabled": {
                        "description": "Enable issuing refresh tokens.",
                        "type": "boolean"
                      },
                      "refreshTokenExpiresInSeconds": {
                        "description": "Refresh token lifetime in seconds.",
                        "type": "number",
                        "minimum": 60
                      }
                    },
                    "additionalProperties": false
                  },
                  "requireDPoP": {
                    "description": "Require DPoP proofs for token/credential requests.",
                    "type": "boolean"
                  },
                  "label": {
                    "description": "Optional display label for UI selection.",
                    "type": "string"
                  },
                  "enabled": {
                    "description": "Whether this authorization server entry is enabled.",
                    "type": "boolean"
                  }
                },
                "required": ["type", "id", "upstream"],
                "additionalProperties": false
              },
              {
                "type": "object",
                "properties": {
                  "type": {
                    "type": "string",
                    "const": "built-in",
                    "description": "Use EUDIPLO built-in authorization server."
                  },
                  "id": {
                    "type": "string",
                    "minLength": 1,
                    "description": "Authorization server identifier."
                  },
                  "token": {
                    "description": "Optional token issuance settings.",
                    "type": "object",
                    "properties": {
                      "lifetimeSeconds": {
                        "description": "Access token lifetime in seconds.",
                        "type": "number",
                        "minimum": 60
                      },
                      "signingKeyId": {
                        "description": "Optional key chain id used to sign issued tokens.",
                        "type": "string",
                        "minLength": 1
                      },
                      "refreshTokenEnabled": {
                        "description": "Enable issuing refresh tokens.",
                        "type": "boolean"
                      },
                      "refreshTokenExpiresInSeconds": {
                        "description": "Refresh token lifetime in seconds.",
                        "type": "number",
                        "minimum": 60
                      }
                    },
                    "additionalProperties": false
                  },
                  "requireDPoP": {
                    "description": "Require DPoP proofs for token/credential requests.",
                    "type": "boolean"
                  },
                  "label": {
                    "description": "Optional display label for UI selection.",
                    "type": "string"
                  },
                  "enabled": {
                    "description": "Whether this authorization server entry is enabled.",
                    "type": "boolean"
                  }
                },
                "required": ["type", "id"],
                "additionalProperties": false
              }
            ],
            "description": "Supported authorization server configurations."
          },
          "description": "Configured authorization server entries."
        },
        "federation": {
          "description": "Optional OpenID Federation settings.",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "role": {
                  "description": "Federation role for this issuer.",
                  "type": "string",
                  "enum": ["trust_anchor", "intermediate", "leaf"]
                },
                "mode": {
                  "description": "Federation operation mode.",
                  "type": "string",
                  "enum": ["federation-only", "hybrid"]
                },
                "entityId": {
                  "description": "Optional local federation entity id.",
                  "type": "string"
                },
                "enforceSigningPolicy": {
                  "description": "Enforce strict signing policy checks.",
                  "type": "boolean"
                },
                "cacheTtlSeconds": {
                  "description": "Cache time-to-live for federation metadata in seconds.",
                  "type": "integer",
                  "minimum": 1,
                  "maximum": 9007199254740991
                },
                "trustAnchors": {
                  "type": "array",
                  "items": {
                    "type": "object",
                    "properties": {
                      "entityId": {
                        "type": "string",
                        "minLength": 1,
                        "description": "Federation trust anchor entity id."
                      },
                      "entityConfigurationUri": {
                        "type": "string",
                        "format": "uri",
                        "description": "Entity configuration URI for the trust anchor."
                      }
                    },
                    "required": ["entityId", "entityConfigurationUri"],
                    "additionalProperties": false
                  },
                  "description": "Federation trust anchors."
                }
              },
              "required": ["trustAnchors"],
              "additionalProperties": false
            },
            {
              "type": "null"
            }
          ]
        },
        "registrationCertificate": {
          "description": "Optional registration certificate settings.",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "enabled": {
                  "description": "Enable issuer registration certificate support.",
                  "type": "boolean"
                },
                "mode": {
                  "description": "How registration certificate data is provided.",
                  "type": "string",
                  "enum": ["import", "generate"]
                },
                "jwt": {
                  "description": "Optional registration certificate JWT when using import mode.",
                  "type": "string"
                },
                "privacyPolicy": {
                  "description": "Optional privacy policy URI.",
                  "type": "string"
                },
                "supportUri": {
                  "description": "Optional support URI.",
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "null"
            }
          ]
        },
        "display": {
          "description": "Localized issuer metadata shown to wallets.",
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "name": {
                "description": "Issuer display name.",
                "type": "string"
              },
              "locale": {
                "description": "Locale tag for this display entry.",
                "type": "string"
              },
              "logo": {
                "description": "Optional issuer logo metadata.",
                "type": "object",
                "properties": {
                  "uri": {
                    "type": "string",
                    "minLength": 1,
                    "description": "Logo URI."
                  },
                  "alt_text": {
                    "description": "Optional localized alternative text.",
                    "type": "string"
                  }
                },
                "required": ["uri"],
                "additionalProperties": {}
              }
            },
            "additionalProperties": {}
          }
        },
        "notificationEndpointEnabled": {
          "description": "Whether the OID4VCI notification endpoint is exposed for this issuance configuration.",
          "type": "boolean"
        },
        "credentialResponseEncryption": {
          "description": "Enable encrypted credential responses.",
          "type": "boolean"
        },
        "credentialRequestEncryption": {
          "description": "Require encrypted credential requests.",
          "type": "boolean"
        },
        "txCodeMaxAttempts": {
          "description": "Maximum verification attempts for transaction codes. Null resets to defaults.",
          "anyOf": [
            {
              "type": "integer",
              "minimum": 1,
              "maximum": 9007199254740991
            },
            {
              "type": "null"
            }
          ]
        }
      },
      "required": ["authorizationServers"],
      "additionalProperties": false,
      "$id": "./IssuanceConfig.schema.json",
      "title": "IssuanceConfig"
    }
  },
  {
    "uri": "./KeyChainConfigFile.schema.json",
    "fileMatch": ["a://b/KeyChainConfigFile*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "anyOf": [
        {
          "type": "object",
          "properties": {
            "id": {
              "description": "Optional key chain id. If omitted, one is generated.",
              "type": "string"
            },
            "key": {
              "type": "object",
              "properties": {
                "kty": {
                  "type": "string",
                  "description": "Key type (for example EC)."
                },
                "x": {
                  "type": "string",
                  "description": "Elliptic curve public x coordinate."
                },
                "y": {
                  "type": "string",
                  "description": "Elliptic curve public y coordinate."
                },
                "crv": {
                  "type": "string",
                  "description": "Elliptic curve name."
                },
                "d": {
                  "type": "string",
                  "description": "Private key value."
                },
                "alg": {
                  "description": "Optional algorithm hint.",
                  "type": "string"
                },
                "kid": {
                  "description": "Optional key identifier.",
                  "type": "string"
                }
              },
              "required": ["kty", "x", "y", "crv", "d"],
              "additionalProperties": false,
              "description": "Private key material in JWK format."
            },
            "description": {
              "description": "Optional key chain description.",
              "type": "string"
            },
            "usageType": {
              "type": "string",
              "enum": ["access", "attestation", "trustList", "statusList", "encrypt"],
              "description": "Key usage category for the imported key chain."
            },
            "crt": {
              "description": "Optional certificate chain values in PEM or base64 DER.",
              "type": "array",
              "items": {
                "type": "string"
              }
            },
            "kmsProvider": {
              "description": "Optional KMS provider id.",
              "type": "string"
            },
            "rotationPolicy": {
              "description": "Optional rotation policy for imported key chains.",
              "type": "object",
              "properties": {
                "enabled": {
                  "type": "boolean",
                  "description": "Enable automatic rotation for imported key chains."
                },
                "intervalDays": {
                  "description": "Rotation interval in days.",
                  "type": "number",
                  "minimum": 1,
                  "maximum": 3650
                },
                "certValidityDays": {
                  "description": "Certificate validity period in days.",
                  "type": "number",
                  "minimum": 1,
                  "maximum": 3650
                }
              },
              "required": ["enabled"],
              "additionalProperties": false
            }
          },
          "required": ["key", "usageType"],
          "additionalProperties": false
        },
        {
          "type": "object",
          "properties": {
            "apiVersion": {
              "type": "string",
              "const": "eudiplo.io/key-chain/v2"
            },
            "kind": {
              "type": "string",
              "const": "KeyChain"
            },
            "metadata": {
              "type": "object",
              "properties": {
                "id": {
                  "type": "string"
                },
                "generation": {
                  "type": "number"
                },
                "ownership": {
                  "type": "string",
                  "enum": ["unmanaged", "file-managed"]
                }
              },
              "required": ["id"],
              "additionalProperties": false
            },
            "spec": {
              "type": "object",
              "properties": {
                "id": {
                  "type": "string"
                },
                "description": {
                  "type": "string"
                },
                "usageType": {
                  "type": "string",
                  "enum": ["access", "attestation", "trustList", "statusList", "encrypt"]
                },
                "keySource": {
                  "oneOf": [
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "type": "string",
                          "const": "private-jwk"
                        },
                        "jwk": {
                          "type": "object",
                          "properties": {
                            "kty": {
                              "type": "string",
                              "description": "Key type (for example EC)."
                            },
                            "x": {
                              "type": "string",
                              "description": "Elliptic curve public x coordinate."
                            },
                            "y": {
                              "type": "string",
                              "description": "Elliptic curve public y coordinate."
                            },
                            "crv": {
                              "type": "string",
                              "description": "Elliptic curve name."
                            },
                            "d": {
                              "type": "string",
                              "description": "Private key value."
                            },
                            "alg": {
                              "description": "Optional algorithm hint.",
                              "type": "string"
                            },
                            "kid": {
                              "description": "Optional key identifier.",
                              "type": "string"
                            }
                          },
                          "required": ["kty", "x", "y", "crv", "d"],
                          "additionalProperties": false
                        },
                        "activeJwk": {
                          "type": "object",
                          "properties": {
                            "kty": {
                              "type": "string",
                              "description": "Key type (for example EC)."
                            },
                            "x": {
                              "type": "string",
                              "description": "Elliptic curve public x coordinate."
                            },
                            "y": {
                              "type": "string",
                              "description": "Elliptic curve public y coordinate."
                            },
                            "crv": {
                              "type": "string",
                              "description": "Elliptic curve name."
                            },
                            "d": {
                              "type": "string",
                              "description": "Private key value."
                            },
                            "alg": {
                              "description": "Optional algorithm hint.",
                              "type": "string"
                            },
                            "kid": {
                              "description": "Optional key identifier.",
                              "type": "string"
                            }
                          },
                          "required": ["kty", "x", "y", "crv", "d"],
                          "additionalProperties": false
                        }
                      },
                      "required": ["type", "jwk"],
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "type": "string",
                          "const": "external-reference"
                        },
                        "provider": {
                          "type": "string"
                        },
                        "externalKeyId": {
                          "type": "string"
                        },
                        "publicJwk": {
                          "type": "object",
                          "properties": {
                            "kty": {
                              "type": "string"
                            },
                            "x": {
                              "type": "string"
                            },
                            "y": {
                              "type": "string"
                            },
                            "crv": {
                              "type": "string"
                            },
                            "alg": {
                              "type": "string"
                            },
                            "kid": {
                              "type": "string"
                            }
                          },
                          "required": ["kty", "x", "y", "crv"],
                          "additionalProperties": false
                        },
                        "activeExternalKeyId": {
                          "type": "string"
                        },
                        "activePublicJwk": {
                          "type": "object",
                          "properties": {
                            "kty": {
                              "type": "string"
                            },
                            "x": {
                              "type": "string"
                            },
                            "y": {
                              "type": "string"
                            },
                            "crv": {
                              "type": "string"
                            },
                            "alg": {
                              "type": "string"
                            },
                            "kid": {
                              "type": "string"
                            }
                          },
                          "required": ["kty", "x", "y", "crv"],
                          "additionalProperties": false
                        }
                      },
                      "required": ["type", "provider", "externalKeyId", "publicJwk"],
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "type": "string",
                          "const": "required"
                        },
                        "publicJwk": {
                          "type": "object",
                          "properties": {
                            "kty": {
                              "type": "string"
                            },
                            "x": {
                              "type": "string"
                            },
                            "y": {
                              "type": "string"
                            },
                            "crv": {
                              "type": "string"
                            },
                            "alg": {
                              "type": "string"
                            },
                            "kid": {
                              "type": "string"
                            }
                          },
                          "required": ["kty", "x", "y", "crv"],
                          "additionalProperties": false
                        }
                      },
                      "required": ["type"],
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "type": "string",
                          "const": "regenerate"
                        },
                        "keyChainType": {
                          "type": "string",
                          "enum": ["standalone", "internalChain"]
                        }
                      },
                      "required": ["type"],
                      "additionalProperties": false
                    }
                  ]
                },
                "crt": {
                  "type": "array",
                  "items": {
                    "type": "string"
                  }
                },
                "kmsProvider": {
                  "type": "string"
                },
                "rotationPolicy": {
                  "type": "object",
                  "properties": {
                    "enabled": {
                      "type": "boolean"
                    },
                    "intervalDays": {
                      "anyOf": [
                        {
                          "type": "number",
                          "minimum": 1,
                          "maximum": 3650
                        },
                        {
                          "type": "null"
                        }
                      ]
                    },
                    "certValidityDays": {
                      "anyOf": [
                        {
                          "type": "number",
                          "minimum": 1,
                          "maximum": 3650
                        },
                        {
                          "type": "null"
                        }
                      ]
                    }
                  },
                  "required": ["enabled"],
                  "additionalProperties": false
                }
              },
              "required": ["usageType", "keySource"],
              "additionalProperties": false
            }
          },
          "required": ["apiVersion", "kind", "metadata", "spec"],
          "additionalProperties": false
        }
      ],
      "$id": "./KeyChainConfigFile.schema.json",
      "title": "KeyChainConfigFile"
    }
  },
  {
    "uri": "./KeyChainCreateDto.schema.json",
    "fileMatch": ["a://b/KeyChainCreateDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "usageType": {
          "type": "string",
          "enum": ["access", "attestation", "trustList", "statusList", "encrypt"],
          "description": "Key usage category for the key chain."
        },
        "type": {
          "type": "string",
          "enum": ["standalone", "internalChain"],
          "description": "Key chain mode."
        },
        "description": {
          "description": "Optional key chain description.",
          "type": "string"
        },
        "kmsProvider": {
          "description": "Optional KMS provider id for key storage operations.",
          "type": "string"
        },
        "rotationPolicy": {
          "description": "Optional rotation policy.",
          "type": "object",
          "properties": {
            "enabled": {
              "type": "boolean",
              "description": "Enable or disable automatic key rotation."
            },
            "intervalDays": {
              "description": "Rotation interval in days.",
              "type": "number",
              "minimum": 1,
              "maximum": 3650
            },
            "certValidityDays": {
              "description": "Certificate validity period in days for generated leaf certificates.",
              "type": "number",
              "minimum": 1,
              "maximum": 3650
            }
          },
          "required": ["enabled"],
          "additionalProperties": false
        }
      },
      "required": ["usageType", "type"],
      "additionalProperties": false,
      "$id": "./KeyChainCreateDto.schema.json",
      "title": "KeyChainCreateDto"
    }
  },
  {
    "uri": "./KeyChainImportDto.schema.json",
    "fileMatch": ["a://b/KeyChainImportDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "id": {
          "description": "Optional key chain id. If omitted, one is generated.",
          "type": "string"
        },
        "key": {
          "type": "object",
          "properties": {
            "kty": {
              "type": "string",
              "description": "Key type (for example EC)."
            },
            "x": {
              "type": "string",
              "description": "Elliptic curve public x coordinate."
            },
            "y": {
              "type": "string",
              "description": "Elliptic curve public y coordinate."
            },
            "crv": {
              "type": "string",
              "description": "Elliptic curve name."
            },
            "d": {
              "type": "string",
              "description": "Private key value."
            },
            "alg": {
              "description": "Optional algorithm hint.",
              "type": "string"
            },
            "kid": {
              "description": "Optional key identifier.",
              "type": "string"
            }
          },
          "required": ["kty", "x", "y", "crv", "d"],
          "additionalProperties": false,
          "description": "Private key material in JWK format."
        },
        "description": {
          "description": "Optional key chain description.",
          "type": "string"
        },
        "usageType": {
          "type": "string",
          "enum": ["access", "attestation", "trustList", "statusList", "encrypt"],
          "description": "Key usage category for the imported key chain."
        },
        "crt": {
          "description": "Optional certificate chain values in PEM or base64 DER.",
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "kmsProvider": {
          "description": "Optional KMS provider id.",
          "type": "string"
        },
        "rotationPolicy": {
          "description": "Optional rotation policy for imported key chains.",
          "type": "object",
          "properties": {
            "enabled": {
              "type": "boolean",
              "description": "Enable automatic rotation for imported key chains."
            },
            "intervalDays": {
              "description": "Rotation interval in days.",
              "type": "number",
              "minimum": 1,
              "maximum": 3650
            },
            "certValidityDays": {
              "description": "Certificate validity period in days.",
              "type": "number",
              "minimum": 1,
              "maximum": 3650
            }
          },
          "required": ["enabled"],
          "additionalProperties": false
        }
      },
      "required": ["key", "usageType"],
      "additionalProperties": false,
      "$id": "./KeyChainImportDto.schema.json",
      "title": "KeyChainImportDto"
    }
  },
  {
    "uri": "./KeyChainUpdateDto.schema.json",
    "fileMatch": ["a://b/KeyChainUpdateDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "description": {
          "description": "Optional replacement description.",
          "type": "string"
        },
        "rotationPolicy": {
          "description": "Optional rotation policy updates.",
          "type": "object",
          "properties": {
            "enabled": {
              "description": "Optional replacement for rotation enabled flag.",
              "type": "boolean"
            },
            "intervalDays": {
              "description": "Optional replacement for rotation interval in days.",
              "type": "number",
              "minimum": 1,
              "maximum": 3650
            },
            "certValidityDays": {
              "description": "Optional replacement for certificate validity period in days.",
              "type": "number",
              "minimum": 1,
              "maximum": 3650
            }
          },
          "additionalProperties": false
        },
        "activeCertificate": {
          "description": "Optional active certificate override.",
          "type": "string"
        }
      },
      "additionalProperties": false,
      "$id": "./KeyChainUpdateDto.schema.json",
      "title": "KeyChainUpdateDto"
    }
  },
  {
    "uri": "./KmsConfigDto.schema.json",
    "fileMatch": ["a://b/KmsConfigDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "defaultProvider": {
          "description": "ID of the default KMS provider. Defaults to \"db\" if not set.",
          "examples": ["main-vault"],
          "anyOf": [
            {
              "type": "string",
              "minLength": 1
            },
            {
              "type": "string",
              "pattern": "^\\$\\{([A-Z0-9_]+)\\}$"
            }
          ]
        },
        "providers": {
          "type": "array",
          "items": {
            "oneOf": [
              {
                "type": "object",
                "properties": {
                  "id": {
                    "anyOf": [
                      {
                        "type": "string",
                        "minLength": 1
                      },
                      {
                        "type": "string",
                        "pattern": "^\\$\\{([A-Z0-9_]+)\\}$"
                      }
                    ],
                    "description": "Unique identifier for this provider instance. Used when generating keys to specify which provider to use.",
                    "examples": ["main-vault"]
                  },
                  "type": {
                    "type": "string",
                    "const": "db",
                    "description": "Type of the KMS provider.",
                    "examples": ["db"]
                  },
                  "description": {
                    "description": "Human-readable description of this provider instance.",
                    "examples": ["Production HashiCorp Vault for signing keys"],
                    "anyOf": [
                      {
                        "type": "string",
                        "minLength": 1
                      },
                      {
                        "type": "string",
                        "pattern": "^\\$\\{([A-Z0-9_]+)\\}$"
                      }
                    ]
                  }
                },
                "required": ["id", "type"],
                "additionalProperties": false
              },
              {
                "type": "object",
                "properties": {
                  "id": {
                    "anyOf": [
                      {
                        "type": "string",
                        "minLength": 1
                      },
                      {
                        "type": "string",
                        "pattern": "^\\$\\{([A-Z0-9_]+)\\}$"
                      }
                    ],
                    "description": "Unique identifier for this provider instance. Used when generating keys to specify which provider to use.",
                    "examples": ["main-vault"]
                  },
                  "type": {
                    "type": "string",
                    "const": "vault",
                    "description": "Type of the KMS provider.",
                    "examples": ["vault"]
                  },
                  "description": {
                    "description": "Human-readable description of this provider instance.",
                    "examples": ["Production HashiCorp Vault for signing keys"],
                    "anyOf": [
                      {
                        "type": "string",
                        "minLength": 1
                      },
                      {
                        "type": "string",
                        "pattern": "^\\$\\{([A-Z0-9_]+)\\}$"
                      }
                    ]
                  },
                  "vaultUrl": {
                    "anyOf": [
                      {
                        "type": "string",
                        "format": "uri"
                      },
                      {
                        "type": "string",
                        "pattern": "^\\$\\{([A-Z0-9_]+)\\}$"
                      }
                    ],
                    "description": "URL of the HashiCorp Vault instance. Supports ${ENV_VAR} placeholders.",
                    "examples": ["${VAULT_URL}"]
                  },
                  "vaultToken": {
                    "anyOf": [
                      {
                        "type": "string",
                        "minLength": 1
                      },
                      {
                        "type": "string",
                        "pattern": "^\\$\\{([A-Z0-9_]+)\\}$"
                      }
                    ],
                    "description": "Authentication token for HashiCorp Vault. Supports ${ENV_VAR} placeholders.",
                    "examples": ["${VAULT_TOKEN}"]
                  }
                },
                "required": ["id", "type", "vaultUrl", "vaultToken"],
                "additionalProperties": false
              },
              {
                "type": "object",
                "properties": {
                  "id": {
                    "anyOf": [
                      {
                        "type": "string",
                        "minLength": 1
                      },
                      {
                        "type": "string",
                        "pattern": "^\\$\\{([A-Z0-9_]+)\\}$"
                      }
                    ],
                    "description": "Unique identifier for this provider instance. Used when generating keys to specify which provider to use.",
                    "examples": ["main-vault"]
                  },
                  "type": {
                    "type": "string",
                    "const": "aws-kms",
                    "description": "Type of the KMS provider.",
                    "examples": ["aws-kms"]
                  },
                  "description": {
                    "description": "Human-readable description of this provider instance.",
                    "examples": ["Production HashiCorp Vault for signing keys"],
                    "anyOf": [
                      {
                        "type": "string",
                        "minLength": 1
                      },
                      {
                        "type": "string",
                        "pattern": "^\\$\\{([A-Z0-9_]+)\\}$"
                      }
                    ]
                  },
                  "region": {
                    "anyOf": [
                      {
                        "type": "string",
                        "minLength": 1
                      },
                      {
                        "type": "string",
                        "pattern": "^\\$\\{([A-Z0-9_]+)\\}$"
                      }
                    ],
                    "description": "AWS region for KMS. Supports ${ENV_VAR} placeholders.",
                    "examples": ["${AWS_REGION}"]
                  },
                  "accessKeyId": {
                    "description": "AWS access key ID. Optional — uses SDK credential chain if not provided. Supports ${ENV_VAR} placeholders.",
                    "examples": ["${AWS_ACCESS_KEY_ID}"],
                    "anyOf": [
                      {
                        "type": "string",
                        "minLength": 1
                      },
                      {
                        "type": "string",
                        "pattern": "^\\$\\{([A-Z0-9_]+)\\}$"
                      }
                    ]
                  },
                  "secretAccessKey": {
                    "description": "AWS secret access key. Optional — uses SDK credential chain if not provided. Supports ${ENV_VAR} placeholders.",
                    "examples": ["${AWS_SECRET_ACCESS_KEY}"],
                    "anyOf": [
                      {
                        "type": "string",
                        "minLength": 1
                      },
                      {
                        "type": "string",
                        "pattern": "^\\$\\{([A-Z0-9_]+)\\}$"
                      }
                    ]
                  }
                },
                "required": ["id", "type", "region"],
                "additionalProperties": false
              },
              {
                "type": "object",
                "properties": {
                  "id": {
                    "anyOf": [
                      {
                        "type": "string",
                        "minLength": 1
                      },
                      {
                        "type": "string",
                        "pattern": "^\\$\\{([A-Z0-9_]+)\\}$"
                      }
                    ],
                    "description": "Unique identifier for this provider instance. Used when generating keys to specify which provider to use.",
                    "examples": ["main-vault"]
                  },
                  "type": {
                    "type": "string",
                    "const": "pkcs11",
                    "description": "Type of the KMS provider.",
                    "examples": ["pkcs11"]
                  },
                  "description": {
                    "description": "Human-readable description of this provider instance.",
                    "examples": ["Production HashiCorp Vault for signing keys"],
                    "anyOf": [
                      {
                        "type": "string",
                        "minLength": 1
                      },
                      {
                        "type": "string",
                        "pattern": "^\\$\\{([A-Z0-9_]+)\\}$"
                      }
                    ]
                  },
                  "library": {
                    "anyOf": [
                      {
                        "type": "string",
                        "minLength": 1
                      },
                      {
                        "type": "string",
                        "pattern": "^\\$\\{([A-Z0-9_]+)\\}$"
                      }
                    ],
                    "description": "Absolute path to the PKCS#11 module library (.so/.dll/.dylib). Supports ${ENV_VAR} placeholders.",
                    "examples": ["${PKCS11_LIBRARY}"]
                  },
                  "slot": {
                    "anyOf": [
                      {
                        "type": "number"
                      },
                      {
                        "type": "string"
                      }
                    ],
                    "description": "Slot selection. Either the numeric slot index (as a string for ENV interpolation, or a number) or the token label. Supports ${ENV_VAR} placeholders.",
                    "examples": ["${PKCS11_SLOT}"]
                  },
                  "pin": {
                    "anyOf": [
                      {
                        "type": "string",
                        "minLength": 1
                      },
                      {
                        "type": "string",
                        "pattern": "^\\$\\{([A-Z0-9_]+)\\}$"
                      }
                    ],
                    "description": "User PIN used for C_Login. Supports ${ENV_VAR} placeholders.",
                    "examples": ["${PKCS11_PIN}"]
                  },
                  "readOnly": {
                    "description": "Open the PKCS#11 session in read-only mode. Defaults to false.",
                    "examples": [false],
                    "type": "boolean"
                  }
                },
                "required": ["id", "type", "library", "slot", "pin"],
                "additionalProperties": false
              },
              {
                "type": "object",
                "properties": {
                  "id": {
                    "anyOf": [
                      {
                        "type": "string",
                        "minLength": 1
                      },
                      {
                        "type": "string",
                        "pattern": "^\\$\\{([A-Z0-9_]+)\\}$"
                      }
                    ],
                    "description": "Unique identifier for this provider instance. Used when generating keys to specify which provider to use.",
                    "examples": ["main-vault"]
                  },
                  "type": {
                    "type": "string",
                    "const": "http",
                    "description": "Type of the KMS provider.",
                    "examples": ["http"]
                  },
                  "description": {
                    "description": "Human-readable description of this provider instance.",
                    "examples": ["Production HashiCorp Vault for signing keys"],
                    "anyOf": [
                      {
                        "type": "string",
                        "minLength": 1
                      },
                      {
                        "type": "string",
                        "pattern": "^\\$\\{([A-Z0-9_]+)\\}$"
                      }
                    ]
                  },
                  "baseUrl": {
                    "anyOf": [
                      {
                        "type": "string",
                        "format": "uri"
                      },
                      {
                        "type": "string",
                        "pattern": "^\\$\\{([A-Z0-9_]+)\\}$"
                      }
                    ],
                    "description": "Base URL of the remote KMS microservice (no trailing slash). Supports ${ENV_VAR} placeholders.",
                    "examples": ["${KMS_SERVICE_URL}"]
                  },
                  "auth": {
                    "description": "Authentication method for the remote KMS service. Supports bearer token, OAuth 2.0 client credentials, and mutual TLS. Omit (or set type to \"none\") for unauthenticated services.",
                    "oneOf": [
                      {
                        "type": "object",
                        "properties": {
                          "type": {
                            "type": "string",
                            "const": "none",
                            "description": "No authentication — suitable for services on a trusted private network.",
                            "examples": ["none"]
                          }
                        },
                        "required": ["type"],
                        "additionalProperties": false
                      },
                      {
                        "type": "object",
                        "properties": {
                          "type": {
                            "type": "string",
                            "const": "bearer",
                            "description": "Static Bearer token sent as Authorization: Bearer <token>.",
                            "examples": ["bearer"]
                          },
                          "token": {
                            "anyOf": [
                              {
                                "type": "string",
                                "minLength": 1
                              },
                              {
                                "type": "string",
                                "pattern": "^\\$\\{([A-Z0-9_]+)\\}$"
                              }
                            ],
                            "description": "Bearer token value. Supports ${ENV_VAR} placeholders.",
                            "examples": ["${KMS_API_KEY}"]
                          }
                        },
                        "required": ["type", "token"],
                        "additionalProperties": false
                      },
                      {
                        "type": "object",
                        "properties": {
                          "type": {
                            "type": "string",
                            "const": "oauth2-client-credentials",
                            "description": "OAuth 2.0 Client Credentials — EUDIPLO fetches and caches short-lived tokens.",
                            "examples": ["oauth2-client-credentials"]
                          },
                          "tokenUrl": {
                            "anyOf": [
                              {
                                "type": "string",
                                "format": "uri"
                              },
                              {
                                "type": "string",
                                "pattern": "^\\$\\{([A-Z0-9_]+)\\}$"
                              }
                            ],
                            "description": "Token endpoint URL (e.g. Keycloak, Entra ID). Supports ${ENV_VAR} placeholders.",
                            "examples": ["${IAM_TOKEN_URL}"]
                          },
                          "clientId": {
                            "anyOf": [
                              {
                                "type": "string",
                                "minLength": 1
                              },
                              {
                                "type": "string",
                                "pattern": "^\\$\\{([A-Z0-9_]+)\\}$"
                              }
                            ],
                            "description": "OAuth 2.0 client ID. Supports ${ENV_VAR} placeholders.",
                            "examples": ["${KMS_CLIENT_ID}"]
                          },
                          "clientSecret": {
                            "anyOf": [
                              {
                                "type": "string",
                                "minLength": 1
                              },
                              {
                                "type": "string",
                                "pattern": "^\\$\\{([A-Z0-9_]+)\\}$"
                              }
                            ],
                            "description": "OAuth 2.0 client secret. Supports ${ENV_VAR} placeholders.",
                            "examples": ["${KMS_CLIENT_SECRET}"]
                          },
                          "scope": {
                            "description": "Space-separated list of OAuth 2.0 scopes to request. Optional.",
                            "examples": ["kms:sign kms:admin"],
                            "anyOf": [
                              {
                                "type": "string",
                                "minLength": 1
                              },
                              {
                                "type": "string",
                                "pattern": "^\\$\\{([A-Z0-9_]+)\\}$"
                              }
                            ]
                          }
                        },
                        "required": ["type", "tokenUrl", "clientId", "clientSecret"],
                        "additionalProperties": false
                      },
                      {
                        "type": "object",
                        "properties": {
                          "type": {
                            "type": "string",
                            "const": "mtls",
                            "description": "Mutual TLS — EUDIPLO presents a client certificate on every connection.",
                            "examples": ["mtls"]
                          },
                          "certFile": {
                            "anyOf": [
                              {
                                "type": "string",
                                "minLength": 1
                              },
                              {
                                "type": "string",
                                "pattern": "^\\$\\{([A-Z0-9_]+)\\}$"
                              }
                            ],
                            "description": "Absolute path to the PEM-encoded client certificate file. Supports ${ENV_VAR} placeholders.",
                            "examples": ["/etc/certs/eudiplo.crt"]
                          },
                          "keyFile": {
                            "anyOf": [
                              {
                                "type": "string",
                                "minLength": 1
                              },
                              {
                                "type": "string",
                                "pattern": "^\\$\\{([A-Z0-9_]+)\\}$"
                              }
                            ],
                            "description": "Absolute path to the PEM-encoded private key file for the client certificate. Supports ${ENV_VAR} placeholders.",
                            "examples": ["/etc/certs/eudiplo.key"]
                          },
                          "caFile": {
                            "description": "Absolute path to the PEM-encoded CA bundle to trust for the remote server's certificate. Omit to use the system CA store.",
                            "examples": ["/etc/certs/ca.crt"],
                            "anyOf": [
                              {
                                "type": "string",
                                "minLength": 1
                              },
                              {
                                "type": "string",
                                "pattern": "^\\$\\{([A-Z0-9_]+)\\}$"
                              }
                            ]
                          }
                        },
                        "required": ["type", "certFile", "keyFile"],
                        "additionalProperties": false
                      }
                    ]
                  },
                  "keysPath": {
                    "description": "Path prefix for key endpoints on the remote service. Defaults to /keys.",
                    "examples": ["/v1/keys"],
                    "anyOf": [
                      {
                        "type": "string",
                        "minLength": 1
                      },
                      {
                        "type": "string",
                        "pattern": "^\\$\\{([A-Z0-9_]+)\\}$"
                      }
                    ]
                  },
                  "healthPath": {
                    "description": "Path for the health check endpoint on the remote service. Defaults to /health.",
                    "examples": ["/health"],
                    "anyOf": [
                      {
                        "type": "string",
                        "minLength": 1
                      },
                      {
                        "type": "string",
                        "pattern": "^\\$\\{([A-Z0-9_]+)\\}$"
                      }
                    ]
                  },
                  "canImport": {
                    "description": "Whether the remote service supports key import via POST {keysPath}/{kid}/import. Defaults to false.",
                    "examples": [false],
                    "type": "boolean"
                  }
                },
                "required": ["id", "type", "baseUrl"],
                "additionalProperties": false
              },
              {
                "type": "object",
                "properties": {
                  "id": {
                    "anyOf": [
                      {
                        "type": "string",
                        "minLength": 1
                      },
                      {
                        "type": "string",
                        "pattern": "^\\$\\{([A-Z0-9_]+)\\}$"
                      }
                    ],
                    "description": "Unique identifier for this provider instance. Used when generating keys to specify which provider to use.",
                    "examples": ["main-vault"]
                  },
                  "type": {
                    "type": "string",
                    "const": "csc",
                    "description": "Type of the KMS provider.",
                    "examples": ["csc"]
                  },
                  "description": {
                    "description": "Human-readable description of this provider instance.",
                    "examples": ["Production HashiCorp Vault for signing keys"],
                    "anyOf": [
                      {
                        "type": "string",
                        "minLength": 1
                      },
                      {
                        "type": "string",
                        "pattern": "^\\$\\{([A-Z0-9_]+)\\}$"
                      }
                    ]
                  },
                  "baseUrl": {
                    "anyOf": [
                      {
                        "type": "string",
                        "format": "uri"
                      },
                      {
                        "type": "string",
                        "pattern": "^\\$\\{([A-Z0-9_]+)\\}$"
                      }
                    ],
                    "description": "Base URL of the CSC service (without trailing slash). Supports ${ENV_VAR} placeholders.",
                    "examples": ["${CSC_URL}"]
                  },
                  "tokenUrl": {
                    "anyOf": [
                      {
                        "type": "string",
                        "format": "uri"
                      },
                      {
                        "type": "string",
                        "pattern": "^\\$\\{([A-Z0-9_]+)\\}$"
                      }
                    ],
                    "description": "OAuth2 token endpoint URL for client-credentials flow. Supports ${ENV_VAR} placeholders.",
                    "examples": ["${CSC_TOKEN_URL}"]
                  },
                  "clientId": {
                    "anyOf": [
                      {
                        "type": "string",
                        "minLength": 1
                      },
                      {
                        "type": "string",
                        "pattern": "^\\$\\{([A-Z0-9_]+)\\}$"
                      }
                    ],
                    "description": "OAuth2 client ID. Supports ${ENV_VAR} placeholders.",
                    "examples": ["${CSC_CLIENT_ID}"]
                  },
                  "clientSecret": {
                    "anyOf": [
                      {
                        "type": "string",
                        "minLength": 1
                      },
                      {
                        "type": "string",
                        "pattern": "^\\$\\{([A-Z0-9_]+)\\}$"
                      }
                    ],
                    "description": "OAuth2 client secret. Supports ${ENV_VAR} placeholders.",
                    "examples": ["${CSC_CLIENT_SECRET}"]
                  },
                  "scope": {
                    "description": "OAuth2 scope to request during token acquisition.",
                    "examples": ["service"],
                    "anyOf": [
                      {
                        "type": "string",
                        "minLength": 1
                      },
                      {
                        "type": "string",
                        "pattern": "^\\$\\{([A-Z0-9_]+)\\}$"
                      }
                    ]
                  },
                  "credentialId": {
                    "description": "Default CSC credential ID. If omitted, the adapter calls credentials/list and picks the first entry.",
                    "examples": ["[INTESIQCSEALEC]_SEAL_351_SIGN_1781018892758"],
                    "anyOf": [
                      {
                        "type": "string",
                        "minLength": 1
                      },
                      {
                        "type": "string",
                        "pattern": "^\\$\\{([A-Z0-9_]+)\\}$"
                      }
                    ]
                  },
                  "userId": {
                    "description": "Optional CSC user ID used in credentials/list requests.",
                    "examples": ["eudiplo_user"],
                    "anyOf": [
                      {
                        "type": "string",
                        "minLength": 1
                      },
                      {
                        "type": "string",
                        "pattern": "^\\$\\{([A-Z0-9_]+)\\}$"
                      }
                    ]
                  },
                  "apiPath": {
                    "description": "CSC API path prefix appended to baseUrl. Defaults to /csc/v2.",
                    "examples": ["/csc/v2"],
                    "anyOf": [
                      {
                        "type": "string",
                        "minLength": 1
                      },
                      {
                        "type": "string",
                        "pattern": "^\\$\\{([A-Z0-9_]+)\\}$"
                      }
                    ]
                  },
                  "hashAlgorithmOid": {
                    "description": "Hash algorithm OID for signatures/signHash and credentials/authorize. Defaults to SHA-256 OID.",
                    "examples": ["2.16.840.1.101.3.4.2.1"],
                    "anyOf": [
                      {
                        "type": "string",
                        "minLength": 1
                      },
                      {
                        "type": "string",
                        "pattern": "^\\$\\{([A-Z0-9_]+)\\}$"
                      }
                    ]
                  },
                  "signAlgorithmOid": {
                    "description": "Signature algorithm OID for signatures/signHash. Defaults to ecdsa-with-SHA256 OID.",
                    "examples": ["1.2.840.10045.4.3.2"],
                    "anyOf": [
                      {
                        "type": "string",
                        "minLength": 1
                      },
                      {
                        "type": "string",
                        "pattern": "^\\$\\{([A-Z0-9_]+)\\}$"
                      }
                    ]
                  },
                  "sad": {
                    "description": "Static SAD token. If set, the adapter sends it directly in signatures/signHash requests.",
                    "anyOf": [
                      {
                        "type": "string",
                        "minLength": 1
                      },
                      {
                        "type": "string",
                        "pattern": "^\\$\\{([A-Z0-9_]+)\\}$"
                      }
                    ]
                  },
                  "useAuthorizeEndpoint": {
                    "description": "When true and no static SAD is provided, the adapter calls credentials/authorize to obtain SAD before signatures/signHash.",
                    "examples": [false],
                    "type": "boolean"
                  },
                  "authorizeAuthData": {
                    "description": "Optional authData array passed to credentials/authorize (e.g., PIN/OTP factors).",
                    "type": "array",
                    "items": {
                      "type": "object",
                      "properties": {
                        "id": {
                          "anyOf": [
                            {
                              "type": "string",
                              "minLength": 1
                            },
                            {
                              "type": "string",
                              "pattern": "^\\$\\{([A-Z0-9_]+)\\}$"
                            }
                          ],
                          "description": "Authentication factor identifier expected by the CSC provider (e.g., PIN, OTP).",
                          "examples": ["PIN"]
                        },
                        "value": {
                          "anyOf": [
                            {
                              "type": "string",
                              "minLength": 1
                            },
                            {
                              "type": "string",
                              "pattern": "^\\$\\{([A-Z0-9_]+)\\}$"
                            }
                          ],
                          "description": "Authentication factor value sent to CSC credentials/authorize.",
                          "examples": ["123456"]
                        }
                      },
                      "required": ["id", "value"],
                      "additionalProperties": false
                    }
                  }
                },
                "required": ["id", "type", "baseUrl", "tokenUrl", "clientId", "clientSecret"],
                "additionalProperties": false
              }
            ]
          },
          "description": "List of KMS provider configurations. Each provider must have a unique id and a type.",
          "examples": [
            [
              {
                "id": "db",
                "type": "db",
                "description": "Default database provider"
              },
              {
                "id": "main-vault",
                "type": "vault",
                "description": "Production Vault",
                "vaultUrl": "${VAULT_URL}",
                "vaultToken": "${VAULT_TOKEN}"
              },
              {
                "id": "aws",
                "type": "aws-kms",
                "description": "AWS KMS",
                "region": "${AWS_REGION}"
              }
            ]
          ]
        }
      },
      "required": ["providers"],
      "additionalProperties": false,
      "$id": "./KmsConfigDto.schema.json",
      "title": "KmsConfigDto"
    }
  },
  {
    "uri": "./PresentationConfigCreateDto.schema.json",
    "fileMatch": ["a://b/PresentationConfigCreateDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "minLength": 1,
          "description": "Presentation configuration identifier."
        },
        "description": {
          "description": "Optional presentation configuration description.",
          "anyOf": [
            {
              "type": "string"
            },
            {
              "type": "null"
            }
          ]
        },
        "lifeTime": {
          "description": "Presentation request lifetime in seconds.",
          "type": "integer",
          "minimum": 1,
          "maximum": 9007199254740991
        },
        "skewSeconds": {
          "description": "Clock skew tolerance in seconds.",
          "type": "integer",
          "minimum": 0,
          "maximum": 9007199254740991
        },
        "statusCheckMode": {
          "description": "Revocation/status check mode.",
          "type": "string",
          "enum": ["strict", "best_effort", "disabled"]
        },
        "dcql_query": {
          "type": "object",
          "properties": {
            "credentials": {
              "minItems": 1,
              "type": "array",
              "items": {
                "oneOf": [
                  {
                    "type": "object",
                    "properties": {
                      "id": {
                        "type": "string",
                        "minLength": 1,
                        "pattern": "^[A-Za-z0-9_-]+$",
                        "description": "Credential query identifier."
                      },
                      "multiple": {
                        "description": "Allow multiple matching credentials.",
                        "type": "boolean"
                      },
                      "claim_sets": {
                        "description": "Optional claim set constraints.",
                        "type": "array",
                        "items": {
                          "type": "array",
                          "items": {
                            "type": "string"
                          }
                        }
                      },
                      "trusted_authorities": {
                        "description": "Optional trusted authority constraints.",
                        "type": "array",
                        "items": {
                          "oneOf": [
                            {
                              "type": "object",
                              "properties": {
                                "type": {
                                  "type": "string",
                                  "const": "etsi_tl",
                                  "description": "Trusted authority type discriminator for ETSI trust lists."
                                },
                                "values": {
                                  "type": "array",
                                  "items": {
                                    "type": "object",
                                    "properties": {
                                      "trustListId": {
                                        "description": "Optional trust list id reference.",
                                        "type": "string"
                                      },
                                      "url": {
                                        "description": "Optional trust list URL reference.",
                                        "anyOf": [
                                          {
                                            "type": "string",
                                            "format": "uri"
                                          },
                                          {
                                            "type": "string",
                                            "pattern": "^<TENANT_URL>(?:\\/.*)?$"
                                          }
                                        ]
                                      },
                                      "verifierKey": {
                                        "description": "Optional verifier key material.",
                                        "type": "object",
                                        "propertyNames": {
                                          "type": "string"
                                        },
                                        "additionalProperties": {}
                                      },
                                      "verifierX509Der": {
                                        "description": "Optional verifier certificate in DER/base64 form.",
                                        "type": "string"
                                      }
                                    },
                                    "additionalProperties": false
                                  },
                                  "description": "Trust list references for ETSI TL verification."
                                }
                              },
                              "required": ["type", "values"],
                              "additionalProperties": false
                            },
                            {
                              "type": "object",
                              "properties": {
                                "type": {
                                  "type": "string",
                                  "const": "openid_federation",
                                  "description": "Trusted authority type discriminator for OpenID Federation."
                                },
                                "values": {
                                  "type": "array",
                                  "items": {
                                    "type": "string"
                                  },
                                  "description": "OpenID Federation authority identifiers."
                                }
                              },
                              "required": ["type", "values"],
                              "additionalProperties": false
                            }
                          ]
                        }
                      },
                      "format": {
                        "type": "string",
                        "const": "dc+sd-jwt",
                        "description": "Credential format discriminator."
                      },
                      "meta": {
                        "type": "object",
                        "properties": {
                          "vct_values": {
                            "minItems": 1,
                            "type": "array",
                            "items": {
                              "type": "string"
                            },
                            "description": "Accepted VCT values."
                          }
                        },
                        "required": ["vct_values"],
                        "additionalProperties": false
                      },
                      "claims": {
                        "description": "Optional claim-level constraints.",
                        "type": "array",
                        "items": {
                          "type": "object",
                          "properties": {
                            "id": {
                              "description": "Optional claim query id.",
                              "type": "string"
                            },
                            "path": {
                              "type": "array",
                              "items": {
                                "anyOf": [
                                  {
                                    "type": "string"
                                  },
                                  {
                                    "type": "number"
                                  }
                                ]
                              },
                              "description": "Path to the claim value in presented credentials."
                            },
                            "values": {
                              "description": "Optional allowed values for the claim.",
                              "type": "array",
                              "items": {
                                "type": "string"
                              }
                            }
                          },
                          "required": ["path"],
                          "additionalProperties": false
                        }
                      }
                    },
                    "required": ["id", "format", "meta"],
                    "additionalProperties": false
                  },
                  {
                    "type": "object",
                    "properties": {
                      "id": {
                        "type": "string",
                        "minLength": 1,
                        "pattern": "^[A-Za-z0-9_-]+$",
                        "description": "Credential query identifier."
                      },
                      "multiple": {
                        "description": "Allow multiple matching credentials.",
                        "type": "boolean"
                      },
                      "claim_sets": {
                        "description": "Optional claim set constraints.",
                        "type": "array",
                        "items": {
                          "type": "array",
                          "items": {
                            "type": "string"
                          }
                        }
                      },
                      "trusted_authorities": {
                        "description": "Optional trusted authority constraints.",
                        "type": "array",
                        "items": {
                          "oneOf": [
                            {
                              "type": "object",
                              "properties": {
                                "type": {
                                  "type": "string",
                                  "const": "etsi_tl",
                                  "description": "Trusted authority type discriminator for ETSI trust lists."
                                },
                                "values": {
                                  "type": "array",
                                  "items": {
                                    "type": "object",
                                    "properties": {
                                      "trustListId": {
                                        "description": "Optional trust list id reference.",
                                        "type": "string"
                                      },
                                      "url": {
                                        "description": "Optional trust list URL reference.",
                                        "anyOf": [
                                          {
                                            "type": "string",
                                            "format": "uri"
                                          },
                                          {
                                            "type": "string",
                                            "pattern": "^<TENANT_URL>(?:\\/.*)?$"
                                          }
                                        ]
                                      },
                                      "verifierKey": {
                                        "description": "Optional verifier key material.",
                                        "type": "object",
                                        "propertyNames": {
                                          "type": "string"
                                        },
                                        "additionalProperties": {}
                                      },
                                      "verifierX509Der": {
                                        "description": "Optional verifier certificate in DER/base64 form.",
                                        "type": "string"
                                      }
                                    },
                                    "additionalProperties": false
                                  },
                                  "description": "Trust list references for ETSI TL verification."
                                }
                              },
                              "required": ["type", "values"],
                              "additionalProperties": false
                            },
                            {
                              "type": "object",
                              "properties": {
                                "type": {
                                  "type": "string",
                                  "const": "openid_federation",
                                  "description": "Trusted authority type discriminator for OpenID Federation."
                                },
                                "values": {
                                  "type": "array",
                                  "items": {
                                    "type": "string"
                                  },
                                  "description": "OpenID Federation authority identifiers."
                                }
                              },
                              "required": ["type", "values"],
                              "additionalProperties": false
                            }
                          ]
                        }
                      },
                      "format": {
                        "type": "string",
                        "const": "mso_mdoc",
                        "description": "Credential format discriminator."
                      },
                      "meta": {
                        "type": "object",
                        "properties": {
                          "doctype_value": {
                            "type": "string",
                            "minLength": 1,
                            "description": "Expected mDoc doctype value."
                          }
                        },
                        "required": ["doctype_value"],
                        "additionalProperties": false
                      },
                      "claims": {
                        "description": "Optional mDoc claim-level constraints.",
                        "type": "array",
                        "items": {
                          "type": "object",
                          "properties": {
                            "id": {
                              "description": "Optional claim query id.",
                              "type": "string"
                            },
                            "path": {
                              "type": "array",
                              "items": {
                                "anyOf": [
                                  {
                                    "type": "string"
                                  },
                                  {
                                    "type": "number"
                                  }
                                ]
                              },
                              "description": "Path to the claim value in presented credentials."
                            },
                            "values": {
                              "description": "Optional allowed values for the claim.",
                              "type": "array",
                              "items": {
                                "type": "string"
                              }
                            },
                            "intent_to_retain": {
                              "description": "Whether relying party intends to retain the claim.",
                              "type": "boolean"
                            }
                          },
                          "required": ["path"],
                          "additionalProperties": false
                        }
                      }
                    },
                    "required": ["id", "format", "meta"],
                    "additionalProperties": false
                  }
                ]
              },
              "description": "Credential queries requested by the verifier."
            },
            "credential_sets": {
              "description": "Optional higher-level credential set requirements.",
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "options": {
                    "minItems": 1,
                    "type": "array",
                    "items": {
                      "minItems": 1,
                      "type": "array",
                      "items": {
                        "type": "string"
                      }
                    },
                    "description": "Alternative credential query id combinations."
                  },
                  "required": {
                    "description": "Whether this credential set is mandatory.",
                    "type": "boolean"
                  }
                },
                "required": ["options"],
                "additionalProperties": false
              }
            }
          },
          "required": ["credentials"],
          "additionalProperties": false,
          "description": "DCQL query defining requested credentials and claims."
        },
        "transaction_data": {
          "description": "Optional transaction data descriptors.",
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "type": {
                "type": "string",
                "description": "Transaction data type identifier."
              },
              "credential_ids": {
                "type": "array",
                "items": {
                  "type": "string"
                },
                "description": "Credential query ids this transaction data applies to."
              }
            },
            "required": ["type", "credential_ids"],
            "additionalProperties": {}
          }
        },
        "registration_cert": {
          "description": "Optional registration certificate request settings.",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "id": {
                  "type": "string"
                },
                "body": {
                  "type": "object",
                  "properties": {
                    "privacy_policy": {
                      "type": "string"
                    },
                    "support_uri": {
                      "type": "string"
                    },
                    "intermediary": {
                      "type": "string"
                    },
                    "purpose": {
                      "type": "array",
                      "items": {
                        "type": "object",
                        "properties": {
                          "lang": {
                            "type": "string"
                          },
                          "content": {
                            "type": "string"
                          }
                        },
                        "required": ["lang", "content"],
                        "additionalProperties": false
                      }
                    },
                    "credentials": {
                      "type": "array",
                      "items": {
                        "type": "object",
                        "propertyNames": {
                          "type": "string"
                        },
                        "additionalProperties": {}
                      }
                    },
                    "provided_attestations": {
                      "type": "array",
                      "items": {
                        "type": "object",
                        "propertyNames": {
                          "type": "string"
                        },
                        "additionalProperties": {}
                      }
                    }
                  },
                  "additionalProperties": false
                },
                "jwt": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "null"
            }
          ]
        },
        "webhookEndpointId": {
          "description": "Optional webhook endpoint id for presentation callbacks.",
          "anyOf": [
            {
              "type": "string"
            },
            {
              "type": "null"
            }
          ]
        },
        "attached": {
          "description": "Optional attachments included with presentation requests.",
          "anyOf": [
            {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "format": {
                    "type": "string",
                    "description": "Attachment format identifier."
                  },
                  "data": {
                    "description": "Attachment payload."
                  },
                  "credential_ids": {
                    "description": "Optional credential query ids bound to this attachment.",
                    "type": "array",
                    "items": {
                      "type": "string"
                    }
                  }
                },
                "required": ["format", "data"],
                "additionalProperties": false
              }
            },
            {
              "type": "null"
            }
          ]
        },
        "redirectUri": {
          "description": "Optional redirect URI after presentation completion.",
          "anyOf": [
            {
              "type": "string"
            },
            {
              "type": "null"
            }
          ]
        },
        "accessKeyChainId": {
          "description": "Optional key chain id for access token/auth operations.",
          "anyOf": [
            {
              "type": "string"
            },
            {
              "type": "null"
            }
          ]
        },
        "readerAuth": {
          "description": "Whether reader authentication is required for mDoc requests.",
          "anyOf": [
            {
              "type": "boolean"
            },
            {
              "type": "null"
            }
          ]
        }
      },
      "required": ["id", "dcql_query"],
      "additionalProperties": false,
      "$id": "./PresentationConfigCreateDto.schema.json",
      "title": "PresentationConfigCreateDto"
    }
  },
  {
    "uri": "./RotationPolicyCreateDto.schema.json",
    "fileMatch": ["a://b/RotationPolicyCreateDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "enabled": {
          "type": "boolean",
          "description": "Enable or disable automatic key rotation."
        },
        "intervalDays": {
          "description": "Rotation interval in days.",
          "type": "number",
          "minimum": 1,
          "maximum": 3650
        },
        "certValidityDays": {
          "description": "Certificate validity period in days for generated leaf certificates.",
          "type": "number",
          "minimum": 1,
          "maximum": 3650
        }
      },
      "required": ["enabled"],
      "additionalProperties": false,
      "$id": "./RotationPolicyCreateDto.schema.json",
      "title": "RotationPolicyCreateDto"
    }
  },
  {
    "uri": "./RotationPolicyUpdateDto.schema.json",
    "fileMatch": ["a://b/RotationPolicyUpdateDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "enabled": {
          "description": "Optional replacement for rotation enabled flag.",
          "type": "boolean"
        },
        "intervalDays": {
          "description": "Optional replacement for rotation interval in days.",
          "type": "number",
          "minimum": 1,
          "maximum": 3650
        },
        "certValidityDays": {
          "description": "Optional replacement for certificate validity period in days.",
          "type": "number",
          "minimum": 1,
          "maximum": 3650
        }
      },
      "additionalProperties": false,
      "$id": "./RotationPolicyUpdateDto.schema.json",
      "title": "RotationPolicyUpdateDto"
    }
  },
  {
    "uri": "./SessionStorageConfig.schema.json",
    "fileMatch": ["a://b/SessionStorageConfig*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "ttlSeconds": {
          "description": "Session time-to-live in seconds.",
          "type": "integer",
          "minimum": 60,
          "maximum": 9007199254740991
        },
        "cleanupMode": {
          "description": "Whether to fully delete or anonymize expired sessions.",
          "type": "string",
          "enum": ["full", "anonymize"]
        }
      },
      "additionalProperties": false,
      "description": "Tenant session storage configuration.",
      "$id": "./SessionStorageConfig.schema.json",
      "title": "SessionStorageConfig"
    }
  },
  {
    "uri": "./StatusListConfig.schema.json",
    "fileMatch": ["a://b/StatusListConfig*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "capacity": {
          "description": "Default status list capacity.",
          "type": "integer",
          "minimum": 100,
          "maximum": 9007199254740991
        },
        "bits": {
          "description": "Bits-per-status setting (1, 2, 4, or 8).",
          "anyOf": [
            {
              "type": "number",
              "const": 1
            },
            {
              "type": "number",
              "const": 2
            },
            {
              "type": "number",
              "const": 4
            },
            {
              "type": "number",
              "const": 8
            }
          ]
        },
        "ttl": {
          "description": "JWT TTL for status list tokens in seconds.",
          "type": "integer",
          "minimum": 60,
          "maximum": 9007199254740991
        },
        "immediateUpdate": {
          "description": "Regenerate status list JWTs immediately after status updates.",
          "type": "boolean"
        },
        "enableAggregation": {
          "description": "Include aggregation_uri in generated status list JWTs.",
          "type": "boolean"
        }
      },
      "additionalProperties": false,
      "description": "Tenant defaults for status list generation and publishing behavior.",
      "$id": "./StatusListConfig.schema.json",
      "title": "StatusListConfig"
    }
  },
  {
    "uri": "./StatusListImportDto.schema.json",
    "fileMatch": ["a://b/StatusListImportDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "minLength": 1,
          "description": "Status list identifier."
        },
        "credentialConfigurationId": {
          "description": "Optional credential configuration binding. Null means shared list.",
          "anyOf": [
            {
              "type": "string",
              "minLength": 1
            },
            {
              "type": "null"
            }
          ]
        },
        "keyChainId": {
          "description": "Optional key chain used for signing this status list.",
          "type": "string",
          "minLength": 1
        },
        "capacity": {
          "description": "Optional list capacity override.",
          "type": "integer",
          "minimum": 100,
          "maximum": 9007199254740991
        },
        "bits": {
          "description": "Optional bits-per-status override.",
          "anyOf": [
            {
              "type": "number",
              "const": 1
            },
            {
              "type": "number",
              "const": 2
            },
            {
              "type": "number",
              "const": 4
            },
            {
              "type": "number",
              "const": 8
            }
          ]
        }
      },
      "required": ["id"],
      "additionalProperties": false,
      "$id": "./StatusListImportDto.schema.json",
      "title": "StatusListImportDto"
    }
  },
  {
    "uri": "./TenantConfigFile.schema.json",
    "fileMatch": ["a://b/TenantConfigFile*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "anyOf": [
        {
          "type": "object",
          "properties": {
            "name": {
              "default": "EUDIPLO",
              "description": "Display name of the tenant.",
              "type": "string",
              "minLength": 1
            },
            "description": {
              "description": "Optional tenant description.",
              "type": "string",
              "minLength": 1
            },
            "sessionConfig": {
              "description": "Optional tenant-specific session storage configuration.",
              "type": "object",
              "properties": {
                "ttlSeconds": {
                  "description": "Session time-to-live in seconds.",
                  "type": "integer",
                  "minimum": 60,
                  "maximum": 9007199254740991
                },
                "cleanupMode": {
                  "description": "Whether to fully delete or anonymize expired sessions.",
                  "type": "string",
                  "enum": ["full", "anonymize"]
                }
              },
              "additionalProperties": false
            },
            "statusListConfig": {
              "description": "Optional tenant-specific status list defaults.",
              "type": "object",
              "properties": {
                "capacity": {
                  "description": "Default status list capacity.",
                  "type": "integer",
                  "minimum": 100,
                  "maximum": 9007199254740991
                },
                "bits": {
                  "description": "Bits-per-status setting (1, 2, 4, or 8).",
                  "anyOf": [
                    {
                      "type": "number",
                      "const": 1
                    },
                    {
                      "type": "number",
                      "const": 2
                    },
                    {
                      "type": "number",
                      "const": 4
                    },
                    {
                      "type": "number",
                      "const": 8
                    }
                  ]
                },
                "ttl": {
                  "description": "JWT TTL for status list tokens in seconds.",
                  "type": "integer",
                  "minimum": 60,
                  "maximum": 9007199254740991
                },
                "immediateUpdate": {
                  "description": "Regenerate status list JWTs immediately after status updates.",
                  "type": "boolean"
                },
                "enableAggregation": {
                  "description": "Include aggregation_uri in generated status list JWTs.",
                  "type": "boolean"
                }
              },
              "additionalProperties": false
            }
          },
          "required": ["name"],
          "additionalProperties": false,
          "description": "Payload used when importing tenant metadata from config files."
        },
        {
          "type": "object",
          "properties": {
            "apiVersion": {
              "type": "string",
              "const": "eudiplo.io/tenant/v1"
            },
            "kind": {
              "type": "string",
              "const": "Tenant"
            },
            "metadata": {
              "type": "object",
              "properties": {
                "id": {
                  "type": "string",
                  "minLength": 1
                },
                "generation": {
                  "type": "number"
                },
                "ownership": {
                  "type": "string",
                  "enum": ["unmanaged", "file-managed"]
                }
              },
              "required": ["id"],
              "additionalProperties": false
            },
            "spec": {
              "type": "object",
              "properties": {
                "name": {
                  "default": "EUDIPLO",
                  "description": "Display name of the tenant.",
                  "type": "string",
                  "minLength": 1
                },
                "description": {
                  "description": "Optional tenant description.",
                  "type": "string",
                  "minLength": 1
                },
                "sessionConfig": {
                  "description": "Optional tenant-specific session storage configuration.",
                  "type": "object",
                  "properties": {
                    "ttlSeconds": {
                      "description": "Session time-to-live in seconds.",
                      "type": "integer",
                      "minimum": 60,
                      "maximum": 9007199254740991
                    },
                    "cleanupMode": {
                      "description": "Whether to fully delete or anonymize expired sessions.",
                      "type": "string",
                      "enum": ["full", "anonymize"]
                    }
                  },
                  "additionalProperties": false
                },
                "statusListConfig": {
                  "description": "Optional tenant-specific status list defaults.",
                  "type": "object",
                  "properties": {
                    "capacity": {
                      "description": "Default status list capacity.",
                      "type": "integer",
                      "minimum": 100,
                      "maximum": 9007199254740991
                    },
                    "bits": {
                      "description": "Bits-per-status setting (1, 2, 4, or 8).",
                      "anyOf": [
                        {
                          "type": "number",
                          "const": 1
                        },
                        {
                          "type": "number",
                          "const": 2
                        },
                        {
                          "type": "number",
                          "const": 4
                        },
                        {
                          "type": "number",
                          "const": 8
                        }
                      ]
                    },
                    "ttl": {
                      "description": "JWT TTL for status list tokens in seconds.",
                      "type": "integer",
                      "minimum": 60,
                      "maximum": 9007199254740991
                    },
                    "immediateUpdate": {
                      "description": "Regenerate status list JWTs immediately after status updates.",
                      "type": "boolean"
                    },
                    "enableAggregation": {
                      "description": "Include aggregation_uri in generated status list JWTs.",
                      "type": "boolean"
                    }
                  },
                  "additionalProperties": false
                }
              },
              "required": ["name"],
              "additionalProperties": false,
              "description": "Payload used when importing tenant metadata from config files."
            }
          },
          "required": ["apiVersion", "kind", "metadata", "spec"],
          "additionalProperties": false
        }
      ],
      "$id": "./TenantConfigFile.schema.json",
      "title": "TenantConfigFile"
    }
  },
  {
    "uri": "./TransactionData.schema.json",
    "fileMatch": ["a://b/TransactionData*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "description": "Transaction data type identifier."
        },
        "credential_ids": {
          "type": "array",
          "items": {
            "type": "string"
          },
          "description": "Credential query ids this transaction data applies to."
        }
      },
      "required": ["type", "credential_ids"],
      "additionalProperties": {},
      "$id": "./TransactionData.schema.json",
      "title": "TransactionData"
    }
  },
  {
    "uri": "./TrustListCreateDto.schema.json",
    "fileMatch": ["a://b/TrustListCreateDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "id": {
          "description": "Optional trust list id. If omitted, one may be generated.",
          "type": "string",
          "minLength": 1
        },
        "description": {
          "description": "Optional trust list description.",
          "type": "string"
        },
        "keyChainId": {
          "description": "Optional key chain id used to sign trust list payloads.",
          "type": "string",
          "minLength": 1
        },
        "entities": {
          "minItems": 1,
          "type": "array",
          "items": {
            "oneOf": [
              {
                "type": "object",
                "properties": {
                  "type": {
                    "type": "string",
                    "const": "internal",
                    "description": "Use locally managed key chains for trust material."
                  },
                  "issuerKeyChainId": {
                    "type": "string",
                    "minLength": 1,
                    "description": "Key chain id for issuer certificate material."
                  },
                  "revocationKeyChainId": {
                    "type": "string",
                    "minLength": 1,
                    "description": "Key chain id for revocation/status list certificate material."
                  },
                  "info": {
                    "type": "object",
                    "properties": {
                      "name": {
                        "type": "string",
                        "minLength": 1,
                        "description": "Display name of the trusted entity."
                      },
                      "lang": {
                        "description": "Optional language tag for entity info.",
                        "type": "string"
                      },
                      "locale": {
                        "description": "Optional locale identifier.",
                        "type": "string"
                      },
                      "uri": {
                        "description": "Optional entity URI.",
                        "type": "string"
                      },
                      "country": {
                        "description": "Optional country name or code.",
                        "type": "string"
                      },
                      "locality": {
                        "description": "Optional locality or city.",
                        "type": "string"
                      },
                      "postalCode": {
                        "description": "Optional postal code.",
                        "type": "string"
                      },
                      "streetAddress": {
                        "description": "Optional street address.",
                        "type": "string"
                      },
                      "contactUri": {
                        "description": "Optional contact URI for the entity.",
                        "type": "string"
                      }
                    },
                    "required": ["name"],
                    "additionalProperties": false,
                    "description": "Entity metadata."
                  }
                },
                "required": ["type", "issuerKeyChainId", "revocationKeyChainId", "info"],
                "additionalProperties": false
              },
              {
                "type": "object",
                "properties": {
                  "type": {
                    "type": "string",
                    "const": "external",
                    "description": "Provide external PEM certificates directly."
                  },
                  "issuerCertPem": {
                    "type": "string",
                    "minLength": 1,
                    "description": "Issuer certificate in PEM format."
                  },
                  "revocationCertPem": {
                    "type": "string",
                    "minLength": 1,
                    "description": "Revocation/status certificate in PEM format."
                  },
                  "info": {
                    "type": "object",
                    "properties": {
                      "name": {
                        "type": "string",
                        "minLength": 1,
                        "description": "Display name of the trusted entity."
                      },
                      "lang": {
                        "description": "Optional language tag for entity info.",
                        "type": "string"
                      },
                      "locale": {
                        "description": "Optional locale identifier.",
                        "type": "string"
                      },
                      "uri": {
                        "description": "Optional entity URI.",
                        "type": "string"
                      },
                      "country": {
                        "description": "Optional country name or code.",
                        "type": "string"
                      },
                      "locality": {
                        "description": "Optional locality or city.",
                        "type": "string"
                      },
                      "postalCode": {
                        "description": "Optional postal code.",
                        "type": "string"
                      },
                      "streetAddress": {
                        "description": "Optional street address.",
                        "type": "string"
                      },
                      "contactUri": {
                        "description": "Optional contact URI for the entity.",
                        "type": "string"
                      }
                    },
                    "required": ["name"],
                    "additionalProperties": false,
                    "description": "Entity metadata."
                  }
                },
                "required": ["type", "issuerCertPem", "revocationCertPem", "info"],
                "additionalProperties": false
              }
            ]
          },
          "description": "One or more entities included in this trust list."
        },
        "data": {
          "description": "Optional additional custom payload data.",
          "type": "object",
          "propertyNames": {
            "type": "string"
          },
          "additionalProperties": {}
        }
      },
      "required": ["entities"],
      "additionalProperties": false,
      "$id": "./TrustListCreateDto.schema.json",
      "title": "TrustListCreateDto"
    }
  },
  {
    "uri": "./UpdateAttributeProviderDto.schema.json",
    "fileMatch": ["a://b/UpdateAttributeProviderDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "minLength": 1,
          "description": "Unique attribute provider identifier."
        },
        "name": {
          "type": "string",
          "minLength": 1,
          "description": "Display name of the attribute provider."
        },
        "description": {
          "anyOf": [
            {
              "type": "string",
              "minLength": 1
            },
            {
              "type": "null"
            }
          ],
          "description": "Optional attribute provider description."
        },
        "url": {
          "type": "string",
          "format": "uri",
          "description": "Base URL of the attribute provider endpoint."
        },
        "auth": {
          "oneOf": [
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "const": "none",
                  "description": "Disable authentication for attribute provider calls."
                }
              },
              "required": ["type"],
              "additionalProperties": false,
              "description": "No authentication variant."
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "const": "apiKey",
                  "description": "Use API key authentication."
                },
                "config": {
                  "type": "object",
                  "properties": {
                    "headerName": {
                      "type": "string",
                      "minLength": 1,
                      "description": "HTTP header name carrying the API key."
                    },
                    "value": {
                      "type": "string",
                      "minLength": 1,
                      "description": "API key value."
                    }
                  },
                  "required": ["headerName", "value"],
                  "additionalProperties": false,
                  "description": "API key authentication settings."
                }
              },
              "required": ["type", "config"],
              "additionalProperties": false,
              "description": "API key authentication variant."
            }
          ],
          "description": "Authentication configuration for outbound provider requests."
        }
      },
      "additionalProperties": false,
      "$id": "./UpdateAttributeProviderDto.schema.json",
      "title": "UpdateAttributeProviderDto"
    }
  },
  {
    "uri": "./UpdateClientDto.schema.json",
    "fileMatch": ["a://b/UpdateClientDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "description": {
          "description": "Optional updated description.",
          "type": "string",
          "minLength": 1
        },
        "roles": {
          "description": "Optional replacement roles for the client.",
          "minItems": 1,
          "type": "array",
          "items": {
            "type": "string",
            "enum": [
              "presentation:manage",
              "presentation:request",
              "issuance:manage",
              "issuance:offer",
              "clients:manage",
              "users:manage",
              "tenants:manage",
              "tenant:admin",
              "registrar:manage"
            ]
          }
        },
        "allowedPresentationConfigs": {
          "description": "Optional replacement allow-list of presentation config ids.",
          "anyOf": [
            {
              "type": "array",
              "items": {
                "type": "string",
                "minLength": 1
              }
            },
            {
              "type": "null"
            }
          ]
        },
        "allowedIssuanceConfigs": {
          "description": "Optional replacement allow-list of issuance config ids.",
          "anyOf": [
            {
              "type": "array",
              "items": {
                "type": "string",
                "minLength": 1
              }
            },
            {
              "type": "null"
            }
          ]
        }
      },
      "additionalProperties": false,
      "$id": "./UpdateClientDto.schema.json",
      "title": "UpdateClientDto"
    }
  },
  {
    "uri": "./UpdateStatusListConfigDto.schema.json",
    "fileMatch": ["a://b/UpdateStatusListConfigDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "capacity": {
          "description": "Capacity override. Set null to reset to defaults.",
          "anyOf": [
            {
              "type": "integer",
              "minimum": 100,
              "maximum": 9007199254740991
            },
            {
              "type": "null"
            }
          ]
        },
        "bits": {
          "description": "Bits-per-status override. Set null to reset to defaults.",
          "anyOf": [
            {
              "anyOf": [
                {
                  "type": "number",
                  "const": 1
                },
                {
                  "type": "number",
                  "const": 2
                },
                {
                  "type": "number",
                  "const": 4
                },
                {
                  "type": "number",
                  "const": 8
                }
              ]
            },
            {
              "type": "null"
            }
          ]
        },
        "ttl": {
          "description": "JWT TTL override in seconds. Set null to reset.",
          "anyOf": [
            {
              "type": "integer",
              "minimum": 60,
              "maximum": 9007199254740991
            },
            {
              "type": "null"
            }
          ]
        },
        "immediateUpdate": {
          "description": "Immediate regeneration toggle. Set null to reset.",
          "anyOf": [
            {
              "type": "boolean"
            },
            {
              "type": "null"
            }
          ]
        },
        "enableAggregation": {
          "description": "Aggregation URI toggle. Set null to reset.",
          "anyOf": [
            {
              "type": "boolean"
            },
            {
              "type": "null"
            }
          ]
        }
      },
      "additionalProperties": false,
      "$id": "./UpdateStatusListConfigDto.schema.json",
      "title": "UpdateStatusListConfigDto"
    }
  },
  {
    "uri": "./UpdateStatusListDto.schema.json",
    "fileMatch": ["a://b/UpdateStatusListDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "credentialConfigurationId": {
          "description": "Updated credential configuration binding. Null means shared list.",
          "anyOf": [
            {
              "type": "string",
              "minLength": 1
            },
            {
              "type": "null"
            }
          ]
        },
        "keyChainId": {
          "description": "Updated key chain id. Null means use tenant default.",
          "anyOf": [
            {
              "type": "string",
              "minLength": 1
            },
            {
              "type": "null"
            }
          ]
        }
      },
      "additionalProperties": false,
      "$id": "./UpdateStatusListDto.schema.json",
      "title": "UpdateStatusListDto"
    }
  },
  {
    "uri": "./UpdateTenantDto.schema.json",
    "fileMatch": ["a://b/UpdateTenantDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "name": {
          "description": "Display name of the tenant.",
          "type": "string",
          "minLength": 1
        },
        "description": {
          "description": "Tenant description. Omit to keep the current value or set to null to remove it.",
          "anyOf": [
            {
              "type": "string",
              "minLength": 1
            },
            {
              "type": "null"
            }
          ]
        },
        "sessionConfig": {
          "description": "Optional tenant-specific session storage configuration.",
          "type": "object",
          "properties": {
            "ttlSeconds": {
              "description": "Session time-to-live in seconds.",
              "type": "integer",
              "minimum": 60,
              "maximum": 9007199254740991
            },
            "cleanupMode": {
              "description": "Whether to fully delete or anonymize expired sessions.",
              "type": "string",
              "enum": ["full", "anonymize"]
            }
          },
          "additionalProperties": false
        },
        "statusListConfig": {
          "description": "Optional tenant-specific status list defaults.",
          "type": "object",
          "properties": {
            "capacity": {
              "description": "Default status list capacity.",
              "type": "integer",
              "minimum": 100,
              "maximum": 9007199254740991
            },
            "bits": {
              "description": "Bits-per-status setting (1, 2, 4, or 8).",
              "anyOf": [
                {
                  "type": "number",
                  "const": 1
                },
                {
                  "type": "number",
                  "const": 2
                },
                {
                  "type": "number",
                  "const": 4
                },
                {
                  "type": "number",
                  "const": 8
                }
              ]
            },
            "ttl": {
              "description": "JWT TTL for status list tokens in seconds.",
              "type": "integer",
              "minimum": 60,
              "maximum": 9007199254740991
            },
            "immediateUpdate": {
              "description": "Regenerate status list JWTs immediately after status updates.",
              "type": "boolean"
            },
            "enableAggregation": {
              "description": "Include aggregation_uri in generated status list JWTs.",
              "type": "boolean"
            }
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false,
      "description": "Payload for partially updating tenant metadata.",
      "$id": "./UpdateTenantDto.schema.json",
      "title": "UpdateTenantDto"
    }
  },
  {
    "uri": "./UpdateWebhookEndpointDto.schema.json",
    "fileMatch": ["a://b/UpdateWebhookEndpointDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "minLength": 1,
          "description": "Unique webhook endpoint identifier."
        },
        "name": {
          "type": "string",
          "minLength": 1,
          "description": "Display name of the webhook endpoint."
        },
        "description": {
          "anyOf": [
            {
              "type": "string",
              "minLength": 1
            },
            {
              "type": "null"
            }
          ],
          "description": "Optional webhook endpoint description."
        },
        "url": {
          "type": "string",
          "format": "uri",
          "description": "Destination URL for webhook delivery."
        },
        "auth": {
          "oneOf": [
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "const": "none",
                  "description": "Disable webhook authentication."
                }
              },
              "required": ["type"],
              "additionalProperties": false,
              "description": "No webhook authentication variant."
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "const": "apiKey",
                  "description": "Use API key authentication for webhook requests."
                },
                "config": {
                  "type": "object",
                  "properties": {
                    "headerName": {
                      "type": "string",
                      "minLength": 1,
                      "description": "HTTP header name for the API key."
                    },
                    "value": {
                      "type": "string",
                      "minLength": 1,
                      "description": "API key value sent with webhook requests."
                    }
                  },
                  "required": ["headerName", "value"],
                  "additionalProperties": false,
                  "description": "API key webhook authentication settings."
                }
              },
              "required": ["type", "config"],
              "additionalProperties": false,
              "description": "API key webhook authentication variant."
            }
          ],
          "description": "Authentication configuration applied to outgoing webhook requests."
        }
      },
      "additionalProperties": false,
      "$id": "./UpdateWebhookEndpointDto.schema.json",
      "title": "UpdateWebhookEndpointDto"
    }
  },
  {
    "uri": "./VCT.schema.json",
    "fileMatch": ["a://b/VCT*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "vct": {
          "description": "VCT identifier.",
          "type": "string"
        },
        "name": {
          "description": "Human-readable VCT name.",
          "type": "string"
        },
        "description": {
          "description": "Optional VCT description.",
          "type": "string"
        },
        "extends": {
          "description": "Optional base VCT reference.",
          "type": "string"
        },
        "extends#integrity": {
          "description": "Integrity hash for the extends reference.",
          "type": "string"
        },
        "schema_uri": {
          "description": "Optional schema URI for the VCT.",
          "type": "string"
        },
        "schema_uri#integrity": {
          "description": "Integrity hash for schema_uri.",
          "type": "string"
        }
      },
      "additionalProperties": false,
      "$id": "./VCT.schema.json",
      "title": "VCT"
    }
  },
  {
    "uri": "./WebhookConfig.schema.json",
    "fileMatch": ["a://b/WebhookConfig*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "url": {
          "type": "string",
          "minLength": 1,
          "description": "The URL to which the webhook will send notifications."
        },
        "auth": {
          "oneOf": [
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "const": "none",
                  "description": "Disable authentication."
                }
              },
              "required": ["type"],
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "const": "apiKey",
                  "description": "Use API key authentication."
                },
                "config": {
                  "type": "object",
                  "properties": {
                    "headerName": {
                      "type": "string",
                      "minLength": 1,
                      "description": "The header name used to send the API key."
                    },
                    "value": {
                      "type": "string",
                      "minLength": 1,
                      "description": "The API key value."
                    }
                  },
                  "required": ["headerName", "value"],
                  "additionalProperties": false,
                  "description": "API key authentication settings."
                }
              },
              "required": ["type", "config"],
              "additionalProperties": false
            }
          ],
          "description": "Webhook authentication strategy."
        },
        "includeRawTokensFor": {
          "description": "List of credential IDs to include raw tokens for (for example ['sca_credential']).",
          "type": "array",
          "items": {
            "type": "string"
          }
        }
      },
      "required": ["url", "auth"],
      "additionalProperties": false,
      "$id": "./WebhookConfig.schema.json",
      "title": "WebhookConfig"
    }
  }
]
